
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8HVLq", function(module, exports) {

var $aZWa4 = parcelRequire("aZWa4");

var $exJyI = parcelRequire("exJyI");

var $jKtCD = parcelRequire("jKtCD");
(0, $aZWa4.retrieveAndSetPageLoadTrace)((0, $exJyI.default));
(0, $jKtCD.fetchIssueData)(window);

});
parcelRegister("aZWa4", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $b515f2bc55199ff5$export$1a71d2bbe236de99);

var $tcn7E = parcelRequire("tcn7E");
let $b515f2bc55199ff5$var$alreadySet = false;
const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $b515f2bc55199ff5$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $b515f2bc55199ff5$var$alreadySet = true;
    (0, $tcn7E.setActiveTrace)(traceId, spanId, 'page_load');
};

});
parcelRegister("tcn7E", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $e9d8d7e26b2e602d$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $e9d8d7e26b2e602d$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $e9d8d7e26b2e602d$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $e9d8d7e26b2e602d$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $e9d8d7e26b2e602d$export$6e17cce6446848f9);

var $nfArY = parcelRequire("nfArY");
const $e9d8d7e26b2e602d$var$state = {
    context: null
};
function $e9d8d7e26b2e602d$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $e9d8d7e26b2e602d$export$f2e521e495a88544(interactionId, experienceType) {
    $e9d8d7e26b2e602d$export$a1002be327997103(interactionId.replace(/-/g, ''), $e9d8d7e26b2e602d$export$295213bc4d0c54ad(), experienceType);
}
function $e9d8d7e26b2e602d$export$a1002be327997103(traceId, spanId, type) {
    $e9d8d7e26b2e602d$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $e9d8d7e26b2e602d$export$b6ac780db3a3cc77() {
    return $e9d8d7e26b2e602d$var$state.context || undefined;
}
function $e9d8d7e26b2e602d$export$17ab21d7be720b() {
    $e9d8d7e26b2e602d$var$state.context = null;
}
function $e9d8d7e26b2e602d$export$6e17cce6446848f9(_url) {
    if ($e9d8d7e26b2e602d$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $e9d8d7e26b2e602d$var$state.context;
    return (0, $nfArY.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $e9d8d7e26b2e602d$export$a1e7396778592551(_url) {
    const traceHeaders = $e9d8d7e26b2e602d$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("nfArY", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $ab54be471bba623c$export$1115c5277eb10d5e);
function $ab54be471bba623c$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});



parcelRegister("exJyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2b7554a8f38d81$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $fe2b7554a8f38d81$export$2e2bcd8739ae039 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});

parcelRegister("jKtCD", function(module, exports) {

$parcel$export(module.exports, "fetchIssueData", () => $841dc2f73c6ba1d9$export$a4b3e9c5c73e29c2);
/* eslint-disable no-param-reassign */ 
var $3Mzpf = parcelRequire("3Mzpf");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $jxAdw = parcelRequire("jxAdw");

var $fV0e4 = parcelRequire("fV0e4");

var $bYZwm = parcelRequire("bYZwm");

var $exJyI = parcelRequire("exJyI");
const $841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY = 'ISSUE_GIRA_DATA';
const $841dc2f73c6ba1d9$var$EARLY_FETCH_AGG_KEY = 'ISSUE_AGG_DATA';
const $841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_NON_CRITICAL = 'ISSUE_GIRA_NON_CRITICAL_DATA';
// From strip-url-to-issue-key
const $841dc2f73c6ba1d9$var$ISSUE_KEY_REGEXP = /(([A-Z0-9][A-Z0-9_]+)-([0-9]+))($|[?|#].*|\/embed)/;
const $841dc2f73c6ba1d9$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($841dc2f73c6ba1d9$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $841dc2f73c6ba1d9$export$a4b3e9c5c73e29c2 = (win)=>{
    if ((0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false)) return;
    const { fetch: fetch, location: location } = win;
    if (!fetch) return;
    const { pathname: pathname, href: href } = location;
    if (!/^\/browse\/(?:\w+-\d+)/.test(pathname)) return;
    const issueKey = $841dc2f73c6ba1d9$export$1f3c6284caef177b(href);
    if (issueKey === null || issueKey === undefined) return;
    const projectKey = issueKey != null ? issueKey.split('-')[0] : '';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    // While falling back, certain document events are fired before this scripts is ran,
    // This causes certain functionality to break. We're setting a __SSR_FALLBACK__ to true when falling back.
    // This allows us to disable certain functionality that relies on document events and requires SSR to begin with.
    const isSsrFallback = globalVar?.__SSR_FALLBACK__ === true;
    performance.mark('issueViewEarlyScripts:clientRequestStart');
    performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY}:clientRequestStart`);
    if (!isSsrFallback && (0, $4R6GH.fg)('jira-bifrost-template-early-gql-fetch-master')) {
        const issueGiraDataPromise = (0, $fV0e4.getGiraDataFromInitialPageResponse)().catch(()=>{
            performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY}:getFromInitialPageFailed`);
            return (0, $fV0e4.fetchIssueGiraData)('', issueKey, projectKey);
        });
        issueGiraDataPromise.then(()=>performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY}:getFromInitialPageEnd`));
        win[$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY] = issueGiraDataPromise;
    } else {
        const issueGiraDataPromise = (0, $fV0e4.fetchIssueGiraData)('', issueKey, projectKey);
        issueGiraDataPromise.then(()=>performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY}:getFromNetworkEnd`));
        win[$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY] = issueGiraDataPromise;
    }
    performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_KEY}:clientRequestEnd`);
    performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_AGG_KEY}:clientRequestStart`);
    const cloudId = (0, $exJyI.default)('ajs-cloud-id') || '';
    const siteAri = (0, $3Mzpf.JiraSiteAri).create({
        siteId: cloudId
    }).toString();
    if (!isSsrFallback && (0, $4R6GH.fg)('jira-bifrost-template-early-gql-fetch-master')) {
        const issueAggDataPromise = (0, $jxAdw.getAggDataFromInitialPageResponse)().catch(()=>{
            performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_AGG_KEY}:getFromInitialPageFailed`);
            // can't use fetchIssueRelayData here otherwise there will be a race to set the same promise map
            return (0, $jxAdw.fetchIssueAggData)(issueKey, cloudId, siteAri);
        });
        issueAggDataPromise.then(()=>{
            performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_AGG_KEY}:getFromInitialPageEnd`);
        });
        (0, $jxAdw.fetchIssueRelayDataViaDelegate)(issueKey, cloudId, siteAri, issueAggDataPromise);
    } else (0, $jxAdw.fetchIssueRelayData)(issueKey, cloudId, siteAri);
    performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_AGG_KEY}:clientRequestEnd`);
    if (!(0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path')) {
        performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_NON_CRITICAL}:clientRequestStart`);
        const issueGiraNonCriticalDataPromise = (0, $bYZwm.fetchIssueGiraNonCriticalData)(issueKey);
        issueGiraNonCriticalDataPromise.then(()=>performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_NON_CRITICAL}:getFromNetworkEnd`));
        win[$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_NON_CRITICAL] = issueGiraNonCriticalDataPromise;
        performance.mark(`issueViewEarlyScripts:${$841dc2f73c6ba1d9$var$EARLY_FETCH_GIRA_NON_CRITICAL}:clientRequestEnd`);
    }
    performance.mark('issueViewEarlyScripts:clientRequestEnd');
};

});
parcelRegister("3Mzpf", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $2c1151bb17cb172c$export$6c0f81f222d09301);

var $gQC3n = parcelRequire("gQC3n");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/site/manifest.ts
var $2c1151bb17cb172c$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gQC3n.JiraSiteAriResourceOwner),
    resourceType: (0, $gQC3n.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $2c1151bb17cb172c$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("gQC3n", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $032a4e897fcecef5$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $032a4e897fcecef5$export$886165a991f21644);
// src/jira/site/types.ts
var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";

});

parcelRegister("9KGzW", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $71997031dd676429$export$579ee78b1dcf0a11);

var $1Jl81 = parcelRequire("1Jl81");
// src/core/registered-ari.ts
var $71997031dd676429$export$579ee78b1dcf0a11 = class extends (0, $1Jl81.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $1Jl81.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("1Jl81", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $142a620f899fb689$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $142a620f899fb689$export$44a7af7122933d6b);

var $1C2Ux = parcelRequire("1C2Ux");
// src/core/ari.ts
var $142a620f899fb689$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $1C2Ux.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $142a620f899fb689$export$44a7af7122933d6b = class _AnyAri extends $142a620f899fb689$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $1C2Ux.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $1C2Ux.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("1C2Ux", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $12cb9916f0aaeeed$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $12cb9916f0aaeeed$export$ab4b293d0121b8ee);

var $fo7u7 = parcelRequire("fo7u7");

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/cloud-id.ts
function $12cb9916f0aaeeed$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $ed4UU.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $12cb9916f0aaeeed$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $ed4UU.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $12cb9916f0aaeeed$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $12cb9916f0aaeeed$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $ed4UU.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $12cb9916f0aaeeed$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $ed4UU.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS = 5, $12cb9916f0aaeeed$export$4c3a8cde7a55740b = class extends (0, $fo7u7.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $fo7u7.validateAriQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $ed4UU.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $ed4UU.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS = 4, $12cb9916f0aaeeed$var$AtiParser = class extends (0, $fo7u7.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $12cb9916f0aaeeed$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $12cb9916f0aaeeed$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("fo7u7", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $b33ee73cfb749d69$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $b33ee73cfb749d69$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $b33ee73cfb749d69$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $b33ee73cfb749d69$export$3d09a5c28ff3e040);

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/platform-qualifier.ts
function $b33ee73cfb749d69$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $ed4UU.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $b33ee73cfb749d69$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $ed4UU.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $ed4UU.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $ed4UU.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS = 5, $b33ee73cfb749d69$var$SEGMENT_SEPARATOR = ":", $b33ee73cfb749d69$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($b33ee73cfb749d69$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $ed4UU.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($b33ee73cfb749d69$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("ed4UU", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $a58617fff8cdca9e$export$2191b9da168c6cf0);
// src/errors.ts
var $a58617fff8cdca9e$export$2191b9da168c6cf0 = class extends Error {
};

});






parcelRegister("6s1PB", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $d0d3e1363a65fa96$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $d0d3e1363a65fa96$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $d0d3e1363a65fa96$export$677f9fa2e1ae6fec);
/* eslint-disable max-classes-per-file */ 
var $iEN9D = parcelRequire("iEN9D");

var $gSA3s = parcelRequire("gSA3s");

var $40Gox = parcelRequire("40Gox");

var $aMh57 = parcelRequire("aMh57");
class $d0d3e1363a65fa96$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // 1 - checkIfExperimentExists
            // 2 - a caller
            this.stack = [
                ...stackLines.slice(2)
            ].join('\n');
        }
    }
}
const $d0d3e1363a65fa96$var$checkedExperiments = new Set();
const $d0d3e1363a65fa96$var$checkIfExperimentExists = (experimentName)=>{
    // perform early exist to minimize performance impact
    if ($d0d3e1363a65fa96$var$checkedExperiments.has(experimentName)) return;
    $d0d3e1363a65fa96$var$checkedExperiments.add(experimentName);
    if ((0, $iEN9D.default).checkGate('jfp_magma_jira-report-incorrect-experiments', {
        fireGateExposure: false
    })) {
        if (!(0, $iEN9D.default).isExperimentExists(experimentName)) {
            const error = new $d0d3e1363a65fa96$var$ErrorPointingUp(`Experiment ${experimentName} does not exist`);
            (0, $aMh57.captureException)('FeatureGates.isExperimentExists', error);
            // eslint-disable-next-line no-console
            console.error(`Experiment ${experimentName} does not exist`);
        }
    }
};
function $d0d3e1363a65fa96$var$readExpVal(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $iEN9D.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $gSA3s.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    const experiment = $d0d3e1363a65fa96$var$readExpVal(experimentName, param, defaultValue);
    $d0d3e1363a65fa96$var$checkIfExperimentExists(experimentName);
    return experiment;
}
function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue, defaultValue = null) {
    const experiment = $d0d3e1363a65fa96$var$readExpVal(experimentName, param, defaultValue);
    $d0d3e1363a65fa96$var$checkIfExperimentExists(experimentName);
    return experiment === comparatorValue;
}
class $d0d3e1363a65fa96$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
            const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $gSA3s.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gSA3s.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $d0d3e1363a65fa96$var$cache = new Map();
function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
    const fireExposure = ()=>(0, $iEN9D.default).manuallyLogExperimentExposure(experimentName);
    if (instance == null) {
        (0, $40Gox.UNSAFE_initIfNeeded)();
        const config = (0, $iEN9D.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        instance = [
            new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
    }
    return instance;
}

});
parcelRegister("iEN9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $35b5264e002d74be$export$2e2bcd8739ae039);

var $BptNL = parcelRequire("BptNL");

var $i9mLs = parcelRequire("i9mLs");



var $8ruqY = parcelRequire("8ruqY");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $35b5264e002d74be$var$FeatureGates {
    static{
        this.client = new (0, $BptNL.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$35b5264e002d74be$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $35b5264e002d74be$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$35b5264e002d74be$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $35b5264e002d74be$var$boundFGJS = $35b5264e002d74be$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $35b5264e002d74be$var$FeatureGates;
    else {
        $35b5264e002d74be$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $35b5264e002d74be$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $i9mLs.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $i9mLs.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $35b5264e002d74be$export$2e2bcd8739ae039 = $35b5264e002d74be$var$boundFGJS;

});
parcelRegister("BptNL", function(module, exports) {

$parcel$export(module.exports, "Client", () => $f5725ccebe8e2f70$export$1f2bb630327ac4b6);

var $1Nxtn = parcelRequire("1Nxtn");

var $9Pvqq = parcelRequire("9Pvqq");

var $hMFzK = parcelRequire("hMFzK");

var $9DDUe = parcelRequire("9DDUe");

var $6jK44 = parcelRequire("6jK44");

var $1VtdU = parcelRequire("1VtdU");

var $l4hNL = parcelRequire("l4hNL");

var $5b5vX = parcelRequire("5b5vX");

var $8ruqY = parcelRequire("8ruqY");

var $GWCtt = parcelRequire("GWCtt");

var $i9mLs = parcelRequire("i9mLs");
const $f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $f5725ccebe8e2f70$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $f5725ccebe8e2f70$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $5b5vX.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $9Pvqq.default)();
        this.dataAdapter = new (0, $l4hNL.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $5b5vX.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $i9mLs.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $i9mLs.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $8ruqY.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $GWCtt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $GWCtt.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $1VtdU.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $hMFzK.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $hMFzK.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $6jK44.EvaluationReason).Error
            });
        }
    }
    /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ isCurrentUser(identifiers, customAttributes) {
        return (0, $GWCtt.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $GWCtt.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $1VtdU.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $1VtdU.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $GWCtt.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $f5725ccebe8e2f70$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.sdkKey = sdkKey;
        this.user = (0, $GWCtt.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter
        };
        try {
            this.statsigClient = new (0, $1Nxtn.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $1Nxtn.StatsigClient)($f5725ccebe8e2f70$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $GWCtt.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ getPackageVersion() {
        return 0, $i9mLs.CLIENT_VERSION;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $9DDUe.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $9DDUe.Layer).fromLayer((0, $1Nxtn._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("1Nxtn", function(module, exports) {
"use strict";
var $14f4550c94fd1c44$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14f4550c94fd1c44$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $14f4550c94fd1c44$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;

var $b9ZdZ = parcelRequire("b9ZdZ");
module.exports.StatsigClient = $b9ZdZ.default;

$14f4550c94fd1c44$var$__exportStar((parcelRequire("10Gqk")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    StatsigClient: $b9ZdZ.default
});
module.exports.default = __STATSIG__;

});
parcelRegister("b9ZdZ", function(module, exports) {
"use strict";
var $820006e6093ad8b3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10Gqk = parcelRequire("10Gqk");

var $kY5TA = parcelRequire("kY5TA");

var $4m0mJ = parcelRequire("4m0mJ");

var $lsG6u = parcelRequire("lsG6u");

var $krRcT = parcelRequire("krRcT");
class $820006e6093ad8b3$var$StatsigClient extends $10Gqk.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $10Gqk._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $820006e6093ad8b3$var$StatsigClient) return instance;
        $10Gqk.Log.warn((0, $10Gqk._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $820006e6093ad8b3$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $10Gqk.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $4m0mJ.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $krRcT.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($10Gqk.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($10Gqk.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($10Gqk.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($10Gqk.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($10Gqk.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $kY5TA.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $10Gqk.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $820006e6093ad8b3$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $10Gqk.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $10Gqk.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $820006e6093ad8b3$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $10Gqk.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $10Gqk.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $10Gqk.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $10Gqk.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($10Gqk.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $10Gqk.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $10Gqk.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $10Gqk.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $10Gqk.StatsigSession.get(this._sdkKey),
            stableID: $10Gqk.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $820006e6093ad8b3$var$__awaiter(this, void 0, void 0, function*() {
            if (!$10Gqk.Storage.isReady()) yield $10Gqk.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $10Gqk.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $10Gqk._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $10Gqk.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $10Gqk._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $10Gqk._createGateExposure)(this._user, result), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $10Gqk._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $10Gqk._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $10Gqk._makeExperiment)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getExperimentOverride) === null || _b === void 0 ? void 0 : _b.call(_a, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $10Gqk._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $10Gqk._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $10Gqk._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $10Gqk._createLayerParameterExposure)(this._user, result, param), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        return {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $lsG6u._makeParamStoreGetter)(this, configuration, options)
        };
    }
}
module.exports.default = $820006e6093ad8b3$var$StatsigClient;

});
parcelRegister("10Gqk", function(module, exports) {
"use strict";
var $0bc6b2fd8e2f8939$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0bc6b2fd8e2f8939$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0bc6b2fd8e2f8939$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;


Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cLdPq")).Diagnostics;
    }
});

var $jPmF4 = parcelRequire("jPmF4");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $jPmF4.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("bWQcA")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6abDe")).Storage;
    }
});

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("dWN0S")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cKhdt")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("kvuMv")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("lTh7N")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cLdPq")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("3Ldy5")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("chIEM")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("jQTNP")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("4r2xR")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("iFJ4e")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("6gUK9")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("bWQcA")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("9ewyA")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("fcTTc")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("5oGx8")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("j5rLe")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("lHEph")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("41u1G")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("aufpK")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("i7IAl")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("kISM6")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("2EFwj")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("2hLV8")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("egTIF")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("c0FvX")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cOFsX")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("2av9q")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("ejscn")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cJCL7")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("jKP2H")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("dHfQC")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("6abDe")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("fAGEY")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("9nGbQ")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("9cY7K")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("4Pas4")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("LDu8c")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("b7bEu")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("CFdSR")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    Log: (parcelRequire("bWQcA")).Log,
    SDK_VERSION: (parcelRequire("cOFsX")).SDK_VERSION
});

});
parcelRegister("dWN0S", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $a276b61d30e1e400$var$_a, $a276b61d30e1e400$var$_b, $a276b61d30e1e400$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $bWQcA = parcelRequire("bWQcA");
const $a276b61d30e1e400$var$_getStatsigGlobal = ()=>{
    return __STATSIG__ ? __STATSIG__ : $a276b61d30e1e400$var$statsigGlobal;
};
module.exports._getStatsigGlobal = $a276b61d30e1e400$var$_getStatsigGlobal;
const $a276b61d30e1e400$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $a276b61d30e1e400$var$_getStatsigGlobalFlag;
const $a276b61d30e1e400$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $bWQcA.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $a276b61d30e1e400$var$_getInstance;
const $a276b61d30e1e400$var$GLOBAL_KEY = '__STATSIG__';
const $a276b61d30e1e400$var$_window = typeof window !== 'undefined' ? window : {};
const $a276b61d30e1e400$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $a276b61d30e1e400$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $a276b61d30e1e400$var$statsigGlobal = ($a276b61d30e1e400$var$_c = ($a276b61d30e1e400$var$_b = ($a276b61d30e1e400$var$_a = $a276b61d30e1e400$var$_window[$a276b61d30e1e400$var$GLOBAL_KEY]) !== null && $a276b61d30e1e400$var$_a !== void 0 ? $a276b61d30e1e400$var$_a : $a276b61d30e1e400$var$_global[$a276b61d30e1e400$var$GLOBAL_KEY]) !== null && $a276b61d30e1e400$var$_b !== void 0 ? $a276b61d30e1e400$var$_b : $a276b61d30e1e400$var$_globalThis[$a276b61d30e1e400$var$GLOBAL_KEY]) !== null && $a276b61d30e1e400$var$_c !== void 0 ? $a276b61d30e1e400$var$_c : {
    instance: module.exports._getInstance
};
$a276b61d30e1e400$var$_window[$a276b61d30e1e400$var$GLOBAL_KEY] = $a276b61d30e1e400$var$statsigGlobal;
$a276b61d30e1e400$var$_global[$a276b61d30e1e400$var$GLOBAL_KEY] = $a276b61d30e1e400$var$statsigGlobal;
$a276b61d30e1e400$var$_globalThis[$a276b61d30e1e400$var$GLOBAL_KEY] = $a276b61d30e1e400$var$statsigGlobal;

});
parcelRegister("bWQcA", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $8b2d9ab9bfd5eaf2$var$DEBUG = ' DEBUG ';
const $8b2d9ab9bfd5eaf2$var$_INFO = '  INFO ';
const $8b2d9ab9bfd5eaf2$var$_WARN = '  WARN ';
const $8b2d9ab9bfd5eaf2$var$ERROR = ' ERROR ';
function $8b2d9ab9bfd5eaf2$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $8b2d9ab9bfd5eaf2$var$Log {
    static info(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Info) console.info($8b2d9ab9bfd5eaf2$var$_INFO, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
    static debug(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Debug) console.debug($8b2d9ab9bfd5eaf2$var$DEBUG, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
    static warn(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Warn) console.warn($8b2d9ab9bfd5eaf2$var$_WARN, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
    static error(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Error) console.error($8b2d9ab9bfd5eaf2$var$ERROR, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
}
module.exports.Log = $8b2d9ab9bfd5eaf2$var$Log;
$8b2d9ab9bfd5eaf2$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("cLdPq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $94a499d7a6ebffae$var$MARKER_MAP = new Map();
const $94a499d7a6ebffae$var$ACT_START = 'start';
const $94a499d7a6ebffae$var$ACT_END = 'end';
const $94a499d7a6ebffae$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $94a499d7a6ebffae$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker({}, $94a499d7a6ebffae$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $94a499d7a6ebffae$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker(data, $94a499d7a6ebffae$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker(data, $94a499d7a6ebffae$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker({}, $94a499d7a6ebffae$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker(data, $94a499d7a6ebffae$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $94a499d7a6ebffae$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $94a499d7a6ebffae$var$_safeGetField(e, 'code'),
            name: $94a499d7a6ebffae$var$_safeGetField(e, 'name'),
            message: $94a499d7a6ebffae$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $94a499d7a6ebffae$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $94a499d7a6ebffae$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $94a499d7a6ebffae$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $94a499d7a6ebffae$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $94a499d7a6ebffae$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $94a499d7a6ebffae$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $94a499d7a6ebffae$var$MARKER_MAP.set(sdkKey, markers);
}
function $94a499d7a6ebffae$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("jPmF4", function(module, exports) {
"use strict";
var $e6f45bd75fd22a5d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $cKhdt = parcelRequire("cKhdt");

var $iFJ4e = parcelRequire("iFJ4e");

var $bWQcA = parcelRequire("bWQcA");

var $fcTTc = parcelRequire("fcTTc");

var $41u1G = parcelRequire("41u1G");

var $c0FvX = parcelRequire("c0FvX");

var $6abDe = parcelRequire("6abDe");

var $9cY7K = parcelRequire("9cY7K");

var $LDu8c = parcelRequire("LDu8c");
const $e6f45bd75fd22a5d$var$DEFAULT_QUEUE_SIZE = 100;
const $e6f45bd75fd22a5d$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $e6f45bd75fd22a5d$var$MAX_DEDUPER_KEYS = 1000;
const $e6f45bd75fd22a5d$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $e6f45bd75fd22a5d$var$MAX_FAILED_LOGS = 500;
const $e6f45bd75fd22a5d$var$QUICK_FLUSH_WINDOW_MS = 200;
const $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP = {};
const $e6f45bd75fd22a5d$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $e6f45bd75fd22a5d$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._isLoggingDisabled = (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true;
        this._maxQueueSize = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _a !== void 0 ? _a : $e6f45bd75fd22a5d$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $9cY7K.UrlConfiguration($fcTTc.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLoggingDisabled(isDisabled) {
        this._isLoggingDisabled = isDisabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        if ((0, $41u1G._isServerEnv)()) return; // do not run in server environments
        $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        (0, $LDu8c._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $e6f45bd75fd22a5d$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $e6f45bd75fd22a5d$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey), $e6f45bd75fd22a5d$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        if ((0, $41u1G._isServerEnv)()) return false; // do not run in server environments
        if (!(0, $c0FvX._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $cKhdt._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $e6f45bd75fd22a5d$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $e6f45bd75fd22a5d$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._isLoggingDisabled) {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $LDu8c._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $bWQcA.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $bWQcA.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$fcTTc.NetworkParam.EventCount]: String(events.length)
            }
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $e6f45bd75fd22a5d$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $6abDe._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $bWQcA.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
                if (!$6abDe.Storage.isReady()) yield $6abDe.Storage.isReadyResolver();
                const events = (0, $6abDe._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.Startup) $6abDe.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.GainedFocus) $6abDe.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $bWQcA.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $iFJ4e._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $bWQcA.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $41u1G._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $e6f45bd75fd22a5d$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $e6f45bd75fd22a5d$var$EventLogger;

});
parcelRegister("cKhdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $iFJ4e = parcelRequire("iFJ4e");
function $947722b3fa4f6609$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $iFJ4e._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $947722b3fa4f6609$var$_getUserStorageKey;
function $947722b3fa4f6609$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $947722b3fa4f6609$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $iFJ4e._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $947722b3fa4f6609$var$_getStorageKey;

});
parcelRegister("iFJ4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9nGbQ = parcelRequire("9nGbQ");
const $d97f03c19f6b4be6$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $d97f03c19f6b4be6$var$_DJB2;
const $d97f03c19f6b4be6$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $d97f03c19f6b4be6$var$_DJB2Object;
const $d97f03c19f6b4be6$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9nGbQ._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $d97f03c19f6b4be6$var$_getSortedObject;

});
parcelRegister("9nGbQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $6d46fd1d22276144$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $6d46fd1d22276144$var$_typeOf;
function $6d46fd1d22276144$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $6d46fd1d22276144$var$_isTypeMatch;

});



parcelRegister("fcTTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("41u1G", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $2ede8bff48d17c3f$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $2ede8bff48d17c3f$var$_getWindowSafe;
const $2ede8bff48d17c3f$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $2ede8bff48d17c3f$var$_getDocumentSafe;
const $2ede8bff48d17c3f$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $6cAn5 !== 'undefined' && $6cAn5.versions != null && $6cAn5.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $2ede8bff48d17c3f$var$_isServerEnv;
const $2ede8bff48d17c3f$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $2ede8bff48d17c3f$var$_addWindowEventListenerSafe;
const $2ede8bff48d17c3f$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $2ede8bff48d17c3f$var$_addDocumentEventListenerSafe;
const $2ede8bff48d17c3f$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $2ede8bff48d17c3f$var$_getCurrentPageUrlSafe;

});
parcelRegister("6cAn5", function(module, exports) {
// shim for using process in browser
var $484013ac3f8916ed$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $484013ac3f8916ed$var$cachedSetTimeout;
var $484013ac3f8916ed$var$cachedClearTimeout;
function $484013ac3f8916ed$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $484013ac3f8916ed$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $484013ac3f8916ed$var$cachedSetTimeout = setTimeout;
        else $484013ac3f8916ed$var$cachedSetTimeout = $484013ac3f8916ed$var$defaultSetTimout;
    } catch (e) {
        $484013ac3f8916ed$var$cachedSetTimeout = $484013ac3f8916ed$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $484013ac3f8916ed$var$cachedClearTimeout = clearTimeout;
        else $484013ac3f8916ed$var$cachedClearTimeout = $484013ac3f8916ed$var$defaultClearTimeout;
    } catch (e) {
        $484013ac3f8916ed$var$cachedClearTimeout = $484013ac3f8916ed$var$defaultClearTimeout;
    }
})();
function $484013ac3f8916ed$var$runTimeout(fun) {
    if ($484013ac3f8916ed$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($484013ac3f8916ed$var$cachedSetTimeout === $484013ac3f8916ed$var$defaultSetTimout || !$484013ac3f8916ed$var$cachedSetTimeout) && setTimeout) {
        $484013ac3f8916ed$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $484013ac3f8916ed$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $484013ac3f8916ed$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $484013ac3f8916ed$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $484013ac3f8916ed$var$runClearTimeout(marker) {
    if ($484013ac3f8916ed$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($484013ac3f8916ed$var$cachedClearTimeout === $484013ac3f8916ed$var$defaultClearTimeout || !$484013ac3f8916ed$var$cachedClearTimeout) && clearTimeout) {
        $484013ac3f8916ed$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $484013ac3f8916ed$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $484013ac3f8916ed$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $484013ac3f8916ed$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $484013ac3f8916ed$var$queue = [];
var $484013ac3f8916ed$var$draining = false;
var $484013ac3f8916ed$var$currentQueue;
var $484013ac3f8916ed$var$queueIndex = -1;
function $484013ac3f8916ed$var$cleanUpNextTick() {
    if (!$484013ac3f8916ed$var$draining || !$484013ac3f8916ed$var$currentQueue) return;
    $484013ac3f8916ed$var$draining = false;
    if ($484013ac3f8916ed$var$currentQueue.length) $484013ac3f8916ed$var$queue = $484013ac3f8916ed$var$currentQueue.concat($484013ac3f8916ed$var$queue);
    else $484013ac3f8916ed$var$queueIndex = -1;
    if ($484013ac3f8916ed$var$queue.length) $484013ac3f8916ed$var$drainQueue();
}
function $484013ac3f8916ed$var$drainQueue() {
    if ($484013ac3f8916ed$var$draining) return;
    var timeout = $484013ac3f8916ed$var$runTimeout($484013ac3f8916ed$var$cleanUpNextTick);
    $484013ac3f8916ed$var$draining = true;
    var len = $484013ac3f8916ed$var$queue.length;
    while(len){
        $484013ac3f8916ed$var$currentQueue = $484013ac3f8916ed$var$queue;
        $484013ac3f8916ed$var$queue = [];
        while(++$484013ac3f8916ed$var$queueIndex < len)if ($484013ac3f8916ed$var$currentQueue) $484013ac3f8916ed$var$currentQueue[$484013ac3f8916ed$var$queueIndex].run();
        $484013ac3f8916ed$var$queueIndex = -1;
        len = $484013ac3f8916ed$var$queue.length;
    }
    $484013ac3f8916ed$var$currentQueue = null;
    $484013ac3f8916ed$var$draining = false;
    $484013ac3f8916ed$var$runClearTimeout(timeout);
}
$484013ac3f8916ed$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $484013ac3f8916ed$var$queue.push(new $484013ac3f8916ed$var$Item(fun, args));
    if ($484013ac3f8916ed$var$queue.length === 1 && !$484013ac3f8916ed$var$draining) $484013ac3f8916ed$var$runTimeout($484013ac3f8916ed$var$drainQueue);
};
// v8 likes predictible objects
function $484013ac3f8916ed$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$484013ac3f8916ed$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$484013ac3f8916ed$var$process.title = 'browser';
$484013ac3f8916ed$var$process.browser = true;
$484013ac3f8916ed$var$process.env = {};
$484013ac3f8916ed$var$process.argv = [];
$484013ac3f8916ed$var$process.version = ''; // empty string to avoid regexp issues
$484013ac3f8916ed$var$process.versions = {};
function $484013ac3f8916ed$var$noop() {}
$484013ac3f8916ed$var$process.on = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.addListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.once = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.off = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.removeListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.removeAllListeners = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.emit = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.prependListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.prependOnceListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.listeners = function(name) {
    return [];
};
$484013ac3f8916ed$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$484013ac3f8916ed$var$process.cwd = function() {
    return '/';
};
$484013ac3f8916ed$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$484013ac3f8916ed$var$process.umask = function() {
    return 0;
};

});


parcelRegister("c0FvX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $8be5b000a996ae67$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $8be5b000a996ae67$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $8be5b000a996ae67$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $8be5b000a996ae67$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $8be5b000a996ae67$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $8be5b000a996ae67$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $8be5b000a996ae67$var$GATE_EXPOSURE_NAME || eventName === $8be5b000a996ae67$var$CONFIG_EXPOSURE_NAME || eventName === $8be5b000a996ae67$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $8be5b000a996ae67$var$_isExposureEvent;
const $8be5b000a996ae67$var$_createGateExposure = (user, gate)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $8be5b000a996ae67$var$_createExposure($8be5b000a996ae67$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, (_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : []);
};
module.exports._createGateExposure = $8be5b000a996ae67$var$_createGateExposure;
const $8be5b000a996ae67$var$_createConfigExposure = (user, config)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $8be5b000a996ae67$var$_createExposure($8be5b000a996ae67$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, (_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : []);
};
module.exports._createConfigExposure = $8be5b000a996ae67$var$_createConfigExposure;
const $8be5b000a996ae67$var$_createLayerParameterExposure = (user, layer, parameterName)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $8be5b000a996ae67$var$_createExposure($8be5b000a996ae67$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, secondaryExposures);
};
module.exports._createLayerParameterExposure = $8be5b000a996ae67$var$_createLayerParameterExposure;
const $8be5b000a996ae67$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("6abDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $41u1G = parcelRequire("41u1G");
const $47ccb314d7420b3b$var$inMemoryStore = {};
const $47ccb314d7420b3b$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$47ccb314d7420b3b$var$inMemoryStore[key] ? $47ccb314d7420b3b$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $47ccb314d7420b3b$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $47ccb314d7420b3b$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($47ccb314d7420b3b$var$inMemoryStore)
};
let $47ccb314d7420b3b$var$_localStorageProvider = null;
try {
    const win = (0, $41u1G._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $47ccb314d7420b3b$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $bWQcA.Log.warn('Failed to setup localStorageProvider.');
}
let $47ccb314d7420b3b$var$_main = $47ccb314d7420b3b$var$_localStorageProvider !== null && $47ccb314d7420b3b$var$_localStorageProvider !== void 0 ? $47ccb314d7420b3b$var$_localStorageProvider : $47ccb314d7420b3b$var$_inMemoryProvider;
let $47ccb314d7420b3b$var$_current = $47ccb314d7420b3b$var$_main;
function $47ccb314d7420b3b$var$_inMemoryBreaker(get) {
    try {
        return get();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($47ccb314d7420b3b$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$47ccb314d7420b3b$var$_current.isReady(),
    isReadyResolver: ()=>$47ccb314d7420b3b$var$_current.isReadyResolver(),
    getProviderName: ()=>$47ccb314d7420b3b$var$_current.getProviderName(),
    getItem: (key)=>$47ccb314d7420b3b$var$_inMemoryBreaker(()=>$47ccb314d7420b3b$var$_current.getItem(key)),
    setItem: (key, value)=>$47ccb314d7420b3b$var$_current.setItem(key, value),
    removeItem: (key)=>$47ccb314d7420b3b$var$_current.removeItem(key),
    getAllKeys: ()=>$47ccb314d7420b3b$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $47ccb314d7420b3b$var$_main = newProvider;
        $47ccb314d7420b3b$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $47ccb314d7420b3b$var$_current = $47ccb314d7420b3b$var$_inMemoryProvider;
        else $47ccb314d7420b3b$var$_current = $47ccb314d7420b3b$var$_main;
    }
};
function $47ccb314d7420b3b$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $47ccb314d7420b3b$var$_getObjectFromStorage;
function $47ccb314d7420b3b$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $47ccb314d7420b3b$var$_setObjectInStorage;

});

parcelRegister("9cY7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $fcTTc = parcelRequire("fcTTc");
const $6b43df6ee783ce73$var$ENDPOINT_DNS_KEY_MAP = {
    [$fcTTc.Endpoint._initialize]: 'i',
    [$fcTTc.Endpoint._rgstr]: 'e',
    [$fcTTc.Endpoint._download_config_specs]: 'd'
};
class $6b43df6ee783ce73$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $6b43df6ee783ce73$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $fcTTc.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
}
module.exports.UrlConfiguration = $6b43df6ee783ce73$var$UrlConfiguration;

});

parcelRegister("LDu8c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $41u1G = parcelRequire("41u1G");
const $08f304cbfc59140c$var$FOREGROUND = 'foreground';
const $08f304cbfc59140c$var$BACKGROUND = 'background';
const $08f304cbfc59140c$var$LISTENERS = [];
let $08f304cbfc59140c$var$current = $08f304cbfc59140c$var$FOREGROUND;
let $08f304cbfc59140c$var$isUnloading = false;
const $08f304cbfc59140c$var$_isCurrentlyVisible = ()=>{
    return $08f304cbfc59140c$var$current === $08f304cbfc59140c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $08f304cbfc59140c$var$_isCurrentlyVisible;
const $08f304cbfc59140c$var$_isUnloading = ()=>$08f304cbfc59140c$var$isUnloading;
module.exports._isUnloading = $08f304cbfc59140c$var$_isUnloading;
const $08f304cbfc59140c$var$_subscribeToVisiblityChanged = (listener)=>{
    $08f304cbfc59140c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $08f304cbfc59140c$var$_subscribeToVisiblityChanged;
const $08f304cbfc59140c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $08f304cbfc59140c$var$current) return;
    $08f304cbfc59140c$var$current = visibility;
    $08f304cbfc59140c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $08f304cbfc59140c$var$_notifyVisibilityChanged;
(0, $41u1G._addWindowEventListenerSafe)('focus', ()=>{
    $08f304cbfc59140c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($08f304cbfc59140c$var$FOREGROUND);
});
(0, $41u1G._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($08f304cbfc59140c$var$BACKGROUND));
(0, $41u1G._addWindowEventListenerSafe)('beforeunload', ()=>{
    $08f304cbfc59140c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($08f304cbfc59140c$var$BACKGROUND);
});
(0, $41u1G._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $08f304cbfc59140c$var$FOREGROUND : $08f304cbfc59140c$var$BACKGROUND);
});

});


parcelRegister("cOFsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.12.0';
let $954a51ddfc554c85$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$954a51ddfc554c85$var$metadata,
    add: (additions)=>{
        $954a51ddfc554c85$var$metadata = Object.assign(Object.assign({}, $954a51ddfc554c85$var$metadata), additions);
    }
};

});

parcelRegister("kvuMv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lTh7N", function(module, exports) {
"use strict";
var $fefc04a5334f0e35$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $kISM6 = parcelRequire("kISM6");

var $dHfQC = parcelRequire("dHfQC");

var $6abDe = parcelRequire("6abDe");

var $fAGEY = parcelRequire("fAGEY");
const $fefc04a5334f0e35$var$CACHE_LIMIT = 10;
class $fefc04a5334f0e35$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $fefc04a5334f0e35$var$InMemoryCache();
    }
    attach(sdkKey, options) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $dHfQC._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $dHfQC._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $fefc04a5334f0e35$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $fefc04a5334f0e35$var$__awaiter(this, void 0, void 0, function*() {
            if (!$6abDe.Storage.isReady()) yield $6abDe.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $bWQcA.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $fefc04a5334f0e35$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $dHfQC._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $fefc04a5334f0e35$var$__awaiter(this, void 0, void 0, function*() {
            let cachedData = null;
            if (cachedResult && this._isCachedResultValidFor204(cachedResult, user)) cachedData = cachedResult.data;
            const latest = yield this._fetchFromNetwork(cachedData, user, options);
            if (!latest) {
                $bWQcA.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $fAGEY._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $kISM6.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $fefc04a5334f0e35$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $fefc04a5334f0e35$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $bWQcA.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $6abDe.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($6abDe.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $fAGEY._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $6abDe.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $6abDe._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $fefc04a5334f0e35$var$_getEvictableKey(lastModifiedTimeMap, $fefc04a5334f0e35$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $6abDe.Storage.removeItem(evictable);
        }
        (0, $6abDe._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $fefc04a5334f0e35$var$DataAdapterCore;
function $fefc04a5334f0e35$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $dHfQC._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $fefc04a5334f0e35$var$_makeDataAdapterResult;
class $fefc04a5334f0e35$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $bWQcA.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $fefc04a5334f0e35$var$_getEvictableKey(this._data, $fefc04a5334f0e35$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $fefc04a5334f0e35$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("kISM6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $cKhdt = parcelRequire("cKhdt");

var $bWQcA = parcelRequire("bWQcA");

var $6abDe = parcelRequire("6abDe");

var $4Pas4 = parcelRequire("4Pas4");
const $f16267e08d9b62ab$var$PROMISE_MAP = {};
module.exports.StableID = {
    get: (sdkKey)=>{
        if ($f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] == null) {
            let stableID = $f16267e08d9b62ab$var$_loadFromStorage(sdkKey);
            if (stableID == null) {
                stableID = (0, $4Pas4.getUUID)();
                $f16267e08d9b62ab$var$_persistToStorage(stableID, sdkKey);
            }
            $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] = stableID;
        }
        return $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey];
    },
    setOverride: (override, sdkKey)=>{
        $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] = override;
        $f16267e08d9b62ab$var$_persistToStorage(override, sdkKey);
    }
};
function $f16267e08d9b62ab$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $cKhdt._getStorageKey)(sdkKey)}`;
}
function $f16267e08d9b62ab$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $f16267e08d9b62ab$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $6abDe._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $bWQcA.Log.warn('Failed to save StableID');
    }
}
function $f16267e08d9b62ab$var$_loadFromStorage(sdkKey) {
    const storageKey = $f16267e08d9b62ab$var$_getStableIDStorageKey(sdkKey);
    return (0, $6abDe._getObjectFromStorage)(storageKey);
}

});
parcelRegister("4Pas4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $3834085e5db4efd7$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $3834085e5db4efd7$var$getUUID;

});


parcelRegister("dHfQC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $iFJ4e = parcelRequire("iFJ4e");

var $bWQcA = parcelRequire("bWQcA");
function $9f8b9588b140fb9e$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $bWQcA.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $9f8b9588b140fb9e$var$_normalizeUser;
function $9f8b9588b140fb9e$var$_getFullUserHash(user) {
    return user ? (0, $iFJ4e._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $9f8b9588b140fb9e$var$_getFullUserHash;

});

parcelRegister("fAGEY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $bWQcA = parcelRequire("bWQcA");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $b59b4f260bbb468d$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $bWQcA.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $b59b4f260bbb468d$var$_typedJsonParse;

});


parcelRegister("3Ldy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("chIEM", function(module, exports) {
"use strict";
var $8f19b676caca501d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $aufpK = parcelRequire("aufpK");

var $cOFsX = parcelRequire("cOFsX");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $8f19b676caca501d$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $8f19b676caca501d$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $8f19b676caca501d$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $8f19b676caca501d$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $bWQcA.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$8f19b676caca501d$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($8f19b676caca501d$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $8f19b676caca501d$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $aufpK.SDKType._get(this._sdkKey);
                    const statsigMetadata = $cOFsX.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $8f19b676caca501d$var$_getDescription(unwrapped);
                    const body = JSON.stringify(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: body
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $8f19b676caca501d$var$ErrorBoundary;
function $8f19b676caca501d$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $8f19b676caca501d$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $8f19b676caca501d$var$UNKNOWN_ERROR;
    }
}
function $8f19b676caca501d$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}

});
parcelRegister("aufpK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $7a28a9aa1041049f$var$SDK_CLIENT = {};
let $7a28a9aa1041049f$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $7a28a9aa1041049f$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($7a28a9aa1041049f$var$suffix !== null && $7a28a9aa1041049f$var$suffix !== void 0 ? $7a28a9aa1041049f$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $7a28a9aa1041049f$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$7a28a9aa1041049f$var$suffix || $7a28a9aa1041049f$var$suffix === '-react') $7a28a9aa1041049f$var$suffix = '-' + binding;
    }
};

});


parcelRegister("jQTNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4r2xR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6gUK9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9ewyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _layer: 'l',
    _paramStore: 'p'
};
const $6b8eacf9f40140b7$var$EXIST_KEYS = new Set([]);
const $6b8eacf9f40140b7$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $6b8eacf9f40140b7$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($6b8eacf9f40140b7$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($6b8eacf9f40140b7$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $6b8eacf9f40140b7$var$createMemoKey;

});

parcelRegister("5oGx8", function(module, exports) {
"use strict";
var $3ee02fe0b5e0b9b6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $dWN0S = parcelRequire("dWN0S");

var $dWN0S = parcelRequire("dWN0S");

var $cLdPq = parcelRequire("cLdPq");

var $bWQcA = parcelRequire("bWQcA");

var $fcTTc = parcelRequire("fcTTc");

var $goBIO = parcelRequire("goBIO");

var $aufpK = parcelRequire("aufpK");

var $41u1G = parcelRequire("41u1G");

var $i7IAl = parcelRequire("i7IAl");

var $kISM6 = parcelRequire("kISM6");

var $2hLV8 = parcelRequire("2hLV8");

var $cOFsX = parcelRequire("cOFsX");

var $LDu8c = parcelRequire("LDu8c");
const $3ee02fe0b5e0b9b6$var$DEFAULT_TIMEOUT_MS = 10000;
const $3ee02fe0b5e0b9b6$var$BACKOFF_BASE_MS = 500;
const $3ee02fe0b5e0b9b6$var$BACKOFF_MAX_MS = 30000;
const $3ee02fe0b5e0b9b6$var$RATE_LIMIT_WINDOW_MS = 1000;
const $3ee02fe0b5e0b9b6$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $3ee02fe0b5e0b9b6$var$LEAK_RATE = $3ee02fe0b5e0b9b6$var$RATE_LIMIT_MAX_REQ_COUNT / $3ee02fe0b5e0b9b6$var$RATE_LIMIT_WINDOW_MS;
const $3ee02fe0b5e0b9b6$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $3ee02fe0b5e0b9b6$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $3ee02fe0b5e0b9b6$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $goBIO.NetworkFallbackResolver(this._options);
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            if (!$3ee02fe0b5e0b9b6$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs('POST', args);
            const body = yield this._getPopulatedBody(argsInternal, args.data);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, body);
        });
    }
    post(args) {
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            argsInternal.body = yield this._getPopulatedBody(argsInternal, args.data);
            if (args.isStatsigEncodable) argsInternal.body = this._attemptToEncodeString(argsInternal, argsInternal.body);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            if (!$3ee02fe0b5e0b9b6$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $bWQcA.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $LDu8c._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $3ee02fe0b5e0b9b6$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $3ee02fe0b5e0b9b6$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $3ee02fe0b5e0b9b6$var$_getErrorMessage(abortController, error);
                const timedOut = $3ee02fe0b5e0b9b6$var$_didTimeout(abortController);
                $3ee02fe0b5e0b9b6$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$3ee02fe0b5e0b9b6$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $2hLV8.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $bWQcA.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $3ee02fe0b5e0b9b6$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $3ee02fe0b5e0b9b6$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $3ee02fe0b5e0b9b6$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $fcTTc.Endpoint._initialize || args.urlConfig.endpoint === $fcTTc.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$fcTTc.NetworkParam.SdkKey]: args.sdkKey,
                [$fcTTc.NetworkParam.SdkType]: $aufpK.SDKType._get(args.sdkKey),
                [$fcTTc.NetworkParam.SdkVersion]: $cOFsX.SDK_VERSION,
                [$fcTTc.NetworkParam.Time]: String(Date.now()),
                [$fcTTc.NetworkParam.SessionID]: $i7IAl.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join('&');
            return `${url}${query ? `?${query}` : ''}`;
        });
    }
    _getPopulatedBody(args, data) {
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
            const stableID = $kISM6.StableID.get(sdkKey);
            const sessionID = $i7IAl.SessionID.get(sdkKey);
            const sdkType = $aufpK.SDKType._get(sdkKey);
            return JSON.stringify(Object.assign(Object.assign({}, data), {
                statsigMetadata: Object.assign(Object.assign({}, $cOFsX.StatsigMetadataProvider.get()), {
                    stableID: stableID,
                    sessionID: sessionID,
                    sdkType: sdkType,
                    fallbackUrl: fallbackUrl
                })
            }));
        });
    }
    _attemptToEncodeString(args, input) {
        var _a, _b;
        const win = (0, $41u1G._getWindowSafe)();
        if (this._options.disableStatsigEncoding || (0, $dWN0S._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return input;
        try {
            const result = (_a = win.btoa(input).split('').reverse().join('')) !== null && _a !== void 0 ? _a : input;
            args.params = Object.assign(Object.assign({}, (_b = args.params) !== null && _b !== void 0 ? _b : {}), {
                [$fcTTc.NetworkParam.StatsigEncoded]: '1'
            });
            return result;
        } catch (_c) {
            $bWQcA.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`);
            return input;
        }
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        return Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
    }
}
module.exports.NetworkCore = $3ee02fe0b5e0b9b6$var$NetworkCore;
const $3ee02fe0b5e0b9b6$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $bWQcA.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
function $3ee02fe0b5e0b9b6$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $3ee02fe0b5e0b9b6$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $3ee02fe0b5e0b9b6$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $fcTTc.Endpoint._initialize) return;
    $cLdPq.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $3ee02fe0b5e0b9b6$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $fcTTc.Endpoint._initialize) return;
    $cLdPq.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $cLdPq.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $3ee02fe0b5e0b9b6$var$_exponentialBackoff(attempt) {
    return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($3ee02fe0b5e0b9b6$var$BACKOFF_BASE_MS * (attempt * attempt), $3ee02fe0b5e0b9b6$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("goBIO", function(module, exports) {
"use strict";
var $befc26043885e3a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $fqq4V = parcelRequire("fqq4V");

var $iFJ4e = parcelRequire("iFJ4e");

var $bWQcA = parcelRequire("bWQcA");

var $6abDe = parcelRequire("6abDe");
const $befc26043885e3a5$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $befc26043885e3a5$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $befc26043885e3a5$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $befc26043885e3a5$var$DEFAULT_TTL_MS;
        $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $befc26043885e3a5$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0)) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    getFallbackFromProvided(url) {
        const path = $befc26043885e3a5$var$_extractPathFromUrl(url);
        if (path) return url.replace(path, '');
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $befc26043885e3a5$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$befc26043885e3a5$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig.endpoint, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, endpoint, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            url: newUrl,
            expiryTime: Date.now() + $befc26043885e3a5$var$DEFAULT_TTL_MS,
            previous: []
        };
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $befc26043885e3a5$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $befc26043885e3a5$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $fqq4V._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $befc26043885e3a5$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $befc26043885e3a5$var$NetworkFallbackResolver;
function $befc26043885e3a5$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $befc26043885e3a5$var$_isDomainFailure;
function $befc26043885e3a5$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $iFJ4e._DJB2)(sdkKey)}`;
}
function $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $befc26043885e3a5$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $6abDe.Storage.removeItem(hashKey);
        return;
    }
    $6abDe.Storage.setItem(hashKey, JSON.stringify(info));
}
function $befc26043885e3a5$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $befc26043885e3a5$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $6abDe.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $bWQcA.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $befc26043885e3a5$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("fqq4V", function(module, exports) {
"use strict";
var $b3ad8355bad4e62d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $b3ad8355bad4e62d$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $b3ad8355bad4e62d$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $b3ad8355bad4e62d$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $b3ad8355bad4e62d$var$MAX_START_LOOKUP = 200;
function $b3ad8355bad4e62d$var$_fetchTxtRecords(networkFunc) {
    return $b3ad8355bad4e62d$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($b3ad8355bad4e62d$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $b3ad8355bad4e62d$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $b3ad8355bad4e62d$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $b3ad8355bad4e62d$var$_fetchTxtRecords;
function $b3ad8355bad4e62d$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $b3ad8355bad4e62d$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $b3ad8355bad4e62d$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("i7IAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $cKhdt = parcelRequire("cKhdt");

var $bWQcA = parcelRequire("bWQcA");

var $6abDe = parcelRequire("6abDe");

var $4Pas4 = parcelRequire("4Pas4");
const $d31b7720065816c5$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $d31b7720065816c5$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $d31b7720065816c5$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($d31b7720065816c5$var$PROMISE_MAP[sdkKey] == null) $d31b7720065816c5$var$PROMISE_MAP[sdkKey] = $d31b7720065816c5$var$_loadSession(sdkKey);
        const session = $d31b7720065816c5$var$PROMISE_MAP[sdkKey];
        return $d31b7720065816c5$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $d31b7720065816c5$var$PROMISE_MAP[sdkKey] = $d31b7720065816c5$var$_overrideSessionId(override, sdkKey);
    }
};
function $d31b7720065816c5$var$_loadSession(sdkKey) {
    let data = $d31b7720065816c5$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $4Pas4.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $d31b7720065816c5$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $d31b7720065816c5$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    if ($d31b7720065816c5$var$_isIdle(data) || $d31b7720065816c5$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $4Pas4.getUUID)();
        data.startTime = now;
    }
    data.lastUpdate = now;
    $d31b7720065816c5$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    const sdkKey = session.sdkKey;
    session.idleTimeoutID = $d31b7720065816c5$var$_createSessionTimeout(sdkKey, $d31b7720065816c5$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $d31b7720065816c5$var$_createSessionTimeout(sdkKey, $d31b7720065816c5$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $d31b7720065816c5$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $d31b7720065816c5$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $d31b7720065816c5$var$MAX_SESSION_IDLE_TIME;
}
function $d31b7720065816c5$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $d31b7720065816c5$var$MAX_SESSION_AGE;
}
function $d31b7720065816c5$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $cKhdt._getStorageKey)(sdkKey)}`;
}
function $d31b7720065816c5$var$_persistToStorage(session, sdkKey) {
    const storageKey = $d31b7720065816c5$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $6abDe._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $bWQcA.Log.warn('Failed to save SessionID');
    }
}
function $d31b7720065816c5$var$_loadFromStorage(sdkKey) {
    const storageKey = $d31b7720065816c5$var$_getSessionIDStorageKey(sdkKey);
    return (0, $6abDe._getObjectFromStorage)(storageKey);
}

});

parcelRegister("2hLV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("j5rLe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lHEph", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2EFwj", function(module, exports) {
"use strict";
var $1eef863bd57456de$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $dWN0S = parcelRequire("dWN0S");

var $dWN0S = parcelRequire("dWN0S");

var $chIEM = parcelRequire("chIEM");

var $jPmF4 = parcelRequire("jPmF4");

var $bWQcA = parcelRequire("bWQcA");

var $9ewyA = parcelRequire("9ewyA");

var $41u1G = parcelRequire("41u1G");

var $i7IAl = parcelRequire("i7IAl");

var $6abDe = parcelRequire("6abDe");
const $1eef863bd57456de$var$MAX_MEMO_CACHE_SIZE = 3000;
class $1eef863bd57456de$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($bWQcA.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $6abDe.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $i7IAl.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $6abDe.Storage._setProvider(options.storageProvider);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $jPmF4.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $chIEM.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options);
        this.storageProvider = $6abDe.Storage;
        this._primeReadyRipcord();
        $1eef863bd57456de$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingDisabled(options.disableLogging);
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $6abDe.Storage._setDisabled(options.disableStorage);
        }
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $1eef863bd57456de$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $bWQcA.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $9ewyA.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $1eef863bd57456de$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $1eef863bd57456de$var$StatsigClientBase;
function $1eef863bd57456de$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $41u1G._isServerEnv)()) return;
    const statsigGlobal = (0, $dWN0S._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $bWQcA.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("egTIF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("2av9q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ejscn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cJCL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $9nGbQ = parcelRequire("9nGbQ");
const $9457c0baaccffd65$var$DEFAULT_RULE = 'default';
function $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $9457c0baaccffd65$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $9457c0baaccffd65$var$_makeFeatureGate(name, details, evaluation) {
    return $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $9457c0baaccffd65$var$_makeFeatureGate;
function $9457c0baaccffd65$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $9457c0baaccffd65$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $9457c0baaccffd65$var$_makeDynamicConfig;
function $9457c0baaccffd65$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $9457c0baaccffd65$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $9457c0baaccffd65$var$_makeExperiment;
function $9457c0baaccffd65$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $9457c0baaccffd65$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $9457c0baaccffd65$var$_makeLayer;
function $9457c0baaccffd65$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $9457c0baaccffd65$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $9457c0baaccffd65$var$_mergeOverride;
function $9457c0baaccffd65$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9nGbQ._isTypeMatch)(found, fallback)) {
            $bWQcA.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $9457c0baaccffd65$var$_makeTypedGet;

});

parcelRegister("jKP2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b7bEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $81796305d4513c6f$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $81796305d4513c6f$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});

parcelRegister("CFdSR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $074386bd88212bf7$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $074386bd88212bf7$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $074386bd88212bf7$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});


parcelRegister("kY5TA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10Gqk = parcelRequire("10Gqk");
class $f43dfc011d243ec2$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $10Gqk._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        if (!result) return false;
        const values = (0, $10Gqk._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        if (values.sdk_flags) $10Gqk.SDKFlags.setFlags(this._sdkKey, values.sdk_flags);
        else $10Gqk.SDKFlags.setFlags(this._sdkKey, {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $10Gqk._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a;
        const stableID = $10Gqk.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            if ((0, $10Gqk._getFullUserHash)(user) !== (0, $10Gqk._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $f43dfc011d243ec2$var$EvaluationStore;

});

parcelRegister("4m0mJ", function(module, exports) {
"use strict";
var $32b98016f09d5f8a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10Gqk = parcelRequire("10Gqk");

var $aKDb8 = parcelRequire("aKDb8");
class $32b98016f09d5f8a$var$StatsigNetwork extends $10Gqk.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._initializeUrlConfig = new $10Gqk.UrlConfiguration($10Gqk.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user) {
        return $32b98016f09d5f8a$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $10Gqk._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) data = Object.assign(Object.assign({}, data), {
                sinceTime: cache.time,
                previousDerivedFields: 'derived_fields' in cache ? cache.derived_fields : {},
                deltasResponseRequested: true,
                full_checksum: cache.full_checksum
            });
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $32b98016f09d5f8a$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $aKDb8._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $32b98016f09d5f8a$var$StatsigNetwork;

});
parcelRegister("aKDb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $10Gqk = parcelRequire("10Gqk");
const $7d3c97532ff78645$var$MAX_DELTAS_SORT_DEPTH = 2;
function $7d3c97532ff78645$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $10Gqk._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $7d3c97532ff78645$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $7d3c97532ff78645$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $10Gqk._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $7d3c97532ff78645$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $7d3c97532ff78645$var$_resolveDeltasResponse;
function $7d3c97532ff78645$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $7d3c97532ff78645$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $7d3c97532ff78645$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $7d3c97532ff78645$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $7d3c97532ff78645$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $7d3c97532ff78645$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("lsG6u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $10Gqk = parcelRequire("10Gqk");
const $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $f9fcdf6c868e549f$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $10Gqk._isTypeMatch)(value, fallback);
}
function $f9fcdf6c868e549f$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $f9fcdf6c868e549f$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $f9fcdf6c868e549f$var$_shouldLogExposure(options) ? undefined : $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $f9fcdf6c868e549f$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($f9fcdf6c868e549f$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $f9fcdf6c868e549f$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($f9fcdf6c868e549f$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $f9fcdf6c868e549f$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($f9fcdf6c868e549f$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $f9fcdf6c868e549f$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $10Gqk._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $f9fcdf6c868e549f$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $f9fcdf6c868e549f$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $f9fcdf6c868e549f$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $f9fcdf6c868e549f$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $f9fcdf6c868e549f$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $f9fcdf6c868e549f$var$_makeParamStoreGetter;

});

parcelRegister("krRcT", function(module, exports) {
"use strict";
var $ee2f9a0c916ece5f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $10Gqk = parcelRequire("10Gqk");

var $4m0mJ = parcelRequire("4m0mJ");
class $ee2f9a0c916ece5f$var$StatsigEvaluationsDataAdapter extends $10Gqk.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options) {
        super.attach(sdkKey, options);
        this._network = new $4m0mJ.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $10Gqk._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $10Gqk._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $10Gqk.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options) {
        var _a;
        return $ee2f9a0c916ece5f$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $10Gqk._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$10Gqk.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $10Gqk._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $ee2f9a0c916ece5f$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("9Pvqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $713542dc64f11289$export$2e2bcd8739ae039);

var $7n9mn = parcelRequire("7n9mn");
const $713542dc64f11289$export$a66cbd9b2289cd78 = '@all-features';
class $713542dc64f11289$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, $7n9mn.EventEmitter2)();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($713542dc64f11289$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($713542dc64f11289$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($713542dc64f11289$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $713542dc64f11289$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});
parcelRegister("7n9mn", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $6cAn5.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("hMFzK", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $142fe0e7679753ac$export$6dc24881a3d96325);

var $GWCtt = parcelRequire("GWCtt");
class $142fe0e7679753ac$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $142fe0e7679753ac$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $GWCtt.migrateEvaluationDetails)(experiment.details), experiment.__evaluation?.secondary_exposures, experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("GWCtt", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $181d0696732d3f0c$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $181d0696732d3f0c$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $181d0696732d3f0c$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $181d0696732d3f0c$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $181d0696732d3f0c$export$18ad168d3dbac899);

var $1Nxtn = parcelRequire("1Nxtn");

var $aIZdc = parcelRequire("aIZdc");

var $6jK44 = parcelRequire("6jK44");

var $8ruqY = parcelRequire("8ruqY");
const $181d0696732d3f0c$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $aIZdc.isFedRamp)() ? (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE : (0, $8ruqY.PerimeterType).COMMERCIAL,
        ...options
    });
const $181d0696732d3f0c$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $181d0696732d3f0c$export$3dad1db244472f32 = (identifiers, customAttributes, sdkKey)=>{
    const user = {
        customIDs: !customAttributes?.stableID && sdkKey ? {
            stableID: (0, $1Nxtn.StableID).get(sdkKey),
            ...identifiers
        } : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $181d0696732d3f0c$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $181d0696732d3f0c$var$evaluationReasonMappings = Object.entries((0, $6jK44.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $181d0696732d3f0c$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $181d0696732d3f0c$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $6jK44.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("aIZdc", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $d33f031e5d50f679$export$64d6499adf9b2e51);

var $bNXfF = parcelRequire("bNXfF");
function $d33f031e5d50f679$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $bNXfF.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("bNXfF", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $16271ea4123e88a6$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $16271ea4123e88a6$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $16271ea4123e88a6$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $16271ea4123e88a6$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $16271ea4123e88a6$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $16271ea4123e88a6$export$404582bc18fe4d9e);
const $16271ea4123e88a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $16271ea4123e88a6$export$f005e2e9f707cb5f = 'commercial';
const $16271ea4123e88a6$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $16271ea4123e88a6$export$a739cd5aac835909 = 'stg';
const $16271ea4123e88a6$export$42dd0cdd351a4a9 = 'prod';
const $16271ea4123e88a6$export$404582bc18fe4d9e = 'dev';
const $16271ea4123e88a6$export$d8347b4aae768c2d = [
    $16271ea4123e88a6$export$f005e2e9f707cb5f
];
const $16271ea4123e88a6$export$b1b1ccc8f3e7f954 = [
    $16271ea4123e88a6$export$f005e2e9f707cb5f,
    $16271ea4123e88a6$export$ce553301d55c2fd8
];

});


parcelRegister("6jK44", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $ebf60ba7eff6038f$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ebf60ba7eff6038f$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});

});

parcelRegister("8ruqY", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $2d5b6990a7a5a559$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $2d5b6990a7a5a559$export$c42b7bbc5e7ba555);
var $2d5b6990a7a5a559$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $2d5b6990a7a5a559$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $2d5b6990a7a5a559$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("9DDUe", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $263dbcb77497739a$export$936d0764594b6eb3);

var $GWCtt = parcelRequire("GWCtt");
class $263dbcb77497739a$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $263dbcb77497739a$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $GWCtt.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), layer.__evaluation?.secondary_exposures, layer.__evaluation?.undelegated_secondary_exposures, layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("1VtdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad1f7bf4f3a697b2$export$2e2bcd8739ae039);

var $8ruqY = parcelRequire("8ruqY");

var $i9mLs = parcelRequire("i9mLs");

var $4BA3W = parcelRequire("4BA3W");
const $ad1f7bf4f3a697b2$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $ad1f7bf4f3a697b2$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $ad1f7bf4f3a697b2$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $ad1f7bf4f3a697b2$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $ad1f7bf4f3a697b2$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $ad1f7bf4f3a697b2$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4BA3W.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4BA3W.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter) {
        if (useGatewayUrl) return $ad1f7bf4f3a697b2$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $8ruqY.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $8ruqY.FeatureGateEnvironment).Production:
                return $ad1f7bf4f3a697b2$export$18c93900db9358a4;
            case (0, $8ruqY.FeatureGateEnvironment).Staging:
                return $ad1f7bf4f3a697b2$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $8ruqY.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $8ruqY.FeatureGateEnvironment).Development:
                return $ad1f7bf4f3a697b2$export$f058dbf75c3bc647;
            case (0, $8ruqY.FeatureGateEnvironment).Staging:
                return $ad1f7bf4f3a697b2$export$942ba04389b0d5a2;
            default:
                return $ad1f7bf4f3a697b2$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $ad1f7bf4f3a697b2$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $ad1f7bf4f3a697b2$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $i9mLs.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("i9mLs", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $702e4d150695c43b$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $702e4d150695c43b$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("4BA3W", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $362ced472fdb999d$export$286baf652d0b1206);
class $362ced472fdb999d$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("l4hNL", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $e62c5c62fe23e73a$export$55fffef3474104af);

var $1Nxtn = parcelRequire("1Nxtn");
class $e62c5c62fe23e73a$export$55fffef3474104af extends (0, $1Nxtn.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $1Nxtn.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1Nxtn._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1Nxtn._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $1Nxtn._getStorageKey)(this._getSdkKey(), user);
        return `${0, $1Nxtn.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("5b5vX", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $a2f699f5738687d1$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $a2f699f5738687d1$export$bcb28fbac1def494);

var $10Gqk = parcelRequire("10Gqk");
const $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $a2f699f5738687d1$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $a2f699f5738687d1$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $a2f699f5738687d1$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $a2f699f5738687d1$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $a2f699f5738687d1$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $a2f699f5738687d1$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $a2f699f5738687d1$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $a2f699f5738687d1$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($a2f699f5738687d1$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $10Gqk._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$a2f699f5738687d1$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($a2f699f5738687d1$var$djb2MapKey((0, $10Gqk._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $a2f699f5738687d1$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $10Gqk._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($a2f699f5738687d1$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $10Gqk._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $a2f699f5738687d1$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("gSA3s", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $db1a60e9dc5c9d14$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $db1a60e9dc5c9d14$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $db1a60e9dc5c9d14$export$47fade9662f71000);

var $g0ix0 = parcelRequire("g0ix0");
const $db1a60e9dc5c9d14$export$5b78c989c8db2561 = new Map();
const $db1a60e9dc5c9d14$export$2a5c8df26bb89760 = new Map();
function $db1a60e9dc5c9d14$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $g0ix0.redactValue)(featureFlagValue);
    $db1a60e9dc5c9d14$export$5b78c989c8db2561.set(featureFlagName, value);
    $db1a60e9dc5c9d14$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("g0ix0", function(module, exports) {

$parcel$export(module.exports, "redactValue", () => $9a4ed2bdd42d469b$export$fcc03ee4c944962f);

function $9a4ed2bdd42d469b$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $9a4ed2bdd42d469b$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $9a4ed2bdd42d469b$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $9a4ed2bdd42d469b$export$7b4abba432e57989(value) {
    return $9a4ed2bdd42d469b$var$isString(value) && $9a4ed2bdd42d469b$var$startsAsObject(value) || $9a4ed2bdd42d469b$var$isObject(value);
}
function $9a4ed2bdd42d469b$export$fcc03ee4c944962f(featureFlagValue) {
    return $9a4ed2bdd42d469b$export$7b4abba432e57989(featureFlagValue) ? (0, $90de389b166e701f$export$42f4885608027d0c) : featureFlagValue;
}

});
const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';



parcelRegister("40Gox", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_initIfNeeded", () => $b7a4e79bf226085d$export$c9517ca8c289160f);

var $iEN9D = parcelRequire("iEN9D");
var $8ruqY = parcelRequire("8ruqY");

var $j8DrX = parcelRequire("j8DrX");

var $1zAKS = parcelRequire("1zAKS");

var $ouJAE = parcelRequire("ouJAE");
// This script is part of early scripts, where analytics clients are too heavy to be included.
// Therefore, we just record the error in a global variable. Downstream code will report this.
const $b7a4e79bf226085d$var$captureStatsigInitError = (error)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    if (globalThis.statsigInitialisationFixesPir24496Enabled === true) (0, $ouJAE.setUnreportedStatsigInitialisationError)(new Error('Statsig initialisation failed', {
        cause: error
    }));
};
const $b7a4e79bf226085d$var$initIfNeeded = ()=>{
    if (!(0, $iEN9D.default).initializeCalled()) try {
        const initPromise = (0, $iEN9D.default).initializeFromValues({
            sdkKey: 'client-7hFqlBhHaY5b2zA7LaaHDy1QKH7yZigbikmrwNpCuRy',
            // this environment variable is defined in webpack.config.js
            environment: (0, $j8DrX.default)('ajs-environment') === 'prod' ? (0, $8ruqY.FeatureGateEnvironment).Production : (0, $8ruqY.FeatureGateEnvironment).Staging,
            targetApp: 'jira_web',
            // Enable exposure firing from server side
            ...false && true ? {
                ignoreWindowUndefined: true
            } : null
        }, {
            // These getMeta functions should only be called once due to performance implications
            // Ideally we should get these passed through from react which memoizes this call already
            atlassianAccountId: (0, $j8DrX.default)('ajs-atlassian-account-id') || undefined,
            tenantId: (0, $j8DrX.default)('ajs-cloud-id') ?? undefined
        }, (0, $1zAKS.getCustomAttributes)(), (0, $1zAKS.getGateValues)());
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        if (globalThis.statsigInitialisationFixesPir24496Enabled === true) initPromise.catch($b7a4e79bf226085d$var$captureStatsigInitError);
    } catch (error) {
        $b7a4e79bf226085d$var$captureStatsigInitError(error);
        if (error instanceof Error) // eslint-disable-next-line no-console
        console.error('statsig.client.initialization', error.message);
    }
};
const $b7a4e79bf226085d$export$c9517ca8c289160f = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled) {
        if (globalVar.allowStatsigInitialisation_DO_NOT_USE) $b7a4e79bf226085d$var$initIfNeeded();
    } else $b7a4e79bf226085d$var$initIfNeeded();
};

});
parcelRegister("j8DrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $05371d41eb9586d7$export$2e2bcd8739ae039);

var $e7Ou5 = parcelRequire("e7Ou5");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$05371d41eb9586d7$export$2e2bcd8739ae039 = (0, $e7Ou5.default);

});
parcelRegister("e7Ou5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c123e7f489961af$export$2e2bcd8739ae039);
const $1c123e7f489961af$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};
var $1c123e7f489961af$export$2e2bcd8739ae039 = $1c123e7f489961af$export$c47913ca32a5c6f7;

});


parcelRegister("1zAKS", function(module, exports) {

$parcel$export(module.exports, "getCustomAttributes", () => $12e62e66c508782c$export$1ef2b1f78c9e40d9);
$parcel$export(module.exports, "_haveValuesArrived", () => $12e62e66c508782c$export$8ece9c90e8293278);
$parcel$export(module.exports, "getGateValues", () => $12e62e66c508782c$export$fc7c61934a5b05);

var $j8DrX = parcelRequire("j8DrX");
const $12e62e66c508782c$var$TAP_VALUES = {
    f: 'free',
    s: 'standard',
    p: 'premium'
};
const $12e62e66c508782c$var$getTapValue = (editionShorthand)=>$12e62e66c508782c$var$TAP_VALUES[editionShorthand] ?? 'UNLICENSED';
const $12e62e66c508782c$export$61e1423c6d76fbe3 = ()=>{
    try {
        const tenantContextEditions = JSON.parse((0, $j8DrX.default)('ajs-product-editions') || '{}');
        return {
            'jira-software_edition': $12e62e66c508782c$var$getTapValue(tenantContextEditions['jira-software']),
            'jira-servicedesk_edition': $12e62e66c508782c$var$getTapValue(tenantContextEditions['jira-servicedesk']),
            'jira-workmanagement_edition': $12e62e66c508782c$var$getTapValue(tenantContextEditions['jira-core'])
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return {
            'jira-software_edition': 'UNLICENSED',
            'jira-servicedesk_edition': 'UNLICENSED',
            'jira-workmanagement_edition': 'UNLICENSED'
        };
    }
};
const $12e62e66c508782c$export$1ef2b1f78c9e40d9 = ()=>({
        ...$12e62e66c508782c$export$61e1423c6d76fbe3(),
        exposureSource: false ? 'server' : 'client'
    });
const $12e62e66c508782c$var$valuesFromGlobal = (()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    return {
        locator: ()=>'_statsigValues' in globalVar,
        processor: ()=>globalVar._statsigValues
    };
})();
const $12e62e66c508782c$var$valuesFromMeta = (()=>{
    // FeatureGate value written into globalThis via SSR. Because statsig is not yet initialised on the client.
    const statsigInitialisationFixesPir24496Enabled = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    globalThis.statsigInitialisationFixesPir24496Enabled === true;
    // If parsing fails once, it will always fail. Avoid overhead of parsing again & again.
    let parsingFailed = false;
    const locator = ()=>{
        if (statsigInitialisationFixesPir24496Enabled === true && parsingFailed) return null;
        return (0, $j8DrX.default)('ajs-fe-statsig-values');
    };
    return {
        locator: locator,
        processor: ()=>{
            if (statsigInitialisationFixesPir24496Enabled === true && parsingFailed) throw new Error("Can't parse 'ajs-fe-statsig-values' value");
            const featureFlags = locator();
            if (featureFlags != null && featureFlags !== '') {
                globalThis.performance?.mark?.('statsig-parse:start');
                try {
                    const result = JSON.parse(featureFlags);
                    globalThis.performance?.mark?.('statsig-parse:end');
                    return result;
                } catch  {
                    if (statsigInitialisationFixesPir24496Enabled === true) parsingFailed = true;
                    throw new Error("Can't parse 'ajs-fe-statsig-values' value");
                }
            }
        }
    };
})();
const $12e62e66c508782c$export$8ece9c90e8293278 = ()=>{
    return Boolean($12e62e66c508782c$var$valuesFromGlobal.locator() || $12e62e66c508782c$var$valuesFromMeta.locator());
};
const $12e62e66c508782c$export$fc7c61934a5b05 = ()=>{
    if ($12e62e66c508782c$var$valuesFromGlobal.locator()) return $12e62e66c508782c$var$valuesFromGlobal.processor();
    if ($12e62e66c508782c$var$valuesFromMeta.locator()) return $12e62e66c508782c$var$valuesFromMeta.processor();
    return undefined;
};

});

parcelRegister("ouJAE", function(module, exports) {

$parcel$export(module.exports, "unreportedStatsigInitialisationError", () => $d85468caf6eb5df9$export$2f1d868dc4cd45f5);
$parcel$export(module.exports, "setUnreportedStatsigInitialisationError", () => $d85468caf6eb5df9$export$f0253a32470c87a6);
// eslint-disable-next-line import/no-mutable-exports
let $d85468caf6eb5df9$export$2f1d868dc4cd45f5;
const $d85468caf6eb5df9$export$f0253a32470c87a6 = (error)=>{
    $d85468caf6eb5df9$export$2f1d868dc4cd45f5 = error;
};

});


parcelRegister("aMh57", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $7a2e988876e668fc$export$f5282963edea4a68);

var $gES3x = parcelRequire("gES3x");
const $7a2e988876e668fc$export$f5282963edea4a68 = (location, error, details = {})=>false ? undefined : (0, $gES3x.captureException)(location, error, details);

});
parcelRegister("gES3x", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $265ac1cd167664c8$export$f5282963edea4a68);

var $fq71H = parcelRequire("fq71H");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $265ac1cd167664c8$var$tags = [
    'packageName',
    'teamName',
    'hash',
    'userLocation'
];
const $265ac1cd167664c8$export$f5282963edea4a68 = (location, error, details)=>{
    if (!error) return;
    (0, $fq71H.withScope)((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($265ac1cd167664c8$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
        (0, $fq71H.captureException)(error);
    });
};

});
parcelRegister("fq71H", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $b39ebc005c5eaf89$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $b39ebc005c5eaf89$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $b39ebc005c5eaf89$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $b39ebc005c5eaf89$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $b39ebc005c5eaf89$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $b39ebc005c5eaf89$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $b39ebc005c5eaf89$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setExtra", () => $b39ebc005c5eaf89$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTags", () => $b39ebc005c5eaf89$export$74a8fb34822092e6);
$parcel$export(module.exports, "setTag", () => $b39ebc005c5eaf89$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $b39ebc005c5eaf89$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $b39ebc005c5eaf89$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $b39ebc005c5eaf89$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "withActiveSpan", () => $b39ebc005c5eaf89$export$e57ac09b143d92a2);
$parcel$export(module.exports, "startTransaction", () => $b39ebc005c5eaf89$export$e262da7ae6480481);
$parcel$export(module.exports, "getCurrentScope", () => $b39ebc005c5eaf89$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $b39ebc005c5eaf89$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "flush", () => $b39ebc005c5eaf89$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $b39ebc005c5eaf89$export$8360e631d277ea4d);
$parcel$export(module.exports, "lastEventId", () => $b39ebc005c5eaf89$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "isInitialized", () => $b39ebc005c5eaf89$export$3f95c6f800b78024);
$parcel$export(module.exports, "startSession", () => $b39ebc005c5eaf89$export$c0d84948cecf78d8);
$parcel$export(module.exports, "endSession", () => $b39ebc005c5eaf89$export$17a5be43989a0bc1);
$parcel$export(module.exports, "captureSession", () => $b39ebc005c5eaf89$export$667e7b4d445d566b);

var $4mb67 = parcelRequire("4mb67");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");
var $1y8R2 = parcelRequire("1y8R2");

var $b5y9n = parcelRequire("b5y9n");

var $cQ4mt = parcelRequire("cQ4mt");

var $egVmm = parcelRequire("egVmm");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $1WSQk = parcelRequire("1WSQk");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $b39ebc005c5eaf89$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().captureException(exception, (0, $1WSQk.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $b39ebc005c5eaf89$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $b39ebc005c5eaf89$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $b39ebc005c5eaf89$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $b39ebc005c5eaf89$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $egVmm.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $b39ebc005c5eaf89$export$9a4fed82c350c2bd(callback) {
    return (0, $egVmm.runWithAsyncContext)(()=>{
        return callback((0, $egVmm.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $b39ebc005c5eaf89$export$e57ac09b143d92a2(span, callback) {
    return $b39ebc005c5eaf89$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $b39ebc005c5eaf89$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b39ebc005c5eaf89$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    if (!client) (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $1y8R2.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b39ebc005c5eaf89$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $b39ebc005c5eaf89$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $leMLP.timestampInSeconds)();
    function finishCheckIn(status) {
        $b39ebc005c5eaf89$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $leMLP.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $dlAFs.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b39ebc005c5eaf89$export$4909b86c8034bf73(timeout) {
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b39ebc005c5eaf89$export$8360e631d277ea4d(timeout) {
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $b39ebc005c5eaf89$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $b39ebc005c5eaf89$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $b39ebc005c5eaf89$export$3f95c6f800b78024() {
    return !!$b39ebc005c5eaf89$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $b39ebc005c5eaf89$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $b39ebc005c5eaf89$export$c0d84948cecf78d8(context) {
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const currentScope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $b5y9n.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $4mb67.GLOBAL_OBJ).navigator || {};
    const session = (0, $AQ9Bo.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $AQ9Bo.updateSession)(currentSession, {
        status: 'exited'
    });
    $b39ebc005c5eaf89$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $b39ebc005c5eaf89$export$17a5be43989a0bc1() {
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const currentScope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $AQ9Bo.closeSession)(session);
    $b39ebc005c5eaf89$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $b39ebc005c5eaf89$var$_sendSessionUpdate() {
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const currentScope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $b39ebc005c5eaf89$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $b39ebc005c5eaf89$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $b39ebc005c5eaf89$var$_sendSessionUpdate();
}

});
parcelRegister("4mb67", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $32c1d343120fd67b$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $32c1d343120fd67b$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $32c1d343120fd67b$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $32c1d343120fd67b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $32c1d343120fd67b$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $32c1d343120fd67b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $32c1d343120fd67b$var$isGlobalObj(window) || typeof self == 'object' && $32c1d343120fd67b$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $32c1d343120fd67b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $32c1d343120fd67b$export$256479dc0cea61c4() {
    return $32c1d343120fd67b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $32c1d343120fd67b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $32c1d343120fd67b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("dlAFs", function(module, exports) {

$parcel$export(module.exports, "isError", () => $9b79adf0c2239458$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $9b79adf0c2239458$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $9b79adf0c2239458$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $9b79adf0c2239458$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $9b79adf0c2239458$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $9b79adf0c2239458$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $9b79adf0c2239458$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $9b79adf0c2239458$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $9b79adf0c2239458$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $9b79adf0c2239458$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $9b79adf0c2239458$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $9b79adf0c2239458$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $9b79adf0c2239458$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $9b79adf0c2239458$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $9b79adf0c2239458$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $9b79adf0c2239458$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9b79adf0c2239458$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$e6127cc7fe7395c3(wat) {
    switch($9b79adf0c2239458$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $9b79adf0c2239458$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$var$isBuiltin(wat, className) {
    return $9b79adf0c2239458$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$9f9636d330b71954(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$ef9e2056653f0c8e(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$12e869b2a583f783(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$844ec244b1367d54(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$c3825b437cbdea5c(wat) {
    return wat === null || $9b79adf0c2239458$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$53b83ca8eaab0383(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9b79adf0c2239458$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9b79adf0c2239458$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$49841c62b9eff15(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9b79adf0c2239458$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$bc2894c7158efbac(wat) {
    return $9b79adf0c2239458$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("lN8pX", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $fdd4b42aa0c3fc99$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $fdd4b42aa0c3fc99$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $fdd4b42aa0c3fc99$export$af88d00dbe7f521);

var $jK6Z8 = parcelRequire("jK6Z8");

var $4mb67 = parcelRequire("4mb67");
/** Prefix for logging strings */ const $fdd4b42aa0c3fc99$var$PREFIX = 'Sentry Logger ';
const $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $fdd4b42aa0c3fc99$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fdd4b42aa0c3fc99$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $4mb67.GLOBAL_OBJ))) return callback();
    const console = (0, $4mb67.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fdd4b42aa0c3fc99$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fdd4b42aa0c3fc99$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fdd4b42aa0c3fc99$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $jK6Z8.DEBUG_BUILD) $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $fdd4b42aa0c3fc99$export$cda52e2a8927a2ca(()=>{
                (0, $4mb67.GLOBAL_OBJ).console[name](`${$fdd4b42aa0c3fc99$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $fdd4b42aa0c3fc99$export$af88d00dbe7f521 = $fdd4b42aa0c3fc99$var$makeLogger();

});
parcelRegister("jK6Z8", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $e5f7bb4dc7625723$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e5f7bb4dc7625723$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("leMLP", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $f760bc959839c129$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $f760bc959839c129$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $f760bc959839c129$export$baf075a948ffc0bf);

var $4mb67 = parcelRequire("4mb67");
const $f760bc959839c129$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $f760bc959839c129$export$7740643b9eeaf0c4() {
    return Date.now() / $f760bc959839c129$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $f760bc959839c129$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $4mb67.GLOBAL_OBJ);
    if (!performance || !performance.now) return $f760bc959839c129$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $f760bc959839c129$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $f760bc959839c129$export$ee52dced521e3e18 = $f760bc959839c129$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $f760bc959839c129$export$c5907b5a8838db13 = $f760bc959839c129$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $f760bc959839c129$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $f760bc959839c129$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $4mb67.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $f760bc959839c129$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $f760bc959839c129$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $f760bc959839c129$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $f760bc959839c129$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("1y8R2", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $120fd5c154f81fc1$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $120fd5c154f81fc1$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $120fd5c154f81fc1$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $120fd5c154f81fc1$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "addContextToFrame", () => $120fd5c154f81fc1$export$ec2291bfc64632f0);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $120fd5c154f81fc1$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $120fd5c154f81fc1$export$3131421a7d01b4fb);

var $aLrZa = parcelRequire("aLrZa");

var $jmfnM = parcelRequire("jmfnM");

var $4mb67 = parcelRequire("4mb67");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $120fd5c154f81fc1$export$19f53698e68b2496() {
    const gbl = (0, $4mb67.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $120fd5c154f81fc1$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $120fd5c154f81fc1$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $120fd5c154f81fc1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $120fd5c154f81fc1$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $120fd5c154f81fc1$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $120fd5c154f81fc1$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $120fd5c154f81fc1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $120fd5c154f81fc1$export$d364f2020ab30578(input) {
    const match = input.match($120fd5c154f81fc1$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $120fd5c154f81fc1$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $jmfnM.snipLine)(line, 0));
    frame.context_line = (0, $jmfnM.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $jmfnM.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $120fd5c154f81fc1$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $aLrZa.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $120fd5c154f81fc1$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("aLrZa", function(module, exports) {

$parcel$export(module.exports, "fill", () => $7d640080e6eb3f0b$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $7d640080e6eb3f0b$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $7d640080e6eb3f0b$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $7d640080e6eb3f0b$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $7d640080e6eb3f0b$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $7d640080e6eb3f0b$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $7d640080e6eb3f0b$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $7d640080e6eb3f0b$export$d25f2688db1bb433);

var $3oSFd = parcelRequire("3oSFd");

var $jK6Z8 = parcelRequire("jK6Z8");

var $dlAFs = parcelRequire("dlAFs");

var $lN8pX = parcelRequire("lN8pX");

var $jmfnM = parcelRequire("jmfnM");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7d640080e6eb3f0b$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $7d640080e6eb3f0b$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7d640080e6eb3f0b$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $jK6Z8.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7d640080e6eb3f0b$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7d640080e6eb3f0b$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $7d640080e6eb3f0b$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $7d640080e6eb3f0b$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $7d640080e6eb3f0b$export$62ff257738bf57f5(value) {
    if ((0, $dlAFs.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$7d640080e6eb3f0b$var$getOwnProperties(value)
    };
    else if ((0, $dlAFs.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $7d640080e6eb3f0b$var$serializeEventTarget(value.target),
            currentTarget: $7d640080e6eb3f0b$var$serializeEventTarget(value.currentTarget),
            ...$7d640080e6eb3f0b$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $dlAFs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7d640080e6eb3f0b$var$serializeEventTarget(target) {
    try {
        return (0, $dlAFs.isElement)(target) ? (0, $3oSFd.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $7d640080e6eb3f0b$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7d640080e6eb3f0b$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7d640080e6eb3f0b$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jmfnM.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jmfnM.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $7d640080e6eb3f0b$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7d640080e6eb3f0b$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7d640080e6eb3f0b$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($7d640080e6eb3f0b$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $7d640080e6eb3f0b$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($7d640080e6eb3f0b$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $7d640080e6eb3f0b$var$isPojo(input) {
    if (!(0, $dlAFs.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7d640080e6eb3f0b$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dlAFs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("3oSFd", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $279e040ce8072513$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $279e040ce8072513$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $279e040ce8072513$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $279e040ce8072513$export$26727cfcc4d7e0fc);

var $dlAFs = parcelRequire("dlAFs");

var $4mb67 = parcelRequire("4mb67");
// eslint-disable-next-line deprecation/deprecation
const $279e040ce8072513$var$WINDOW = (0, $4mb67.getGlobalObject)();
const $279e040ce8072513$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $279e040ce8072513$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $279e040ce8072513$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $279e040ce8072513$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $279e040ce8072513$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($279e040ce8072513$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $dlAFs.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $279e040ce8072513$export$1cfafeee2987818b() {
    try {
        return $279e040ce8072513$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $279e040ce8072513$export$c660c1f3ab49225c(selector) {
    if ($279e040ce8072513$var$WINDOW.document && $279e040ce8072513$var$WINDOW.document.querySelector) return $279e040ce8072513$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $279e040ce8072513$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$279e040ce8072513$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("jmfnM", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $e17c0107279bbd2f$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e17c0107279bbd2f$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $e17c0107279bbd2f$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $e17c0107279bbd2f$export$a7a5ec66062ea5d);

var $dlAFs = parcelRequire("dlAFs");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e17c0107279bbd2f$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e17c0107279bbd2f$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e17c0107279bbd2f$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dlAFs.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e17c0107279bbd2f$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dlAFs.isString)(value)) return false;
    if ((0, $dlAFs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dlAFs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e17c0107279bbd2f$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e17c0107279bbd2f$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("b5y9n", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $812aa6e213d9b78e$export$849dbeeeda01ae98);
const $812aa6e213d9b78e$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("cQ4mt", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $958db979092b43dc$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $958db979092b43dc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("egVmm", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $a63f0dc2ef4b012c$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $a63f0dc2ef4b012c$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getMainCarrier", () => $a63f0dc2ef4b012c$export$19eade501500c6c1);
$parcel$export(module.exports, "getHubFromCarrier", () => $a63f0dc2ef4b012c$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $a63f0dc2ef4b012c$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $a63f0dc2ef4b012c$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $a63f0dc2ef4b012c$export$70d775fb1f267027);

var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");
var $4mb67 = parcelRequire("4mb67");
var $dlAFs = parcelRequire("dlAFs");
var $1y8R2 = parcelRequire("1y8R2");

var $b5y9n = parcelRequire("b5y9n");

var $cQ4mt = parcelRequire("cQ4mt");

var $XZfNs = parcelRequire("XZfNs");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $itB3p = parcelRequire("itB3p");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $a63f0dc2ef4b012c$export$24a86ef7798177e4 = parseFloat((0, $itB3p.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $a63f0dc2ef4b012c$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $a63f0dc2ef4b012c$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $a63f0dc2ef4b012c$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $XZfNs.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $XZfNs.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $dlAFs.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $a63f0dc2ef4b012c$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $leMLP.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $lN8pX.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $a63f0dc2ef4b012c$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $a63f0dc2ef4b012c$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $cQ4mt.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $lN8pX.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $lN8pX.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $AQ9Bo.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $b5y9n.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $4mb67.GLOBAL_OBJ).navigator || {};
        const session = (0, $AQ9Bo.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $AQ9Bo.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $a63f0dc2ef4b012c$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $a63f0dc2ef4b012c$export$19eade501500c6c1() {
    (0, $4mb67.GLOBAL_OBJ).__SENTRY__ = (0, $4mb67.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $4mb67.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$4188a14ad302d1bc(hub) {
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    const oldHub = $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(registry);
    $a63f0dc2ef4b012c$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $a63f0dc2ef4b012c$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $a63f0dc2ef4b012c$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $a63f0dc2ef4b012c$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$var$getGlobalHub(registry = $a63f0dc2ef4b012c$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$a63f0dc2ef4b012c$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(registry).isOlderThan($a63f0dc2ef4b012c$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $a63f0dc2ef4b012c$export$849f05434e95d2f2(registry, new $a63f0dc2ef4b012c$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$236689a79f5aa020(carrier, parent = $a63f0dc2ef4b012c$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$a63f0dc2ef4b012c$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(carrier).isOlderThan($a63f0dc2ef4b012c$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $a63f0dc2ef4b012c$export$849f05434e95d2f2(carrier, new $a63f0dc2ef4b012c$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $a63f0dc2ef4b012c$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $a63f0dc2ef4b012c$export$70d775fb1f267027(callback, options = {}) {
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $a63f0dc2ef4b012c$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4mb67.getGlobalSingleton)('hub', ()=>new $a63f0dc2ef4b012c$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("XZfNs", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $0b4506875d60d857$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $0b4506875d60d857$export$aa55d5ab8e05984f);

var $leMLP = parcelRequire("leMLP");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $1y8R2 = parcelRequire("1y8R2");

var $bu7hL = parcelRequire("bu7hL");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $cICvr = parcelRequire("cICvr");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $0b4506875d60d857$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $0b4506875d60d857$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $0b4506875d60d857$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $0b4506875d60d857$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $0b4506875d60d857$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $0b4506875d60d857$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $AQ9Bo.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $0b4506875d60d857$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $dlAFs.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $0b4506875d60d857$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $0b4506875d60d857$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $leMLP.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $cICvr.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $bu7hL.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $bu7hL.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!this._client) {
            (0, $lN8pX.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!this._client) {
            (0, $lN8pX.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!this._client) {
            (0, $lN8pX.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $0b4506875d60d857$export$aa55d5ab8e05984f() {
    if (!$0b4506875d60d857$var$globalScope) $0b4506875d60d857$var$globalScope = new $0b4506875d60d857$export$775b6bb06e53a214();
    return $0b4506875d60d857$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $0b4506875d60d857$export$c83048efd17527d6(scope) {
    $0b4506875d60d857$var$globalScope = scope;
}
function $0b4506875d60d857$var$generatePropagationContext() {
    return {
        traceId: (0, $1y8R2.uuid4)(),
        spanId: (0, $1y8R2.uuid4)().substring(16)
    };
}

});
parcelRegister("bu7hL", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $85c825cf5a735bc0$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $85c825cf5a735bc0$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $85c825cf5a735bc0$export$bf2a096c3e883e79);

var $4mb67 = parcelRequire("4mb67");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $57iGk = parcelRequire("57iGk");

var $cQ4mt = parcelRequire("cQ4mt");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $85c825cf5a735bc0$export$3c4238858b85e8ac() {
    return (0, $4mb67.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $85c825cf5a735bc0$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $85c825cf5a735bc0$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $85c825cf5a735bc0$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $57iGk.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $cQ4mt.DEBUG_BUILD) && processor.id && result === null && (0, $lN8pX.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dlAFs.isThenable)(result)) result.then((final)=>$85c825cf5a735bc0$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $85c825cf5a735bc0$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("57iGk", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $3b9c18ffdaba0874$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $3b9c18ffdaba0874$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $3b9c18ffdaba0874$export$78e43115b553f358);

var $dlAFs = parcelRequire("dlAFs");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $3b9c18ffdaba0874$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($3b9c18ffdaba0874$var$States || ($3b9c18ffdaba0874$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $3b9c18ffdaba0874$export$1fda8aa4d135f8aa(value) {
    return new $3b9c18ffdaba0874$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $3b9c18ffdaba0874$export$78e43115b553f358(reason) {
    return new $3b9c18ffdaba0874$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $3b9c18ffdaba0874$export$6f292d4960313241 {
    constructor(executor){
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init.call(this);
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init2.call(this);
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init3.call(this);
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $3b9c18ffdaba0874$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $3b9c18ffdaba0874$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $3b9c18ffdaba0874$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($3b9c18ffdaba0874$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($3b9c18ffdaba0874$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $3b9c18ffdaba0874$var$States.PENDING) return;
            if ((0, $dlAFs.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $3b9c18ffdaba0874$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $3b9c18ffdaba0874$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $3b9c18ffdaba0874$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("AQ9Bo", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $06ebd19476826491$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $06ebd19476826491$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $06ebd19476826491$export$56521d9ba90f62ee);

var $aLrZa = parcelRequire("aLrZa");
var $leMLP = parcelRequire("leMLP");
var $1y8R2 = parcelRequire("1y8R2");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $06ebd19476826491$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $leMLP.timestampInSeconds)();
    const session = {
        sid: (0, $1y8R2.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$06ebd19476826491$var$sessionToJSON(session)
    };
    if (context) $06ebd19476826491$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $06ebd19476826491$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $leMLP.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $1y8R2.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $06ebd19476826491$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $06ebd19476826491$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $06ebd19476826491$var$sessionToJSON(session) {
    return (0, $aLrZa.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("cICvr", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $94277699c2a807a7$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $94277699c2a807a7$export$25ac7e259a513db4);

var $1y8R2 = parcelRequire("1y8R2");
var $aLrZa = parcelRequire("aLrZa");

var $7AtVc = parcelRequire("7AtVc");

var $iB4pU = parcelRequire("iB4pU");

var $aYVgD = parcelRequire("aYVgD");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $94277699c2a807a7$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $94277699c2a807a7$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $94277699c2a807a7$var$applySpanToEvent(event, span);
    $94277699c2a807a7$var$applyFingerprintToEvent(event, fingerprint);
    $94277699c2a807a7$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $94277699c2a807a7$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $94277699c2a807a7$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'extra', extra);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'tags', tags);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'user', user);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'contexts', contexts);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $94277699c2a807a7$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $94277699c2a807a7$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $aLrZa.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $aLrZa.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $aLrZa.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $aLrZa.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $94277699c2a807a7$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $94277699c2a807a7$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $94277699c2a807a7$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $aYVgD.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $iB4pU.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $7AtVc.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $aYVgD.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $94277699c2a807a7$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $1y8R2.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("7AtVc", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $58631b0599d820c1$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $58631b0599d820c1$export$a117f995597e25df);

var $aLrZa = parcelRequire("aLrZa");

var $b5y9n = parcelRequire("b5y9n");

var $fq71H = parcelRequire("fq71H");

var $iB4pU = parcelRequire("iB4pU");

var $aYVgD = parcelRequire("aYVgD");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $58631b0599d820c1$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $aLrZa.dropUndefinedKeys)({
        environment: options.environment || (0, $b5y9n.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $58631b0599d820c1$export$a117f995597e25df(span) {
    const client = (0, $fq71H.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $58631b0599d820c1$export$366bad00d6815eed((0, $aYVgD.spanToJSON)(span).trace_id || '', client, (0, $fq71H.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $iB4pU.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $aYVgD.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $aYVgD.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("iB4pU", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", () => $d89f1bcbc7bf781a$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $d89f1bcbc7bf781a$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("aYVgD", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $7febee0d424b9dbc$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $7febee0d424b9dbc$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTraceContext", () => $7febee0d424b9dbc$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $7febee0d424b9dbc$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceHeader", () => $7febee0d424b9dbc$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $7febee0d424b9dbc$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $7febee0d424b9dbc$export$3f7581298f56c6d7);

var $aLrZa = parcelRequire("aLrZa");
var $27K1p = parcelRequire("27K1p");
var $leMLP = parcelRequire("leMLP");
// These are aligned with OpenTelemetry trace flags
const $7febee0d424b9dbc$export$208d5b368507fb8b = 0x0;
const $7febee0d424b9dbc$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $7febee0d424b9dbc$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $7febee0d424b9dbc$export$92d8c23565496537(span);
    return (0, $aLrZa.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $7febee0d424b9dbc$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $7febee0d424b9dbc$export$5caecac1caaf3a71(span);
    return (0, $27K1p.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $7febee0d424b9dbc$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $7febee0d424b9dbc$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $7febee0d424b9dbc$var$ensureTimestampInSeconds(input.getTime());
    return (0, $leMLP.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $7febee0d424b9dbc$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $7febee0d424b9dbc$export$92d8c23565496537(span) {
    if ($7febee0d424b9dbc$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $7febee0d424b9dbc$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $7febee0d424b9dbc$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $7febee0d424b9dbc$export$eb571cd9b5d98de8);
}

});
parcelRegister("27K1p", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", () => $18bfef263e152628$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $18bfef263e152628$export$ca5c066532785b6e);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $18bfef263e152628$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $18bfef263e152628$export$f35d907436da45cf);

var $1QelU = parcelRequire("1QelU");

var $1y8R2 = parcelRequire("1y8R2");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $18bfef263e152628$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $18bfef263e152628$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($18bfef263e152628$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $18bfef263e152628$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $18bfef263e152628$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $1QelU.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $1y8R2.uuid4)(),
            spanId: (0, $1y8R2.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $1y8R2.uuid4)(),
            parentSpanId: parentSpanId || (0, $1y8R2.uuid4)().substring(16),
            spanId: (0, $1y8R2.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $18bfef263e152628$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $18bfef263e152628$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $1QelU.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $1y8R2.uuid4)(),
        spanId: (0, $1y8R2.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $1y8R2.uuid4)(),
        parentSpanId: parentSpanId || (0, $1y8R2.uuid4)().substring(16),
        spanId: (0, $1y8R2.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $18bfef263e152628$export$f35d907436da45cf(traceId = (0, $1y8R2.uuid4)(), spanId = (0, $1y8R2.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("1QelU", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $1575c7dcc60fd6f1$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $1575c7dcc60fd6f1$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $1575c7dcc60fd6f1$export$56766feef403f365);

var $jK6Z8 = parcelRequire("jK6Z8");

var $dlAFs = parcelRequire("dlAFs");

var $lN8pX = parcelRequire("lN8pX");
const $1575c7dcc60fd6f1$export$9ca9946bd449ac06 = 'baggage';
const $1575c7dcc60fd6f1$export$6e69537d67fa20f = 'sentry-';
const $1575c7dcc60fd6f1$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $1575c7dcc60fd6f1$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $1575c7dcc60fd6f1$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $dlAFs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $1575c7dcc60fd6f1$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $1575c7dcc60fd6f1$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($1575c7dcc60fd6f1$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($1575c7dcc60fd6f1$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $1575c7dcc60fd6f1$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$1575c7dcc60fd6f1$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $1575c7dcc60fd6f1$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $1575c7dcc60fd6f1$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $1575c7dcc60fd6f1$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $1575c7dcc60fd6f1$export$bdd844ddb2def819) {
            (0, $jK6Z8.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("itB3p", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $d737ad8d6bf38903$export$31499a9cd224b78c);
const $d737ad8d6bf38903$export$31499a9cd224b78c = '7.119.0';

});


parcelRegister("1WSQk", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $16b5bfea67ef6af7$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $16b5bfea67ef6af7$export$76b5f966996d1653);

var $1y8R2 = parcelRequire("1y8R2");
var $leMLP = parcelRequire("leMLP");
var $4mb67 = parcelRequire("4mb67");
var $j15Q6 = parcelRequire("j15Q6");
var $jmfnM = parcelRequire("jmfnM");

var $b5y9n = parcelRequire("b5y9n");

var $bu7hL = parcelRequire("bu7hL");

var $XZfNs = parcelRequire("XZfNs");

var $cICvr = parcelRequire("cICvr");

var $aYVgD = parcelRequire("aYVgD");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $16b5bfea67ef6af7$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $1y8R2.uuid4)(),
        timestamp: event.timestamp || (0, $leMLP.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $16b5bfea67ef6af7$var$applyClientOptions(prepared, options);
    $16b5bfea67ef6af7$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $16b5bfea67ef6af7$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $16b5bfea67ef6af7$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $1y8R2.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $XZfNs.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $cICvr.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $cICvr.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $cICvr.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $bu7hL.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $bu7hL.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $16b5bfea67ef6af7$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $16b5bfea67ef6af7$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $16b5bfea67ef6af7$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $b5y9n.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $jmfnM.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $jmfnM.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $jmfnM.truncate)(request.url, maxValueLength);
}
const $16b5bfea67ef6af7$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $16b5bfea67ef6af7$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $4mb67.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $16b5bfea67ef6af7$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $16b5bfea67ef6af7$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $16b5bfea67ef6af7$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $16b5bfea67ef6af7$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $16b5bfea67ef6af7$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $j15Q6.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $j15Q6.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $j15Q6.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $j15Q6.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $j15Q6.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $aYVgD.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $j15Q6.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $16b5bfea67ef6af7$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $XZfNs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $16b5bfea67ef6af7$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($16b5bfea67ef6af7$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($16b5bfea67ef6af7$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $16b5bfea67ef6af7$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $XZfNs.Scope) || typeof hint === 'function';
}
const $16b5bfea67ef6af7$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $16b5bfea67ef6af7$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$16b5bfea67ef6af7$var$captureContextKeys.includes(key));
}

});
parcelRegister("j15Q6", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $dd82a3e2defd66c3$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $dd82a3e2defd66c3$export$23fbbb20bed71033);

var $dlAFs = parcelRequire("dlAFs");

var $bH6rI = parcelRequire("bH6rI");

var $aLrZa = parcelRequire("aLrZa");

var $jVtDJ = parcelRequire("jVtDJ");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dd82a3e2defd66c3$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $dd82a3e2defd66c3$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $dd82a3e2defd66c3$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $dd82a3e2defd66c3$export$a3295358bff77e(object, depth);
    if ($dd82a3e2defd66c3$var$jsonSize(normalized) > maxSize) return $dd82a3e2defd66c3$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $dd82a3e2defd66c3$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $bH6rI.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $dlAFs.isNaN)(value)) return value;
    const stringified = $dd82a3e2defd66c3$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $dd82a3e2defd66c3$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $aLrZa.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $dd82a3e2defd66c3$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $dd82a3e2defd66c3$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $dlAFs.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $dlAFs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $jVtDJ.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $dd82a3e2defd66c3$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $dd82a3e2defd66c3$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $dd82a3e2defd66c3$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dd82a3e2defd66c3$var$jsonSize(value) {
    return $dd82a3e2defd66c3$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $dd82a3e2defd66c3$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("bH6rI", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $8838b5eb2ad6927f$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $8838b5eb2ad6927f$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("jVtDJ", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $e81a55111f017fb6$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $e81a55111f017fb6$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $e81a55111f017fb6$export$aad197c7121a6651);

var $g1pU3 = parcelRequire("g1pU3");
const $e81a55111f017fb6$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $e81a55111f017fb6$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $e81a55111f017fb6$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $e81a55111f017fb6$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $e81a55111f017fb6$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($e81a55111f017fb6$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $e81a55111f017fb6$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $e81a55111f017fb6$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $e81a55111f017fb6$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $e81a55111f017fb6$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $e81a55111f017fb6$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($e81a55111f017fb6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($e81a55111f017fb6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $e81a55111f017fb6$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $e81a55111f017fb6$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $e81a55111f017fb6$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $e81a55111f017fb6$var$defaultFunctionName;
        return fn.name || $e81a55111f017fb6$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $e81a55111f017fb6$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $e81a55111f017fb6$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $g1pU3.node)(getModule)
    ];
}

});
parcelRegister("g1pU3", function(module, exports) {

$parcel$export(module.exports, "node", () => $baa0d5261c6742c8$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $baa0d5261c6742c8$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $baa0d5261c6742c8$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $baa0d5261c6742c8$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});








parcelRegister("4R6GH", function(module, exports) {

$parcel$export(module.exports, "withoutFeatureExistenceCheck", () => $a00a9760f835bf20$export$ede4c4e7e9dad3f2);
$parcel$export(module.exports, "fg", () => $a00a9760f835bf20$export$b40ec24ac8275656);

var $iEN9D = parcelRequire("iEN9D");

var $gSA3s = parcelRequire("gSA3s");

var $40Gox = parcelRequire("40Gox");

var $aMh57 = parcelRequire("aMh57");
class $a00a9760f835bf20$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        // Capture the stack without the error construction
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // Remove the error creation line and preserve caller stack
            // 1 - checkIfGateExists
            // 2 - featureGate
            // 3 - fg
            this.stack = [
                ...stackLines.slice(3)
            ].join('\n');
        }
    }
}
const $a00a9760f835bf20$var$checkedGates = new Set();
const $a00a9760f835bf20$var$checkIfGateExists = (gateName)=>{
    // perform early exist to minimize performance impact
    if ($a00a9760f835bf20$var$checkedGates.has(gateName)) return;
    $a00a9760f835bf20$var$checkedGates.add(gateName);
    if ((0, $iEN9D.default).checkGate('jfp_magma_jira-report-incorrect-gates', {
        fireGateExposure: false
    })) {
        if (!(0, $iEN9D.default).isGateExists(gateName)) {
            const error = new $a00a9760f835bf20$var$ErrorPointingUp(`Feature gate ${gateName} does not exist`);
            (0, $aMh57.captureException)('FeatureGates.isGateExists', error);
            // eslint-disable-next-line no-console
            console.error(`Feature gate ${gateName} does not exist in StatSig. It was archived or hasn't been created yet`);
        }
    }
};
let $a00a9760f835bf20$var$shouldPerformGateExistenceCheck = true;
const $a00a9760f835bf20$export$ede4c4e7e9dad3f2 = (fn)=>{
    $a00a9760f835bf20$var$shouldPerformGateExistenceCheck = false;
    const result = fn();
    $a00a9760f835bf20$var$shouldPerformGateExistenceCheck = true;
    return result;
};
const $a00a9760f835bf20$var$featureGate = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $iEN9D.default).checkGate(gateName);
    (0, $gSA3s.addFeatureFlagAccessed)(gateName, value);
    if ($a00a9760f835bf20$var$shouldPerformGateExistenceCheck) $a00a9760f835bf20$var$checkIfGateExists(gateName);
    return value;
};
const $a00a9760f835bf20$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled) {
        if (globalVar.allowStatsigInitialisation_DO_NOT_USE) return $a00a9760f835bf20$var$featureGate(gateName);
        // StatSig is not allowed to initialise yet, returning false
        return false;
    }
    return $a00a9760f835bf20$var$featureGate(gateName);
};
const $a00a9760f835bf20$var$featureGateNoExposure = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $iEN9D.default).checkGate(gateName, {
        fireGateExposure: false
    });
    return value;
};
const $a00a9760f835bf20$export$c7fa95c00de0c062 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled) {
        if (globalVar.allowStatsigInitialisation_DO_NOT_USE) return $a00a9760f835bf20$var$featureGateNoExposure(gateName);
        // StatSig is not allowed to initialise yet, returning false
        return false;
    }
    return $a00a9760f835bf20$var$featureGateNoExposure(gateName);
};

});

parcelRegister("jxAdw", function(module, exports) {

$parcel$export(module.exports, "getAggDataFromInitialPageResponse", () => $35e5a783114047eb$export$684a3d6bfc11fb98);
$parcel$export(module.exports, "fetchIssueRelayDataViaDelegate", () => $35e5a783114047eb$export$452706dec84157f8);
$parcel$export(module.exports, "fetchIssueRelayData", () => $35e5a783114047eb$export$db01683e230c5bcb);
$parcel$export(module.exports, "fetchIssueAggData", () => $35e5a783114047eb$export$5b98d3bf45119270);
/**
 * @fileoverview abstracts the multiple ways of requesting the mainissueaggquery.
 * @todo Will be consolidated in https://jplat.atlassian.net/browse/JIV-19486
 */ /* eslint-disable prefer-object-spread */ // HOT-99984 Object spread in vendorless entries pulls in vendor.js

var $6yLM4 = parcelRequire("6yLM4");

var $eDXka = parcelRequire("eDXka");

var $ajjqZ = parcelRequire("ajjqZ");

var $la3vp = parcelRequire("la3vp");

var $eKonk = parcelRequire("eKonk");

var $eCZ6m = parcelRequire("eCZ6m");

var $4R6GH = parcelRequire("4R6GH");

var $2kcwv = parcelRequire("2kcwv");

var $i5Y40 = parcelRequire("i5Y40");
const $35e5a783114047eb$var$ISSUE_VIEW = 'ISSUE_VIEW';
const $35e5a783114047eb$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $35e5a783114047eb$var$getVariables = (cloudId, issueKey, siteAri)=>{
    const projectKey = issueKey.split('-')[0];
    return Object.assign({
        cloudId: cloudId,
        issueKey: issueKey,
        siteAri: siteAri,
        projectKey: projectKey
    }, (0, $6yLM4.getMainIssueViewAggQueryVariables)(issueKey));
};
const $35e5a783114047eb$export$684a3d6bfc11fb98 = ()=>(0, $i5Y40.default)((0, $eDXka.IssueViewFetchOperations).EARLY_FETCH_AGG);
const $35e5a783114047eb$export$452706dec84157f8 = (issueKey, cloudId, siteAri, delegate)=>{
    const { params: params } = (0, $la3vp.default);
    const variables = $35e5a783114047eb$var$getVariables(cloudId, issueKey, siteAri);
    const key = (0, $ajjqZ.getEarlyScriptPromiseKey)(params, variables);
    const promise = delegate.then((data)=>{
        // potential future optimizations:
        // * if scraped data can return stringified JSON, we can avoid the JSON.stringify here
        // * or if the relay cache contract accepts Map<String, Promise<JSONObject>> instead of Map<String, Promise<Response>>
        // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/103031/overview?commentId=5814184
        const jsonData = JSON.stringify(data);
        return new Response(jsonData);
    });
    (0, $ajjqZ.putEarlyScriptPromise)(key, promise);
};
const $35e5a783114047eb$export$db01683e230c5bcb = (issueKey, cloudId, siteAri)=>(0, $ajjqZ.earlyFetch)((0, $la3vp.default), $35e5a783114047eb$var$getVariables(cloudId, issueKey, siteAri), $35e5a783114047eb$export$6a9b8dd1339b1a17(), $35e5a783114047eb$var$ISSUE_VIEW);
const $35e5a783114047eb$export$6a9b8dd1339b1a17 = ()=>{
    const headers = [
        'JiraIssue',
        'projectStyle',
        'GlobalTimeTrackingSettings'
    ];
    if ((0, $4R6GH.fg)('smart-replies-system-setting')) headers.push('JiraApplicationProperties');
    if ((0, $4R6GH.fg)('issue-jiv-19838-chin-api-lookup-through-issue-key')) headers.push('JiraIssueSearch');
    return headers;
};
const $35e5a783114047eb$export$5b98d3bf45119270 = (issueKey, cloudId, siteAri)=>{
    const endpoint = (0, $eCZ6m.getAggEndpoint)((0, $la3vp.default).params);
    const variables = $35e5a783114047eb$var$getVariables(cloudId, issueKey, siteAri);
    const body = (0, $eCZ6m.getRequestBody)((0, $la3vp.default).params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)($35e5a783114047eb$var$ISSUE_VIEW);
    const options = {
        method: 'POST',
        body: body,
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': $35e5a783114047eb$export$6a9b8dd1339b1a17().toString(),
            ...capabilityHeader ? {
                [$35e5a783114047eb$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        }
    };
    return (0, $2kcwv.default)(endpoint, options);
};

});
parcelRegister("6yLM4", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $bbb83ac7c9853fc8$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $bbb83ac7c9853fc8$export$5896c8dc13246fe2);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5CSGy = parcelRequire("5CSGy");


var $ldyPw = parcelRequire("ldyPw");

var $lpLR9 = parcelRequire("lpLR9");

var $j8DrX = parcelRequire("j8DrX");

var $la3vp = parcelRequire("la3vp");

var $k2DRb = parcelRequire("k2DRb");

var $6tI1D = parcelRequire("6tI1D");
const $bbb83ac7c9853fc8$export$623cfa88de62fcd = ()=>{
    const providerVariables = (0, $la3vp.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
        isCompassComponentsEnabled: true,
        issueViewRelayConfigurationUrlFlag: (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel'),
        jsmSentimentCustomFieldFlag: true,
        isJPDPanelEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        issueViewRelayPriorityFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-priority'),
        // if assignee/reporter/user is true, it represents SingleSelectUserPicker being used
        issueViewRelayAssigneeFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg') || (0, $4R6GH.fg)('relay-migration-issue-fields-reporter') || (0, $4R6GH.fg)('relay-migration-issue-fields-user-fg'),
        issueViewRelayNumberFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-number'),
        issueViewRelaySprintFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-sprint'),
        issueViewRelayAttachmentsFlag: (0, $4R6GH.fg)('relay-migration-issue-view-attachments-'),
        issueViewRelayComponentsFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-components-select'),
        issueViewRelayResolutionFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-resolution'),
        issueViewRelaySingleLineTextFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-single-line-text-fg') || (0, $4R6GH.fg)('relay-migration-issue-fields-single-line-text-msg'),
        issueViewRelayParentFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayProjectFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-project-select'),
        issueViewRelayDateTimeFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-date-time-fg'),
        issueViewRelayMetadataFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-metadata'),
        issueViewDesignsPanelFlag: (0, $6s1PB.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        issueViewDesignsPanelProvidersFlag: (0, $4R6GH.fg)('only_show_designs_panel_with_design_providers'),
        isJPDDeliveryLinkTypeFilteringEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        issueViewRelayUrlFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-url'),
        issueViewRemoveSingleVersionFieldOptionsFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-issue-version'),
        issueViewRemoveCheckboxSelectFieldOptionsFlag: (0, $4R6GH.fg)('remove_issue_field_options_main_query'),
        issueViewRelaySummaryFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-summary'),
        issueViewRelayColorFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-color'),
        issueViewRelayHeaders: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayPeopleAndApproversFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-people-fg') || (0, $4R6GH.fg)('relay-migration-issue-fields-approvers-fg'),
        issueViewRelayTimeTrackingFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking'),
        issueViewRemoveRadioSelectFieldOptionsFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-radio'),
        customFieldConfigurationFlag: (0, $4R6GH.fg)('issue_view_field_config_edit'),
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $4R6GH.fg)('jcs_master_flag'),
        issueViewSmartRepliesSettingsFlag: (0, $4R6GH.fg)('smart-replies-system-setting') ?? false,
        isProactiveCommentSummaryPreferenceEnabled: (0, $4R6GH.fg)('proactive_comment_summary_feature_toggle'),
        issueViewStopFetchingJiraQueryIsAiEnabledForIssue: (0, $4R6GH.fg)('jiv-19647-stop-fetching-jira-isaienabledforissue'),
        crossflowBannerDismissedInAggFlag: (0, $4R6GH.fg)('jiv-19897-move-user-prefs-to-mainissueagg'),
        dateFieldsMessageEnabled: (0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation'),
        chinEmbedQueryToAgg: (0, $4R6GH.fg)('issue-jiv-19838-chin-api-lookup-through-issue-key'),
        issueViewActivityLayoutFieldEnabled: (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $6s1PB.expVal)('issue_view_field_reordering_in_context_panel', 'isReorderingFieldsEnabled', false),
        userThemePrefsInAggEnabled: (0, $4R6GH.fg)('custom-nav-theme-preferences-to-mainissueagg'),
        issueViewRedactionExperience: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewCoverExperimentEnabled: (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isSharedCoverEnabled', false) || (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isMiddleCoverEnabled', false),
        isPlaybooksEnabled: (0, $4R6GH.fg)('playbook_in_jsm_ga'),
        isPlaybooksEnabledForSpecificType: (0, $4R6GH.fg)('playbook_visibility_in_service_request'),
        assignToMeUserPreloaded: (0, $4R6GH.fg)('assign-to-me-user-preloaded-in-issue-view'),
        isAutomationDiscoverabilityEnabled: (0, $4R6GH.fg)('automation_discoverability_in_jsm'),
        issueViewChildIssuesPanelPerformance: (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance'),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query'),
        mentionedConfluencePageLinksPaginationFlag: !(0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query'),
        fetchConfluenceApplinksEarlyFlag: (0, $4R6GH.fg)('jiv-19890_fetch_confluence_applinks_early')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $bbb83ac7c9853fc8$var$getURLFromWindow = ()=>new URL(window.location.href);
const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = (issueKey, url = $bbb83ac7c9853fc8$var$getURLFromWindow())=>({
        ...$bbb83ac7c9853fc8$export$623cfa88de62fcd(),
        ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
        ...(0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? $bbb83ac7c9853fc8$export$e2c3bddbfc195841(url) : $bbb83ac7c9853fc8$export$afa6e4ae995b8926(),
        ...$bbb83ac7c9853fc8$var$getStorageBannerVariables(),
        ...$bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$bbb83ac7c9853fc8$var$getForgeSpecificVariables(),
        ...$bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables()
    });
const $bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if ((0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation')) {
        if (typeof window !== 'undefined') {
            const pathname = window.location.pathname;
            const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
            return {
                isInTimelineOrCalendarView: pattern.test(pathname)
            };
        }
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $bbb83ac7c9853fc8$var$getChildIssuesFieldIdsQueryVariables = ()=>{
    /**
	 * Default fields we're fetching in child issues:
	 * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
	 */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4R6GH.fg)('relay-migration-edit-worklog')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4R6GH.fg)('issue-jiv-20335-relay-progress-summary')) childIssuesFieldIds.push('status');
    // Include unused fields
    if (!(0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance')) childIssuesFieldIds.push('assignee', 'created', 'priority', 'summary', 'updated');
    return childIssuesFieldIds;
};
const $bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        // will have to put jql order by rank later
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        amountOfColumns: 500,
        namespace: 'CHILD_ISSUE_PANEL',
        fieldSetIds: [],
        shouldQueryFieldSetsById: false,
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        fieldSetsContext: {
            issueContext: {
                issueKey: issueKey
            }
        },
        filterId: null,
        viewId: null,
        childIssuesFieldIds: $bbb83ac7c9853fc8$var$getChildIssuesFieldIdsQueryVariables()
    });
const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>{
    const commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS)) || null;
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$export$e2c3bddbfc195841 = (url)=>{
    let commentTargetId = null;
    if ((0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server')) commentTargetId = (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url);
    else commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $lpLR9.default)((0, $j8DrX.default)).software === (0, $ldyPw.FREE_EDITION) && (0, $4R6GH.fg)('move_storage_banner_data_fetch_to_main_issue_agg'),
        offeringKey: (0, $5CSGy.getProductOfferingKeyOrThrow)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d), (0, $ldyPw.STANDARD_EDITION)),
        productKey: (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)
    });
const $bbb83ac7c9853fc8$var$getForgeSpecificVariables = ()=>{
    return {
        forgeInMainIssueAggFlag: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'),
        forgeTypes: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg') ? [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $k2DRb.UI_MODIFICATIONS_MODULE)
        ] : [],
        includeUserAccessForge: (0, $4R6GH.fg)('forge_query_include_user_access'),
        includeEgressOverridesForge: (0, $4R6GH.fg)('forge-ui-overrides-property-in-extension-list'),
        includeUserAccessEnabledForge: (0, $4R6GH.fg)('forge_query_include_user_access_enabled')
    };
};

});
parcelRegister("5CSGy", function(module, exports) {

$parcel$export(module.exports, "getProductOfferingKeyForProject", () => $75290a6120824a25$export$3ad43d25ded909ee);
$parcel$export(module.exports, "getProductOfferingKeyOrThrow", () => $75290a6120824a25$export$92c311d982d129d5);


var $1laI5 = parcelRequire("1laI5");
// Please don't use access these directly, try to implement these using common platform types such as below
const $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
    STANDARD_EDITION: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
    PREMIUM_EDITION: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
    UNLICENSED: null
};
const $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
    STANDARD_EDITION: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
    PREMIUM_EDITION: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
    UNLICENSED: null
};
const $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: '24656f1f-5c14-45ea-88ea-142b9c633661',
    STANDARD_EDITION: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
    PREMIUM_EDITION: '0c6683b4-4633-4673-beca-690d171de6a5',
    UNLICENSED: null
};
const $75290a6120824a25$export$581b2a05d59c1826 = (applicationKey, applicationEdition)=>{
    switch(applicationKey){
        case 0, $c06e1abca7c13910$export$1346c9aa3cbb477d:
            return $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61:
            return $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$202f50ee62667e32:
            return $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS[applicationEdition];
        // can support more products if implemented in future
        default:
            return null;
    }
};
const $75290a6120824a25$export$3ad43d25ded909ee = (project, edition)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(application, edition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${application} ${edition}`);
    return offeringKey;
};
const $75290a6120824a25$export$92c311d982d129d5 = (applicationKey, applicationEdition)=>{
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(applicationKey, applicationEdition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${applicationKey} ${applicationEdition}`);
    return offeringKey;
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("1laI5", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $39ed199f3e5d9f33$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $39ed199f3e5d9f33$export$1af4fd6f5c543149);

var $2vSU6 = parcelRequire("2vSU6");

const $39ed199f3e5d9f33$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $39ed199f3e5d9f33$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($39ed199f3e5d9f33$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $39ed199f3e5d9f33$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $39ed199f3e5d9f33$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $39ed199f3e5d9f33$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});
parcelRegister("2vSU6", function(module, exports) {

$parcel$export(module.exports, "CORE_PROJECT", () => $06cf3305fdeeefe0$export$4b79f735ed858abe);
$parcel$export(module.exports, "SOFTWARE_PROJECT", () => $06cf3305fdeeefe0$export$417275bac62d38d2);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT", () => $06cf3305fdeeefe0$export$9c9c9eaf8c092006);
$parcel$export(module.exports, "CUSTOMER_SERVICE_PROJECT", () => $06cf3305fdeeefe0$export$320625d747692f94);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT_ANALYTICS", () => $06cf3305fdeeefe0$export$d579a2a17bd742af);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PROJECT", () => $06cf3305fdeeefe0$export$e9fe9a39cc7f5103);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CORE_PROJECT", () => $06cf3305fdeeefe0$export$490d3686b662c315);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SOFTWARE_PROJECT", () => $06cf3305fdeeefe0$export$1242aa4e670b910e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT", () => $06cf3305fdeeefe0$export$bb467c3bc8f8620e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT", () => $06cf3305fdeeefe0$export$610dddac4d185bf8);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT", () => $06cf3305fdeeefe0$export$76412127fb3089d6);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ACTIVE", () => $06cf3305fdeeefe0$export$1b784afd50592d26);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ARCHIVED", () => $06cf3305fdeeefe0$export$c02e05d1bee347e5);
$parcel$export(module.exports, "COMPANY_MANAGED_PROJECT", () => $06cf3305fdeeefe0$export$6933c64814be01d9);
$parcel$export(module.exports, "TEAM_MANAGED_PROJECT", () => $06cf3305fdeeefe0$export$e569d8a168a85f48);
$parcel$export(module.exports, "ProjectStyle", () => $06cf3305fdeeefe0$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectStyleCmpNotation", () => $06cf3305fdeeefe0$export$bde8ccac2f23fd0f);
$parcel$export(module.exports, "PROJECT_TYPES", () => $06cf3305fdeeefe0$export$9482030bf1904b0);
$parcel$export(module.exports, "toProjectType", () => $06cf3305fdeeefe0$export$cfdcd9ead66e4329);
$parcel$export(module.exports, "convertToProjectType", () => $06cf3305fdeeefe0$export$aa8444e79de3a8b6);
$parcel$export(module.exports, "convertToJiraProjectType", () => $06cf3305fdeeefe0$export$5a8b6164d1baba87);
$parcel$export(module.exports, "toAnalyticsProjectType", () => $06cf3305fdeeefe0$export$5afb6f76b5af0167);
$parcel$export(module.exports, "projectTypeToCanonicalId", () => $06cf3305fdeeefe0$export$e25a1ee2478a61d6);

var $e4eHl = parcelRequire("e4eHl");

var $9pctO = parcelRequire("9pctO");

var $4R6GH = parcelRequire("4R6GH");
const $06cf3305fdeeefe0$export$4b79f735ed858abe = 'business';
const $06cf3305fdeeefe0$export$417275bac62d38d2 = 'software';
const $06cf3305fdeeefe0$export$9c9c9eaf8c092006 = 'service_desk';
const $06cf3305fdeeefe0$export$320625d747692f94 = 'customer_service';
const $06cf3305fdeeefe0$export$d579a2a17bd742af = 'serviceDesk';
const $06cf3305fdeeefe0$export$e9fe9a39cc7f5103 = 'product_discovery';
const $06cf3305fdeeefe0$export$490d3686b662c315 = 'BUSINESS';
const $06cf3305fdeeefe0$export$1242aa4e670b910e = 'SOFTWARE';
const $06cf3305fdeeefe0$export$bb467c3bc8f8620e = 'SERVICE_DESK';
const $06cf3305fdeeefe0$export$610dddac4d185bf8 = 'CUSTOMER_SERVICE';
const $06cf3305fdeeefe0$export$76412127fb3089d6 = 'PRODUCT_DISCOVERY';
const $06cf3305fdeeefe0$export$1b784afd50592d26 = 'ACTIVE';
const $06cf3305fdeeefe0$export$c02e05d1bee347e5 = 'ARCHIVED';
const $06cf3305fdeeefe0$export$8b2d8efe30253ab3 = 'DELETED';
const $06cf3305fdeeefe0$export$6933c64814be01d9 = 'COMPANY_MANAGED_PROJECT';
const $06cf3305fdeeefe0$export$e569d8a168a85f48 = 'TEAM_MANAGED_PROJECT';
const $06cf3305fdeeefe0$export$1f66f9f05afa05a8 = {
    CLASSIC: 'classic',
    NEXT_GEN: 'next-gen'
};
const $06cf3305fdeeefe0$export$bde8ccac2f23fd0f = {
    COMPANY_MANAGED: 'companyManaged',
    TEAM_MANAGED: 'teamManaged'
};
const $06cf3305fdeeefe0$export$9482030bf1904b0 = [
    $06cf3305fdeeefe0$export$4b79f735ed858abe,
    $06cf3305fdeeefe0$export$417275bac62d38d2,
    $06cf3305fdeeefe0$export$9c9c9eaf8c092006,
    $06cf3305fdeeefe0$export$320625d747692f94,
    $06cf3305fdeeefe0$export$e9fe9a39cc7f5103
];
const $06cf3305fdeeefe0$export$cfdcd9ead66e4329 = (value)=>$06cf3305fdeeefe0$export$9482030bf1904b0.find((projectType)=>projectType === value);
function $06cf3305fdeeefe0$export$aa8444e79de3a8b6(jiraProjectType) {
    if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(jiraProjectType){
        case $06cf3305fdeeefe0$export$490d3686b662c315:
            return $06cf3305fdeeefe0$export$4b79f735ed858abe;
        case $06cf3305fdeeefe0$export$1242aa4e670b910e:
            return $06cf3305fdeeefe0$export$417275bac62d38d2;
        case $06cf3305fdeeefe0$export$bb467c3bc8f8620e:
            return $06cf3305fdeeefe0$export$9c9c9eaf8c092006;
        case $06cf3305fdeeefe0$export$610dddac4d185bf8:
            return $06cf3305fdeeefe0$export$320625d747692f94;
        case $06cf3305fdeeefe0$export$76412127fb3089d6:
            return $06cf3305fdeeefe0$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
    switch(jiraProjectType){
        case $06cf3305fdeeefe0$export$490d3686b662c315:
            return $06cf3305fdeeefe0$export$4b79f735ed858abe;
        case $06cf3305fdeeefe0$export$1242aa4e670b910e:
            return $06cf3305fdeeefe0$export$417275bac62d38d2;
        case $06cf3305fdeeefe0$export$bb467c3bc8f8620e:
            return $06cf3305fdeeefe0$export$9c9c9eaf8c092006;
        case $06cf3305fdeeefe0$export$610dddac4d185bf8:
            return $06cf3305fdeeefe0$export$9c9c9eaf8c092006;
        case $06cf3305fdeeefe0$export$76412127fb3089d6:
            return $06cf3305fdeeefe0$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
}
function $06cf3305fdeeefe0$export$959e77de8f16519c(jiraProjectType) {
    // At the time of writing, convertToProjectType returned "Service Desk" not "Customer Service"; this is a workaround for that
    // With jcs_project_type_m3, convertToProjectType returns "Customer Service"
    if (jiraProjectType === $06cf3305fdeeefe0$export$610dddac4d185bf8 && !(0, $4R6GH.fg)('jcs_project_type_m3')) return (0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))($06cf3305fdeeefe0$export$320625d747692f94);
    const convertedProjectType = $06cf3305fdeeefe0$export$aa8444e79de3a8b6(jiraProjectType);
    if (convertedProjectType === $06cf3305fdeeefe0$export$9c9c9eaf8c092006) // 'Service Desk' is old branding
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))('Service Management');
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))(convertedProjectType);
}
const $06cf3305fdeeefe0$export$5a8b6164d1baba87 = (projectType)=>{
    switch(projectType){
        case $06cf3305fdeeefe0$export$417275bac62d38d2:
            return $06cf3305fdeeefe0$export$1242aa4e670b910e;
        case $06cf3305fdeeefe0$export$9c9c9eaf8c092006:
            return $06cf3305fdeeefe0$export$bb467c3bc8f8620e;
        case $06cf3305fdeeefe0$export$320625d747692f94:
            return $06cf3305fdeeefe0$export$610dddac4d185bf8;
        case $06cf3305fdeeefe0$export$4b79f735ed858abe:
            return $06cf3305fdeeefe0$export$490d3686b662c315;
        case $06cf3305fdeeefe0$export$e9fe9a39cc7f5103:
            return $06cf3305fdeeefe0$export$76412127fb3089d6;
        default:
            throw new Error(`Invalid ProjectType: ${projectType}`);
    }
};
const $06cf3305fdeeefe0$export$5afb6f76b5af0167 = (projectType)=>{
    switch(projectType){
        case $06cf3305fdeeefe0$export$9c9c9eaf8c092006:
            return $06cf3305fdeeefe0$export$d579a2a17bd742af;
        case $06cf3305fdeeefe0$export$320625d747692f94:
            return $06cf3305fdeeefe0$export$320625d747692f94;
        case $06cf3305fdeeefe0$export$417275bac62d38d2:
            return $06cf3305fdeeefe0$export$417275bac62d38d2;
        case $06cf3305fdeeefe0$export$e9fe9a39cc7f5103:
            return $06cf3305fdeeefe0$export$e9fe9a39cc7f5103;
        case $06cf3305fdeeefe0$export$4b79f735ed858abe:
            return $06cf3305fdeeefe0$export$4b79f735ed858abe;
        default:
            return undefined;
    }
};
const $06cf3305fdeeefe0$var$getFullProjectTypeKey = (style, projectType)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(`${style}_${projectType}`);
const $06cf3305fdeeefe0$export$241adb8e9255b93c = $06cf3305fdeeefe0$var$getFullProjectTypeKey($06cf3305fdeeefe0$export$1f66f9f05afa05a8.CLASSIC, $06cf3305fdeeefe0$export$4b79f735ed858abe);
const $06cf3305fdeeefe0$export$e932928a4bf564b7 = $06cf3305fdeeefe0$var$getFullProjectTypeKey($06cf3305fdeeefe0$export$1f66f9f05afa05a8.NEXT_GEN, $06cf3305fdeeefe0$export$417275bac62d38d2);
const $06cf3305fdeeefe0$export$e25a1ee2478a61d6 = (projectType)=>{
    switch(projectType){
        case $06cf3305fdeeefe0$export$4b79f735ed858abe:
            return 'jira-core';
        case $06cf3305fdeeefe0$export$417275bac62d38d2:
            return 'jira-software';
        case $06cf3305fdeeefe0$export$9c9c9eaf8c092006:
            return 'jira-servicedesk';
        case $06cf3305fdeeefe0$export$320625d747692f94:
            return 'jira-customer-service';
        case $06cf3305fdeeefe0$export$e9fe9a39cc7f5103:
            return 'jira-product-discovery';
        default:
            return 'jira';
    }
};

});
parcelRegister("e4eHl", function(module, exports) {

var $jqONe = parcelRequire("jqONe");

var $gDRiW = parcelRequire("gDRiW");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $a3dcd723e7b6ec61$var$camelCase = $gDRiW(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $jqONe(word) : word);
});
module.exports = $a3dcd723e7b6ec61$var$camelCase;

});
parcelRegister("jqONe", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");

var $26Zd8 = parcelRequire("26Zd8");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $e257d87e16229160$var$capitalize(string) {
    return $26Zd8($jJVtR(string).toLowerCase());
}
module.exports = $e257d87e16229160$var$capitalize;

});
parcelRegister("jJVtR", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e5eecec15b83da60$var$toString(value) {
    return value == null ? '' : $kHBB0(value);
}
module.exports = $e5eecec15b83da60$var$toString;

});
parcelRegister("kHBB0", function(module, exports) {

var $7Q2q6 = parcelRequire("7Q2q6");

var $1nIHN = parcelRequire("1nIHN");

var $8LQ84 = parcelRequire("8LQ84");

var $4faK3 = parcelRequire("4faK3");
/** Used as references for various `Number` constants. */ var $f124fc8b024c6e39$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f124fc8b024c6e39$var$symbolProto = $7Q2q6 ? $7Q2q6.prototype : undefined, $f124fc8b024c6e39$var$symbolToString = $f124fc8b024c6e39$var$symbolProto ? $f124fc8b024c6e39$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f124fc8b024c6e39$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($8LQ84(value)) // Recursively convert values (susceptible to call stack limits).
    return $1nIHN(value, $f124fc8b024c6e39$var$baseToString) + '';
    if ($4faK3(value)) return $f124fc8b024c6e39$var$symbolToString ? $f124fc8b024c6e39$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f124fc8b024c6e39$var$INFINITY ? '-0' : result;
}
module.exports = $f124fc8b024c6e39$var$baseToString;

});
parcelRegister("7Q2q6", function(module, exports) {

var $1V15E = parcelRequire("1V15E");
/** Built-in value references. */ var $5b4f444d1a92b2c1$var$Symbol = $1V15E.Symbol;
module.exports = $5b4f444d1a92b2c1$var$Symbol;

});
parcelRegister("1V15E", function(module, exports) {

var $69ksK = parcelRequire("69ksK");
/** Detect free variable `self`. */ var $165bf5ccb29036c7$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $165bf5ccb29036c7$var$root = $69ksK || $165bf5ccb29036c7$var$freeSelf || Function('return this')();
module.exports = $165bf5ccb29036c7$var$root;

});
parcelRegister("69ksK", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $47a374cebe73671f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $47a374cebe73671f$var$freeGlobal;

});



parcelRegister("1nIHN", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $101a9dff7e30cd17$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $101a9dff7e30cd17$var$arrayMap;

});

parcelRegister("8LQ84", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $662b264cb1d66f99$var$isArray = Array.isArray;
module.exports = $662b264cb1d66f99$var$isArray;

});

parcelRegister("4faK3", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $3170e5406b0b6450$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $3170e5406b0b6450$var$isSymbol(value) {
    return typeof value == 'symbol' || $fC1Kz(value) && $beQoo(value) == $3170e5406b0b6450$var$symbolTag;
}
module.exports = $3170e5406b0b6450$var$isSymbol;

});
parcelRegister("beQoo", function(module, exports) {

var $7Q2q6 = parcelRequire("7Q2q6");

var $2f8Jz = parcelRequire("2f8Jz");

var $kL92B = parcelRequire("kL92B");
/** `Object#toString` result references. */ var $82e9a49238c5defc$var$nullTag = '[object Null]', $82e9a49238c5defc$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $82e9a49238c5defc$var$symToStringTag = $7Q2q6 ? $7Q2q6.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $82e9a49238c5defc$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $82e9a49238c5defc$var$undefinedTag : $82e9a49238c5defc$var$nullTag;
    return $82e9a49238c5defc$var$symToStringTag && $82e9a49238c5defc$var$symToStringTag in Object(value) ? $2f8Jz(value) : $kL92B(value);
}
module.exports = $82e9a49238c5defc$var$baseGetTag;

});
parcelRegister("2f8Jz", function(module, exports) {

var $7Q2q6 = parcelRequire("7Q2q6");
/** Used for built-in method references. */ var $1a23c1db74016adf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a23c1db74016adf$var$hasOwnProperty = $1a23c1db74016adf$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a23c1db74016adf$var$nativeObjectToString = $1a23c1db74016adf$var$objectProto.toString;
/** Built-in value references. */ var $1a23c1db74016adf$var$symToStringTag = $7Q2q6 ? $7Q2q6.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $1a23c1db74016adf$var$getRawTag(value) {
    var isOwn = $1a23c1db74016adf$var$hasOwnProperty.call(value, $1a23c1db74016adf$var$symToStringTag), tag = value[$1a23c1db74016adf$var$symToStringTag];
    try {
        value[$1a23c1db74016adf$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $1a23c1db74016adf$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$1a23c1db74016adf$var$symToStringTag] = tag;
        else delete value[$1a23c1db74016adf$var$symToStringTag];
    }
    return result;
}
module.exports = $1a23c1db74016adf$var$getRawTag;

});

parcelRegister("kL92B", function(module, exports) {
/** Used for built-in method references. */ var $f1cf35c8feefaaea$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f1cf35c8feefaaea$var$nativeObjectToString = $f1cf35c8feefaaea$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f1cf35c8feefaaea$var$objectToString(value) {
    return $f1cf35c8feefaaea$var$nativeObjectToString.call(value);
}
module.exports = $f1cf35c8feefaaea$var$objectToString;

});


parcelRegister("fC1Kz", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b5dbc32d3c19b1c2$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $b5dbc32d3c19b1c2$var$isObjectLike;

});




parcelRegister("26Zd8", function(module, exports) {

var $1rEbX = parcelRequire("1rEbX");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $189b9f83d1612d05$var$upperFirst = $1rEbX('toUpperCase');
module.exports = $189b9f83d1612d05$var$upperFirst;

});
parcelRegister("1rEbX", function(module, exports) {

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $10d77d52b2e8a950$var$createCaseFirst(methodName) {
    return function(string) {
        string = $jJVtR(string);
        var strSymbols = $axH2S(string) ? $jx6Tp(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $gvFfr(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $10d77d52b2e8a950$var$createCaseFirst;

});
parcelRegister("gvFfr", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $c04f899d1b7f8e19$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $dM3Z8(array, start, end);
}
module.exports = $c04f899d1b7f8e19$var$castSlice;

});
parcelRegister("dM3Z8", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a072d969c753226d$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a072d969c753226d$var$baseSlice;

});


parcelRegister("axH2S", function(module, exports) {
/** Used to compose unicode character classes. */ var $7ace60643eb3219c$var$rsAstralRange = '\\ud800-\\udfff', $7ace60643eb3219c$var$rsComboMarksRange = '\\u0300-\\u036f', $7ace60643eb3219c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7ace60643eb3219c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7ace60643eb3219c$var$rsComboRange = $7ace60643eb3219c$var$rsComboMarksRange + $7ace60643eb3219c$var$reComboHalfMarksRange + $7ace60643eb3219c$var$rsComboSymbolsRange, $7ace60643eb3219c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7ace60643eb3219c$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $7ace60643eb3219c$var$reHasUnicode = RegExp('[' + $7ace60643eb3219c$var$rsZWJ + $7ace60643eb3219c$var$rsAstralRange + $7ace60643eb3219c$var$rsComboRange + $7ace60643eb3219c$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $7ace60643eb3219c$var$hasUnicode(string) {
    return $7ace60643eb3219c$var$reHasUnicode.test(string);
}
module.exports = $7ace60643eb3219c$var$hasUnicode;

});

parcelRegister("jx6Tp", function(module, exports) {

var $4eCQL = parcelRequire("4eCQL");

var $axH2S = parcelRequire("axH2S");

var $8fF25 = parcelRequire("8fF25");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e3867225a862eba7$var$stringToArray(string) {
    return $axH2S(string) ? $8fF25(string) : $4eCQL(string);
}
module.exports = $e3867225a862eba7$var$stringToArray;

});
parcelRegister("4eCQL", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $31569b03b9b8f45b$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $31569b03b9b8f45b$var$asciiToArray;

});

parcelRegister("8fF25", function(module, exports) {
/** Used to compose unicode character classes. */ var $601f8da7e17e76db$var$rsAstralRange = '\\ud800-\\udfff', $601f8da7e17e76db$var$rsComboMarksRange = '\\u0300-\\u036f', $601f8da7e17e76db$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $601f8da7e17e76db$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $601f8da7e17e76db$var$rsComboRange = $601f8da7e17e76db$var$rsComboMarksRange + $601f8da7e17e76db$var$reComboHalfMarksRange + $601f8da7e17e76db$var$rsComboSymbolsRange, $601f8da7e17e76db$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $601f8da7e17e76db$var$rsAstral = '[' + $601f8da7e17e76db$var$rsAstralRange + ']', $601f8da7e17e76db$var$rsCombo = '[' + $601f8da7e17e76db$var$rsComboRange + ']', $601f8da7e17e76db$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $601f8da7e17e76db$var$rsModifier = '(?:' + $601f8da7e17e76db$var$rsCombo + '|' + $601f8da7e17e76db$var$rsFitz + ')', $601f8da7e17e76db$var$rsNonAstral = '[^' + $601f8da7e17e76db$var$rsAstralRange + ']', $601f8da7e17e76db$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $601f8da7e17e76db$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $601f8da7e17e76db$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $601f8da7e17e76db$var$reOptMod = $601f8da7e17e76db$var$rsModifier + '?', $601f8da7e17e76db$var$rsOptVar = '[' + $601f8da7e17e76db$var$rsVarRange + ']?', $601f8da7e17e76db$var$rsOptJoin = '(?:' + $601f8da7e17e76db$var$rsZWJ + '(?:' + [
    $601f8da7e17e76db$var$rsNonAstral,
    $601f8da7e17e76db$var$rsRegional,
    $601f8da7e17e76db$var$rsSurrPair
].join('|') + ')' + $601f8da7e17e76db$var$rsOptVar + $601f8da7e17e76db$var$reOptMod + ')*', $601f8da7e17e76db$var$rsSeq = $601f8da7e17e76db$var$rsOptVar + $601f8da7e17e76db$var$reOptMod + $601f8da7e17e76db$var$rsOptJoin, $601f8da7e17e76db$var$rsSymbol = '(?:' + [
    $601f8da7e17e76db$var$rsNonAstral + $601f8da7e17e76db$var$rsCombo + '?',
    $601f8da7e17e76db$var$rsCombo,
    $601f8da7e17e76db$var$rsRegional,
    $601f8da7e17e76db$var$rsSurrPair,
    $601f8da7e17e76db$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $601f8da7e17e76db$var$reUnicode = RegExp($601f8da7e17e76db$var$rsFitz + '(?=' + $601f8da7e17e76db$var$rsFitz + ')|' + $601f8da7e17e76db$var$rsSymbol + $601f8da7e17e76db$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $601f8da7e17e76db$var$unicodeToArray(string) {
    return string.match($601f8da7e17e76db$var$reUnicode) || [];
}
module.exports = $601f8da7e17e76db$var$unicodeToArray;

});





parcelRegister("gDRiW", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $k2fTd = parcelRequire("k2fTd");

var $ggpda = parcelRequire("ggpda");
/** Used to compose unicode capture groups. */ var $c1d9a30c400b91cf$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $c1d9a30c400b91cf$var$reApos = RegExp($c1d9a30c400b91cf$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $c1d9a30c400b91cf$var$createCompounder(callback) {
    return function(string) {
        return $2YkAc($ggpda($k2fTd(string).replace($c1d9a30c400b91cf$var$reApos, '')), callback, '');
    };
}
module.exports = $c1d9a30c400b91cf$var$createCompounder;

});
parcelRegister("2YkAc", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $22a126ad13a0dfdf$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $22a126ad13a0dfdf$var$arrayReduce;

});

parcelRegister("k2fTd", function(module, exports) {

var $7cV3a = parcelRequire("7cV3a");

var $jJVtR = parcelRequire("jJVtR");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $e96051e0fc0137e8$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $e96051e0fc0137e8$var$rsComboMarksRange = '\\u0300-\\u036f', $e96051e0fc0137e8$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $e96051e0fc0137e8$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $e96051e0fc0137e8$var$rsComboRange = $e96051e0fc0137e8$var$rsComboMarksRange + $e96051e0fc0137e8$var$reComboHalfMarksRange + $e96051e0fc0137e8$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $e96051e0fc0137e8$var$rsCombo = '[' + $e96051e0fc0137e8$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $e96051e0fc0137e8$var$reComboMark = RegExp($e96051e0fc0137e8$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $e96051e0fc0137e8$var$deburr(string) {
    string = $jJVtR(string);
    return string && string.replace($e96051e0fc0137e8$var$reLatin, $7cV3a).replace($e96051e0fc0137e8$var$reComboMark, '');
}
module.exports = $e96051e0fc0137e8$var$deburr;

});
parcelRegister("7cV3a", function(module, exports) {

var $h2dNA = parcelRequire("h2dNA");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $53f5e859f582a85e$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $53f5e859f582a85e$var$deburrLetter = $h2dNA($53f5e859f582a85e$var$deburredLetters);
module.exports = $53f5e859f582a85e$var$deburrLetter;

});
parcelRegister("h2dNA", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $c66d53bccdb9e3b5$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $c66d53bccdb9e3b5$var$basePropertyOf;

});



parcelRegister("ggpda", function(module, exports) {

var $kyS0O = parcelRequire("kyS0O");

var $lFsk0 = parcelRequire("lFsk0");

var $jJVtR = parcelRequire("jJVtR");

var $16FRB = parcelRequire("16FRB");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $bd71b26e4cb13be1$var$words(string, pattern, guard) {
    string = $jJVtR(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $lFsk0(string) ? $16FRB(string) : $kyS0O(string);
    return string.match(pattern) || [];
}
module.exports = $bd71b26e4cb13be1$var$words;

});
parcelRegister("kyS0O", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $ef80e14c250bc250$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $ef80e14c250bc250$var$asciiWords(string) {
    return string.match($ef80e14c250bc250$var$reAsciiWord) || [];
}
module.exports = $ef80e14c250bc250$var$asciiWords;

});

parcelRegister("lFsk0", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $fc63656a3aba8cc4$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $fc63656a3aba8cc4$var$hasUnicodeWord(string) {
    return $fc63656a3aba8cc4$var$reHasUnicodeWord.test(string);
}
module.exports = $fc63656a3aba8cc4$var$hasUnicodeWord;

});

parcelRegister("16FRB", function(module, exports) {
/** Used to compose unicode character classes. */ var $0ce6d33419ec5717$var$rsAstralRange = '\\ud800-\\udfff', $0ce6d33419ec5717$var$rsComboMarksRange = '\\u0300-\\u036f', $0ce6d33419ec5717$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0ce6d33419ec5717$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0ce6d33419ec5717$var$rsComboRange = $0ce6d33419ec5717$var$rsComboMarksRange + $0ce6d33419ec5717$var$reComboHalfMarksRange + $0ce6d33419ec5717$var$rsComboSymbolsRange, $0ce6d33419ec5717$var$rsDingbatRange = '\\u2700-\\u27bf', $0ce6d33419ec5717$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $0ce6d33419ec5717$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $0ce6d33419ec5717$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $0ce6d33419ec5717$var$rsPunctuationRange = '\\u2000-\\u206f', $0ce6d33419ec5717$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $0ce6d33419ec5717$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $0ce6d33419ec5717$var$rsVarRange = '\\ufe0e\\ufe0f', $0ce6d33419ec5717$var$rsBreakRange = $0ce6d33419ec5717$var$rsMathOpRange + $0ce6d33419ec5717$var$rsNonCharRange + $0ce6d33419ec5717$var$rsPunctuationRange + $0ce6d33419ec5717$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $0ce6d33419ec5717$var$rsApos = "['\u2019]", $0ce6d33419ec5717$var$rsBreak = '[' + $0ce6d33419ec5717$var$rsBreakRange + ']', $0ce6d33419ec5717$var$rsCombo = '[' + $0ce6d33419ec5717$var$rsComboRange + ']', $0ce6d33419ec5717$var$rsDigits = '\\d+', $0ce6d33419ec5717$var$rsDingbat = '[' + $0ce6d33419ec5717$var$rsDingbatRange + ']', $0ce6d33419ec5717$var$rsLower = '[' + $0ce6d33419ec5717$var$rsLowerRange + ']', $0ce6d33419ec5717$var$rsMisc = '[^' + $0ce6d33419ec5717$var$rsAstralRange + $0ce6d33419ec5717$var$rsBreakRange + $0ce6d33419ec5717$var$rsDigits + $0ce6d33419ec5717$var$rsDingbatRange + $0ce6d33419ec5717$var$rsLowerRange + $0ce6d33419ec5717$var$rsUpperRange + ']', $0ce6d33419ec5717$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0ce6d33419ec5717$var$rsModifier = '(?:' + $0ce6d33419ec5717$var$rsCombo + '|' + $0ce6d33419ec5717$var$rsFitz + ')', $0ce6d33419ec5717$var$rsNonAstral = '[^' + $0ce6d33419ec5717$var$rsAstralRange + ']', $0ce6d33419ec5717$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0ce6d33419ec5717$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0ce6d33419ec5717$var$rsUpper = '[' + $0ce6d33419ec5717$var$rsUpperRange + ']', $0ce6d33419ec5717$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0ce6d33419ec5717$var$rsMiscLower = '(?:' + $0ce6d33419ec5717$var$rsLower + '|' + $0ce6d33419ec5717$var$rsMisc + ')', $0ce6d33419ec5717$var$rsMiscUpper = '(?:' + $0ce6d33419ec5717$var$rsUpper + '|' + $0ce6d33419ec5717$var$rsMisc + ')', $0ce6d33419ec5717$var$rsOptContrLower = '(?:' + $0ce6d33419ec5717$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $0ce6d33419ec5717$var$rsOptContrUpper = '(?:' + $0ce6d33419ec5717$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $0ce6d33419ec5717$var$reOptMod = $0ce6d33419ec5717$var$rsModifier + '?', $0ce6d33419ec5717$var$rsOptVar = '[' + $0ce6d33419ec5717$var$rsVarRange + ']?', $0ce6d33419ec5717$var$rsOptJoin = '(?:' + $0ce6d33419ec5717$var$rsZWJ + '(?:' + [
    $0ce6d33419ec5717$var$rsNonAstral,
    $0ce6d33419ec5717$var$rsRegional,
    $0ce6d33419ec5717$var$rsSurrPair
].join('|') + ')' + $0ce6d33419ec5717$var$rsOptVar + $0ce6d33419ec5717$var$reOptMod + ')*', $0ce6d33419ec5717$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $0ce6d33419ec5717$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $0ce6d33419ec5717$var$rsSeq = $0ce6d33419ec5717$var$rsOptVar + $0ce6d33419ec5717$var$reOptMod + $0ce6d33419ec5717$var$rsOptJoin, $0ce6d33419ec5717$var$rsEmoji = '(?:' + [
    $0ce6d33419ec5717$var$rsDingbat,
    $0ce6d33419ec5717$var$rsRegional,
    $0ce6d33419ec5717$var$rsSurrPair
].join('|') + ')' + $0ce6d33419ec5717$var$rsSeq;
/** Used to match complex or compound words. */ var $0ce6d33419ec5717$var$reUnicodeWord = RegExp([
    $0ce6d33419ec5717$var$rsUpper + '?' + $0ce6d33419ec5717$var$rsLower + '+' + $0ce6d33419ec5717$var$rsOptContrLower + '(?=' + [
        $0ce6d33419ec5717$var$rsBreak,
        $0ce6d33419ec5717$var$rsUpper,
        '$'
    ].join('|') + ')',
    $0ce6d33419ec5717$var$rsMiscUpper + '+' + $0ce6d33419ec5717$var$rsOptContrUpper + '(?=' + [
        $0ce6d33419ec5717$var$rsBreak,
        $0ce6d33419ec5717$var$rsUpper + $0ce6d33419ec5717$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $0ce6d33419ec5717$var$rsUpper + '?' + $0ce6d33419ec5717$var$rsMiscLower + '+' + $0ce6d33419ec5717$var$rsOptContrLower,
    $0ce6d33419ec5717$var$rsUpper + '+' + $0ce6d33419ec5717$var$rsOptContrUpper,
    $0ce6d33419ec5717$var$rsOrdUpper,
    $0ce6d33419ec5717$var$rsOrdLower,
    $0ce6d33419ec5717$var$rsDigits,
    $0ce6d33419ec5717$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $0ce6d33419ec5717$var$unicodeWords(string) {
    return string.match($0ce6d33419ec5717$var$reUnicodeWord) || [];
}
module.exports = $0ce6d33419ec5717$var$unicodeWords;

});




parcelRegister("9pctO", function(module, exports) {

var $gDRiW = parcelRequire("gDRiW");

var $26Zd8 = parcelRequire("26Zd8");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $6d90211df59daf17$var$startCase = $gDRiW(function(result, word, index) {
    return result + (index ? ' ' : '') + $26Zd8(word);
});
module.exports = $6d90211df59daf17$var$startCase;

});




parcelRegister("ldyPw", function(module, exports) {

$parcel$export(module.exports, "FREE_EDITION", () => $8bc91341c0daedeb$export$e69af2c4378638a2);
$parcel$export(module.exports, "STANDARD_EDITION", () => $8bc91341c0daedeb$export$7bc7dd5faba7ad6b);
$parcel$export(module.exports, "PREMIUM_EDITION", () => $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7);
$parcel$export(module.exports, "UNLICENSED", () => $8bc91341c0daedeb$export$5747d23113da6aa6);
$parcel$export(module.exports, "FREE_EDITION_KEY", () => $8bc91341c0daedeb$export$c8c756d9ef774404);
$parcel$export(module.exports, "STANDARD_EDITION_KEY", () => $8bc91341c0daedeb$export$6ad005c3d13398a0);
$parcel$export(module.exports, "PREMIUM_EDITION_KEY", () => $8bc91341c0daedeb$export$ee574a74f490a9e8);
$parcel$export(module.exports, "editionKeyToEdition", () => $8bc91341c0daedeb$export$21d25cf944084a5e);
$parcel$export(module.exports, "editionToEditionKey", () => $8bc91341c0daedeb$export$564d24f5605eb83d);
$parcel$export(module.exports, "populateApplicationEditions", () => $8bc91341c0daedeb$export$6bdd11dc05a96fbd);
$parcel$export(module.exports, "getEdition", () => $8bc91341c0daedeb$export$acf25cbc735b9b90);
$parcel$export(module.exports, "getEditionForProject", () => $8bc91341c0daedeb$export$7f5fd5f8e6705012);
$parcel$export(module.exports, "toEdition", () => $8bc91341c0daedeb$export$59f6e933a5e0096b);

var $efvDm = parcelRequire("efvDm");
const $8bc91341c0daedeb$export$e69af2c4378638a2 = 'FREE_EDITION';
const $8bc91341c0daedeb$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $8bc91341c0daedeb$export$5747d23113da6aa6 = 'UNLICENSED';
const $8bc91341c0daedeb$export$c8c756d9ef774404 = 'free';
const $8bc91341c0daedeb$export$6ad005c3d13398a0 = 'standard';
const $8bc91341c0daedeb$export$ee574a74f490a9e8 = 'premium';
const $8bc91341c0daedeb$export$21d25cf944084a5e = (editionShort)=>{
    if (editionShort === $8bc91341c0daedeb$export$c8c756d9ef774404) return $8bc91341c0daedeb$export$e69af2c4378638a2;
    if (editionShort === $8bc91341c0daedeb$export$6ad005c3d13398a0) return $8bc91341c0daedeb$export$7bc7dd5faba7ad6b;
    if (editionShort === $8bc91341c0daedeb$export$ee574a74f490a9e8) return $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7;
    return $8bc91341c0daedeb$export$5747d23113da6aa6;
};
const $8bc91341c0daedeb$export$564d24f5605eb83d = (edition)=>{
    switch(edition){
        case $8bc91341c0daedeb$export$e69af2c4378638a2:
            return $8bc91341c0daedeb$export$c8c756d9ef774404;
        case $8bc91341c0daedeb$export$7bc7dd5faba7ad6b:
            return $8bc91341c0daedeb$export$6ad005c3d13398a0;
        case $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7:
            return $8bc91341c0daedeb$export$ee574a74f490a9e8;
        default:
            return undefined;
    }
};
const $8bc91341c0daedeb$export$6bdd11dc05a96fbd = (overrides = {}, defaultEdition = $8bc91341c0daedeb$export$5747d23113da6aa6)=>({
        core: defaultEdition,
        software: defaultEdition,
        serviceDesk: defaultEdition,
        customerService: defaultEdition,
        productDiscovery: defaultEdition,
        ...overrides
    });
const $8bc91341c0daedeb$export$acf25cbc735b9b90 = (application, applicationEditions)=>{
    switch(application){
        case 0, $efvDm.JIRA_CORE:
            return applicationEditions.core;
        case 0, $efvDm.JIRA_SOFTWARE:
            return applicationEditions.software;
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return applicationEditions.productDiscovery;
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return applicationEditions.serviceDesk;
        case 0, $efvDm.JIRA_CUSTOMER_SERVICE:
            return applicationEditions.customerService;
        default:
            throw new Error(`Unrecognised application: ${application}`);
    }
};
const $8bc91341c0daedeb$export$7f5fd5f8e6705012 = (projectType, applicationEditions)=>{
    const application = (0, $efvDm.getApplicationForProject)(projectType);
    return $8bc91341c0daedeb$export$acf25cbc735b9b90(application, applicationEditions);
};
const $8bc91341c0daedeb$export$59f6e933a5e0096b = (edition)=>{
    switch(edition){
        case $8bc91341c0daedeb$export$e69af2c4378638a2:
            return $8bc91341c0daedeb$export$e69af2c4378638a2;
        case $8bc91341c0daedeb$export$7bc7dd5faba7ad6b:
            return $8bc91341c0daedeb$export$7bc7dd5faba7ad6b;
        case $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7:
            return $8bc91341c0daedeb$export$3fd0bbb8c68dc4c7;
        case $8bc91341c0daedeb$export$5747d23113da6aa6:
        default:
            return $8bc91341c0daedeb$export$5747d23113da6aa6;
    }
};

});
parcelRegister("efvDm", function(module, exports) {

$parcel$export(module.exports, "JIRA_PORTFOLIO", () => $26f24a4ad795a5c5$export$29c4c091cb388ff0);
$parcel$export(module.exports, "JIRA_SERVICE_DESK", () => $26f24a4ad795a5c5$export$3afc372bb8c4538c);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE", () => $26f24a4ad795a5c5$export$19eb54cb466391c5);
$parcel$export(module.exports, "JIRA_SOFTWARE", () => $26f24a4ad795a5c5$export$ad9850d60736acbb);
$parcel$export(module.exports, "JIRA_CORE", () => $26f24a4ad795a5c5$export$66e37ea59188c0b8);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY", () => $26f24a4ad795a5c5$export$b6c5b3e2284b683b);
$parcel$export(module.exports, "getApplicationForProject", () => $26f24a4ad795a5c5$export$3804df50ba7ca359);
$parcel$export(module.exports, "getApplicationKeyForProject", () => $26f24a4ad795a5c5$export$70d16cc42a798666);

var $2vSU6 = parcelRequire("2vSU6");
const $26f24a4ad795a5c5$export$29c4c091cb388ff0 = 'JIRA_PORTFOLIO';
const $26f24a4ad795a5c5$export$3afc372bb8c4538c = 'JIRA_SERVICE_DESK';
const $26f24a4ad795a5c5$export$19eb54cb466391c5 = 'JIRA_CUSTOMER_SERVICE';
const $26f24a4ad795a5c5$export$ad9850d60736acbb = 'JIRA_SOFTWARE';
const $26f24a4ad795a5c5$export$66e37ea59188c0b8 = 'JIRA_CORE';
const $26f24a4ad795a5c5$export$b6c5b3e2284b683b = 'JIRA_PRODUCT_DISCOVERY';
const $26f24a4ad795a5c5$export$3804df50ba7ca359 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return $26f24a4ad795a5c5$export$66e37ea59188c0b8;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return $26f24a4ad795a5c5$export$b6c5b3e2284b683b;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return $26f24a4ad795a5c5$export$ad9850d60736acbb;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $26f24a4ad795a5c5$export$3afc372bb8c4538c;
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return $26f24a4ad795a5c5$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};
const $26f24a4ad795a5c5$export$70d16cc42a798666 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return $26f24a4ad795a5c5$export$66e37ea59188c0b8;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return $26f24a4ad795a5c5$export$b6c5b3e2284b683b;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return $26f24a4ad795a5c5$export$ad9850d60736acbb;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $26f24a4ad795a5c5$export$3afc372bb8c4538c;
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return $26f24a4ad795a5c5$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};

});


parcelRegister("lpLR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd5ccf7391bea73$export$2e2bcd8739ae039);

var $ldyPw = parcelRequire("ldyPw");
const $6fd5ccf7391bea73$var$parseTenantContextEdition = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'f':
            return 0, $ldyPw.FREE_EDITION;
        case 's':
            return 0, $ldyPw.STANDARD_EDITION;
        case 'p':
            return 0, $ldyPw.PREMIUM_EDITION;
        default:
            return 0, $ldyPw.UNLICENSED;
    }
};
const $6fd5ccf7391bea73$var$parseTenantContextEditions = (tenantContextEditions)=>(0, $ldyPw.populateApplicationEditions)({
        core: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-core']),
        software: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-software']),
        serviceDesk: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-servicedesk']),
        customerService: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-customer-service']),
        productDiscovery: $6fd5ccf7391bea73$var$parseTenantContextEdition(tenantContextEditions['jira-product-discovery'])
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6fd5ccf7391bea73$export$2e2bcd8739ae039 = (getMetaImpl)=>{
    try {
        const tenantContextEditions = JSON.parse(getMetaImpl('ajs-product-editions') || '{}');
        return $6fd5ccf7391bea73$var$parseTenantContextEditions(tenantContextEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return (0, $ldyPw.populateApplicationEditions)();
    }
};

});

parcelRegister("la3vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1e3365ed212162$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30ecfd6a14618c6cd0a6415a387a94d4>>
 * @relayHash b13fd82af1dc23037d7129d7c1bfa1e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afc350d7212e12c093e9ab304f97dc326e9df0b1db2904421c8f193e2fd4a34b

var $beHGE = parcelRequire("beHGE");

var $5oQtH = parcelRequire("5oQtH");

var $aD4zJ = parcelRequire("aD4zJ");

var $5FIjM = parcelRequire("5FIjM");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $ju8GE = parcelRequire("ju8GE");

var $5YQLv = parcelRequire("5YQLv");

var $asT4T = parcelRequire("asT4T");

var $hBTVA = parcelRequire("hBTVA");

var $9OzGv = parcelRequire("9OzGv");

var $33qJ8 = parcelRequire("33qJ8");

var $h6nNu = parcelRequire("h6nNu");

var $5pSyb = parcelRequire("5pSyb");

var $cKVMM = parcelRequire("cKVMM");

var $5mEVc = parcelRequire("5mEVc");

var $ef20f = parcelRequire("ef20f");

var $84KW9 = parcelRequire("84KW9");

var $3wM25 = parcelRequire("3wM25");

var $ipyFC = parcelRequire("ipyFC");

var $kT0rw = parcelRequire("kT0rw");

var $d6bux = parcelRequire("d6bux");

var $bdIYk = parcelRequire("bdIYk");

var $hjJTo = parcelRequire("hjJTo");

var $jDqgH = parcelRequire("jDqgH");

var $iwPkC = parcelRequire("iwPkC");

var $krohK = parcelRequire("krohK");

var $6NR1m = parcelRequire("6NR1m");

var $3E2yq = parcelRequire("3E2yq");

var $6sYK2 = parcelRequire("6sYK2");

var $fmbEw = parcelRequire("fmbEw");

var $hSNvs = parcelRequire("hSNvs");

var $qPPmw = parcelRequire("qPPmw");

var $8Y9hN = parcelRequire("8Y9hN");

var $4yni1 = parcelRequire("4yni1");

var $ejqaS = parcelRequire("ejqaS");

var $eXeEx = parcelRequire("eXeEx");

var $hBvdF = parcelRequire("hBvdF");
const $7d1e3365ed212162$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "afc350d7212e12c093e9ab304f97dc326e9df0b1db2904421c8f193e2fd4a34b",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "jira",
                        "issueByKey",
                        "attachments"
                    ]
                }
            ]
        },
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationconfigurationurlrelayprovider": (0, $5YQLv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $5FIjM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $h6nNu.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, $d6bux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, $8Y9hN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, $9OzGv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider": (0, $33qJ8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, $kT0rw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider": (0, $3wM25.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, $5pSyb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, $84KW9.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider": (0, $qPPmw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider": (0, $hjJTo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, $6NR1m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider": (0, $ipyFC.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider": (0, $iwPkC.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider": (0, $bdIYk.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider": (0, $asT4T.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider": (0, $6sYK2.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, $hBTVA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider": (0, $jDqgH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider": (0, $4yni1.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, $cKVMM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, $eXeEx.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, $3E2yq.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, $ejqaS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, $5mEVc.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $beHGE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, $ef20f.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, $krohK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $hSNvs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, $fmbEw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrconeeventimprovementsenabledrelayprovider": (0, $ju8GE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewssrperfm2isenabledrelayprovider": (0, $aD4zJ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default)
        }
    }
};
var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;

});
parcelRegister("beHGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77216947a3d05a6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e77216947a3d05a6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("5oQtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $63783baa7e252f12$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $63783baa7e252f12$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
    }
};

});

parcelRegister("aD4zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c400ce5d227192$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $68c400ce5d227192$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    }
};

});

parcelRegister("5FIjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20c48eec5732675$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c20c48eec5732675$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'));
    }
};

});

parcelRegister("5qm7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $124cec54bee44ed1$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $124cec54bee44ed1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_field_refactor');
    }
};

});

parcelRegister("l8ssf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6503957c800342c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e6503957c800342c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_flag_fix');
    }
};

});

parcelRegister("dttgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b98ab24c97dab4$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;

});

parcelRegister("adKYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff52f025ed33d5fc$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jira_list_merged_column_gate');
    }
};
var $ff52f025ed33d5fc$export$2e2bcd8739ae039 = $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider;

});

parcelRegister("iLxt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35fdb8bdb84235d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('nin_multi_group_picker_cell');
    }
};
var $c35fdb8bdb84235d$export$2e2bcd8739ae039 = $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider;

});

parcelRegister("ju8GE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22f95d64a2848da$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f22f95d64a2848da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('one_event_improvements_1');
    }
};

});

parcelRegister("5YQLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc7b1249165c5cc$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $8cc7b1249165c5cc$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel');
    }
};

});

parcelRegister("asT4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $587bfe0115b03c48$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $587bfe0115b03c48$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-approvers-fg');
    }
};

});

parcelRegister("hBTVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $317518afb86d429d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $317518afb86d429d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg');
    }
};

});

parcelRegister("9OzGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a7d680b4f7aa31$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-checkbox-select');
    }
};

});

parcelRegister("33qJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a066af595fad6e31$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $a066af595fad6e31$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-components-select');
    }
};

});

parcelRegister("h6nNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea05c28112074d6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $4R6GH.fg)('issue_view_field_config_edit');
    }
};
var $4ea05c28112074d6$export$2e2bcd8739ae039 = $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("5pSyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b71e3be8dfea7a$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-group-picker-sg');
    }
};

});

parcelRegister("cKVMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7153ac791d0f4b40$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("5mEVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba981d8b012adb8$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("ef20f", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dac75eea754d44b$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("84KW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c1aa824cd21c11$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-group-picker-fg');
    }
};

});

parcelRegister("3wM25", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f763f7ab8915ff$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $b4f763f7ab8915ff$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg');
    }
};

});

parcelRegister("ipyFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9ca17802c9cba7$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $de9ca17802c9cba7$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg');
    }
};

});

parcelRegister("kT0rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdff8c37120a188$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-original-estimate');
    }
};

});

parcelRegister("d6bux", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9e6f2a33f8172f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("bdIYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3216c683ee81b04$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $d3216c683ee81b04$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-people-fg');
    }
};

});

parcelRegister("hjJTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a929bbaac9d588$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $c8a929bbaac9d588$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-radio');
    }
};

});

parcelRegister("jDqgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $144d769a6379ff4e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $144d769a6379ff4e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-reporter');
    }
};

});

parcelRegister("iwPkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb870d58c524b581$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $cb870d58c524b581$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg');
    }
};

});

parcelRegister("krohK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee92d752c596813$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $7ee92d752c596813$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution');
    }
};

});

parcelRegister("6NR1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $851058f7192cd7ee$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-line-text-fg');
    }
};

});

parcelRegister("3E2yq", function(module, exports) {

$parcel$export(module.exports, "default", () => $847675c0acc8db9e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("6sYK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab91eec7ddbe8f3e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ab91eec7ddbe8f3e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-single-line-text-msg');
    }
};

});

parcelRegister("fmbEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb9a48dda30cc33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution') || (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("hSNvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $efddcea96d8714d0$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("qPPmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0786657423f5409$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $e0786657423f5409$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-team-field-next');
    }
};

});

parcelRegister("8Y9hN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6d2edf34e99bba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking');
    }
};

});

parcelRegister("4yni1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5243bedb3fa46125$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5243bedb3fa46125$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-user-fg');
    }
};

});

parcelRegister("ejqaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7323747132cbc58$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c7323747132cbc58$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("eXeEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfad9d58e7d968c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("hBvdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de224b7b5e8adbe$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5de224b7b5e8adbe$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('thor_colourful_single_select_milestone2_gate');
    }
};

});


parcelRegister("k2DRb", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $e80aa4d4aac5b0dc$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $e80aa4d4aac5b0dc$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $e80aa4d4aac5b0dc$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $e80aa4d4aac5b0dc$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $e80aa4d4aac5b0dc$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $e80aa4d4aac5b0dc$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $e80aa4d4aac5b0dc$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $e80aa4d4aac5b0dc$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $e80aa4d4aac5b0dc$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $e80aa4d4aac5b0dc$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $e80aa4d4aac5b0dc$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $e80aa4d4aac5b0dc$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $e80aa4d4aac5b0dc$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $e80aa4d4aac5b0dc$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$51ab2784839ce348);
const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
const $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $e80aa4d4aac5b0dc$export$cfb15d127f20a01f = 'jira:sprintAction';
const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992 = 'jira:command';
const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
const $e80aa4d4aac5b0dc$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
    $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e,
    $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992,
    $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11,
    $e80aa4d4aac5b0dc$export$cfb15d127f20a01f,
    $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
    $e80aa4d4aac5b0dc$export$259bab989b0129d0,
    $e80aa4d4aac5b0dc$export$75f224942f595e13,
    $e80aa4d4aac5b0dc$export$7e2136b4285d29f5,
    $e80aa4d4aac5b0dc$export$ba0968f9752844,
    $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
    $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
    $e80aa4d4aac5b0dc$export$811b7f067a43b422,
    $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
    $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
    $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
    $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58,
    $e80aa4d4aac5b0dc$export$151b03356f566603,
    $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
    $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
    $e80aa4d4aac5b0dc$export$353acf28daa75c79,
    $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
    $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
    $e80aa4d4aac5b0dc$export$5592ab836d562168,
    $e80aa4d4aac5b0dc$export$842eb4236828ac9,
    $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
    $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
    $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
];
const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$e80aa4d4aac5b0dc$export$a48dade1864725a
};
const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
        ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;

});

parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});
parcelRegister("gKZoD", function(module, exports) {

$parcel$export(module.exports, "di", () => $c330913db3f18753$export$479d1ccc5f2ab701);

var $kuH7D = parcelRequire("kuH7D");

var $baQns = parcelRequire("baQns");
function $c330913db3f18753$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $kuH7D.Context)._currentRenderer2 && (0, $kuH7D.Context)._currentValue2 || // grab value from default renderer
    (0, $kuH7D.Context)._currentValue || (0, $baQns.globalDi);
    return getDependencies(deps, target);
}

});
parcelRegister("kuH7D", function(module, exports) {

$parcel$export(module.exports, "Context", () => $eeb80f296af213d3$export$841858b892ce1f4c);

var $5uXOq = parcelRequire("5uXOq");

var $baQns = parcelRequire("baQns");
const $eeb80f296af213d3$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    getDependencies: (0, $baQns.globalDi).getDependencies
});

});
parcelRegister("5uXOq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("boLIc"));

});
parcelRegister("boLIc", function(module, exports) {

$parcel$export(module.exports, "Children", () => $84c6f22c1328fe7e$export$dca3b0875bd9a954, (v) => $84c6f22c1328fe7e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $84c6f22c1328fe7e$export$16fa2f45be04daa8, (v) => $84c6f22c1328fe7e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $84c6f22c1328fe7e$export$ffb0004e005737fa, (v) => $84c6f22c1328fe7e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $84c6f22c1328fe7e$export$e2c29f18771995cb, (v) => $84c6f22c1328fe7e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $84c6f22c1328fe7e$export$221d75b3f55bb0bd, (v) => $84c6f22c1328fe7e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $84c6f22c1328fe7e$export$5f8d39834fd61797, (v) => $84c6f22c1328fe7e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $84c6f22c1328fe7e$export$74bf444e3cd11ea5, (v) => $84c6f22c1328fe7e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $84c6f22c1328fe7e$export$ae55be85d98224ed, (v) => $84c6f22c1328fe7e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $84c6f22c1328fe7e$export$e530037191fcd5d7, (v) => $84c6f22c1328fe7e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $84c6f22c1328fe7e$export$fd42f52fd3ae1109, (v) => $84c6f22c1328fe7e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $84c6f22c1328fe7e$export$c8a8987d4410bf2d, (v) => $84c6f22c1328fe7e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $84c6f22c1328fe7e$export$d38cd72104c1f0e9, (v) => $84c6f22c1328fe7e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $84c6f22c1328fe7e$export$7d1e3a5e95ceca43, (v) => $84c6f22c1328fe7e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $84c6f22c1328fe7e$export$257a8862b851cb5b, (v) => $84c6f22c1328fe7e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $84c6f22c1328fe7e$export$a8257692ac88316c, (v) => $84c6f22c1328fe7e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $84c6f22c1328fe7e$export$488013bae63b21da, (v) => $84c6f22c1328fe7e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $84c6f22c1328fe7e$export$7c73462e0d25e514, (v) => $84c6f22c1328fe7e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $84c6f22c1328fe7e$export$7568632d0d33d16d, (v) => $84c6f22c1328fe7e$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $84c6f22c1328fe7e$export$88948ce120ea2619, (v) => $84c6f22c1328fe7e$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $84c6f22c1328fe7e$export$35808ee640e87ca7, (v) => $84c6f22c1328fe7e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $84c6f22c1328fe7e$export$fae74005e78b1a27, (v) => $84c6f22c1328fe7e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $84c6f22c1328fe7e$export$dc8fbce3eb94dc1e, (v) => $84c6f22c1328fe7e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $84c6f22c1328fe7e$export$6a7bc4e911dc01cf, (v) => $84c6f22c1328fe7e$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $84c6f22c1328fe7e$export$6d9c69b0de29b591, (v) => $84c6f22c1328fe7e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $84c6f22c1328fe7e$export$f680877a34711e37, (v) => $84c6f22c1328fe7e$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $84c6f22c1328fe7e$export$d5a552a76deda3c2, (v) => $84c6f22c1328fe7e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $84c6f22c1328fe7e$export$aaabe4eda9ed9969, (v) => $84c6f22c1328fe7e$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $84c6f22c1328fe7e$export$e5c5a5f917a5871c, (v) => $84c6f22c1328fe7e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $84c6f22c1328fe7e$export$1538c33de8887b59, (v) => $84c6f22c1328fe7e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $84c6f22c1328fe7e$export$13e3392192263954, (v) => $84c6f22c1328fe7e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $84c6f22c1328fe7e$export$b8f5890fc79d6aca, (v) => $84c6f22c1328fe7e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $84c6f22c1328fe7e$export$60241385465d0a34, (v) => $84c6f22c1328fe7e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $84c6f22c1328fe7e$export$306c0aa65ff9ec16, (v) => $84c6f22c1328fe7e$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $84c6f22c1328fe7e$export$7b286972b8d8ccbf, (v) => $84c6f22c1328fe7e$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $84c6f22c1328fe7e$export$83d89fbfd8236492, (v) => $84c6f22c1328fe7e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84c6f22c1328fe7e$export$dca3b0875bd9a954;
var $84c6f22c1328fe7e$export$16fa2f45be04daa8;
var $84c6f22c1328fe7e$export$ffb0004e005737fa;
var $84c6f22c1328fe7e$export$e2c29f18771995cb;
var $84c6f22c1328fe7e$export$221d75b3f55bb0bd;
var $84c6f22c1328fe7e$export$5f8d39834fd61797;
var $84c6f22c1328fe7e$export$74bf444e3cd11ea5;
var $84c6f22c1328fe7e$export$ae55be85d98224ed;
var $84c6f22c1328fe7e$export$e530037191fcd5d7;
var $84c6f22c1328fe7e$export$fd42f52fd3ae1109;
var $84c6f22c1328fe7e$export$c8a8987d4410bf2d;
var $84c6f22c1328fe7e$export$d38cd72104c1f0e9;
var $84c6f22c1328fe7e$export$7d1e3a5e95ceca43;
var $84c6f22c1328fe7e$export$257a8862b851cb5b;
var $84c6f22c1328fe7e$export$a8257692ac88316c;
var $84c6f22c1328fe7e$export$488013bae63b21da;
var $84c6f22c1328fe7e$export$7c73462e0d25e514;
var $84c6f22c1328fe7e$export$7568632d0d33d16d;
var $84c6f22c1328fe7e$export$88948ce120ea2619;
var $84c6f22c1328fe7e$export$35808ee640e87ca7;
var $84c6f22c1328fe7e$export$fae74005e78b1a27;
var $84c6f22c1328fe7e$export$dc8fbce3eb94dc1e;
var $84c6f22c1328fe7e$export$6a7bc4e911dc01cf;
var $84c6f22c1328fe7e$export$6d9c69b0de29b591;
var $84c6f22c1328fe7e$export$f680877a34711e37;
var $84c6f22c1328fe7e$export$d5a552a76deda3c2;
var $84c6f22c1328fe7e$export$aaabe4eda9ed9969;
var $84c6f22c1328fe7e$export$e5c5a5f917a5871c;
var $84c6f22c1328fe7e$export$1538c33de8887b59;
var $84c6f22c1328fe7e$export$13e3392192263954;
var $84c6f22c1328fe7e$export$b8f5890fc79d6aca;
var $84c6f22c1328fe7e$export$60241385465d0a34;
var $84c6f22c1328fe7e$export$306c0aa65ff9ec16;
var $84c6f22c1328fe7e$export$7b286972b8d8ccbf;
var $84c6f22c1328fe7e$export$83d89fbfd8236492;
'use strict';
var $84c6f22c1328fe7e$var$l = Symbol.for("react.element"), $84c6f22c1328fe7e$var$n = Symbol.for("react.portal"), $84c6f22c1328fe7e$var$p = Symbol.for("react.fragment"), $84c6f22c1328fe7e$var$q = Symbol.for("react.strict_mode"), $84c6f22c1328fe7e$var$r = Symbol.for("react.profiler"), $84c6f22c1328fe7e$var$t = Symbol.for("react.provider"), $84c6f22c1328fe7e$var$u = Symbol.for("react.context"), $84c6f22c1328fe7e$var$v = Symbol.for("react.forward_ref"), $84c6f22c1328fe7e$var$w = Symbol.for("react.suspense"), $84c6f22c1328fe7e$var$x = Symbol.for("react.memo"), $84c6f22c1328fe7e$var$y = Symbol.for("react.lazy"), $84c6f22c1328fe7e$var$z = Symbol.iterator;
function $84c6f22c1328fe7e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $84c6f22c1328fe7e$var$z && a[$84c6f22c1328fe7e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $84c6f22c1328fe7e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $84c6f22c1328fe7e$var$C = Object.assign, $84c6f22c1328fe7e$var$D = {};
function $84c6f22c1328fe7e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $84c6f22c1328fe7e$var$D;
    this.updater = e || $84c6f22c1328fe7e$var$B;
}
$84c6f22c1328fe7e$var$E.prototype.isReactComponent = {};
$84c6f22c1328fe7e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$84c6f22c1328fe7e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $84c6f22c1328fe7e$var$F() {}
$84c6f22c1328fe7e$var$F.prototype = $84c6f22c1328fe7e$var$E.prototype;
function $84c6f22c1328fe7e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $84c6f22c1328fe7e$var$D;
    this.updater = e || $84c6f22c1328fe7e$var$B;
}
var $84c6f22c1328fe7e$var$H = $84c6f22c1328fe7e$var$G.prototype = new $84c6f22c1328fe7e$var$F;
$84c6f22c1328fe7e$var$H.constructor = $84c6f22c1328fe7e$var$G;
$84c6f22c1328fe7e$var$C($84c6f22c1328fe7e$var$H, $84c6f22c1328fe7e$var$E.prototype);
$84c6f22c1328fe7e$var$H.isPureReactComponent = !0;
var $84c6f22c1328fe7e$var$I = Array.isArray, $84c6f22c1328fe7e$var$J = Object.prototype.hasOwnProperty, $84c6f22c1328fe7e$var$K = {
    current: null
}, $84c6f22c1328fe7e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $84c6f22c1328fe7e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$84c6f22c1328fe7e$var$J.call(b, d) && !$84c6f22c1328fe7e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $84c6f22c1328fe7e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $84c6f22c1328fe7e$var$K.current
    };
}
function $84c6f22c1328fe7e$var$N(a, b) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $84c6f22c1328fe7e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $84c6f22c1328fe7e$var$l;
}
function $84c6f22c1328fe7e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $84c6f22c1328fe7e$var$P = /\/+/g;
function $84c6f22c1328fe7e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $84c6f22c1328fe7e$var$escape("" + a.key) : b.toString(36);
}
function $84c6f22c1328fe7e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $84c6f22c1328fe7e$var$l:
                case $84c6f22c1328fe7e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $84c6f22c1328fe7e$var$Q(h, 0) : d, $84c6f22c1328fe7e$var$I(c) ? (e = "", null != a && (e = a.replace($84c6f22c1328fe7e$var$P, "$&/") + "/"), $84c6f22c1328fe7e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($84c6f22c1328fe7e$var$O(c) && (c = $84c6f22c1328fe7e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($84c6f22c1328fe7e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($84c6f22c1328fe7e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $84c6f22c1328fe7e$var$Q(k, g);
        h += $84c6f22c1328fe7e$var$R(k, b, e, f, c);
    }
    else if (f = $84c6f22c1328fe7e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $84c6f22c1328fe7e$var$Q(k, g++), h += $84c6f22c1328fe7e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $84c6f22c1328fe7e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $84c6f22c1328fe7e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $84c6f22c1328fe7e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $84c6f22c1328fe7e$var$U = {
    current: null
}, $84c6f22c1328fe7e$var$V = {
    transition: null
}, $84c6f22c1328fe7e$var$W = {
    ReactCurrentDispatcher: $84c6f22c1328fe7e$var$U,
    ReactCurrentBatchConfig: $84c6f22c1328fe7e$var$V,
    ReactCurrentOwner: $84c6f22c1328fe7e$var$K
};
$84c6f22c1328fe7e$export$dca3b0875bd9a954 = {
    map: $84c6f22c1328fe7e$var$S,
    forEach: function(a, b, e) {
        $84c6f22c1328fe7e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $84c6f22c1328fe7e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $84c6f22c1328fe7e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$84c6f22c1328fe7e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$84c6f22c1328fe7e$export$16fa2f45be04daa8 = $84c6f22c1328fe7e$var$E;
$84c6f22c1328fe7e$export$ffb0004e005737fa = $84c6f22c1328fe7e$var$p;
$84c6f22c1328fe7e$export$e2c29f18771995cb = $84c6f22c1328fe7e$var$r;
$84c6f22c1328fe7e$export$221d75b3f55bb0bd = $84c6f22c1328fe7e$var$G;
$84c6f22c1328fe7e$export$5f8d39834fd61797 = $84c6f22c1328fe7e$var$q;
$84c6f22c1328fe7e$export$74bf444e3cd11ea5 = $84c6f22c1328fe7e$var$w;
$84c6f22c1328fe7e$export$ae55be85d98224ed = $84c6f22c1328fe7e$var$W;
$84c6f22c1328fe7e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $84c6f22c1328fe7e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $84c6f22c1328fe7e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$84c6f22c1328fe7e$var$J.call(b, f) && !$84c6f22c1328fe7e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $84c6f22c1328fe7e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$84c6f22c1328fe7e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $84c6f22c1328fe7e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $84c6f22c1328fe7e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$84c6f22c1328fe7e$export$c8a8987d4410bf2d = $84c6f22c1328fe7e$var$M;
$84c6f22c1328fe7e$export$d38cd72104c1f0e9 = function(a) {
    var b = $84c6f22c1328fe7e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$84c6f22c1328fe7e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$84c6f22c1328fe7e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$v,
        render: a
    };
};
$84c6f22c1328fe7e$export$a8257692ac88316c = $84c6f22c1328fe7e$var$O;
$84c6f22c1328fe7e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $84c6f22c1328fe7e$var$T
    };
};
$84c6f22c1328fe7e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$84c6f22c1328fe7e$export$7568632d0d33d16d = function(a) {
    var b = $84c6f22c1328fe7e$var$V.transition;
    $84c6f22c1328fe7e$var$V.transition = {};
    try {
        a();
    } finally{
        $84c6f22c1328fe7e$var$V.transition = b;
    }
};
$84c6f22c1328fe7e$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$84c6f22c1328fe7e$export$35808ee640e87ca7 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useCallback(a, b);
};
$84c6f22c1328fe7e$export$fae74005e78b1a27 = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useContext(a);
};
$84c6f22c1328fe7e$export$dc8fbce3eb94dc1e = function() {};
$84c6f22c1328fe7e$export$6a7bc4e911dc01cf = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useDeferredValue(a);
};
$84c6f22c1328fe7e$export$6d9c69b0de29b591 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useEffect(a, b);
};
$84c6f22c1328fe7e$export$f680877a34711e37 = function() {
    return $84c6f22c1328fe7e$var$U.current.useId();
};
$84c6f22c1328fe7e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $84c6f22c1328fe7e$var$U.current.useImperativeHandle(a, b, e);
};
$84c6f22c1328fe7e$export$aaabe4eda9ed9969 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useInsertionEffect(a, b);
};
$84c6f22c1328fe7e$export$e5c5a5f917a5871c = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useLayoutEffect(a, b);
};
$84c6f22c1328fe7e$export$1538c33de8887b59 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useMemo(a, b);
};
$84c6f22c1328fe7e$export$13e3392192263954 = function(a, b, e) {
    return $84c6f22c1328fe7e$var$U.current.useReducer(a, b, e);
};
$84c6f22c1328fe7e$export$b8f5890fc79d6aca = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useRef(a);
};
$84c6f22c1328fe7e$export$60241385465d0a34 = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useState(a);
};
$84c6f22c1328fe7e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $84c6f22c1328fe7e$var$U.current.useSyncExternalStore(a, b, e);
};
$84c6f22c1328fe7e$export$7b286972b8d8ccbf = function() {
    return $84c6f22c1328fe7e$var$U.current.useTransition();
};
$84c6f22c1328fe7e$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("baQns", function(module, exports) {

$parcel$export(module.exports, "globalDi", () => $822941ec920432a4$export$a775919ebd7dd28a);

var $53fwy = parcelRequire("53fwy");

var $gbS7D = parcelRequire("gbS7D");
const $822941ec920432a4$var$replacementMap = new Map();
const $822941ec920432a4$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($822941ec920432a4$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $gbS7D.findInjectable)($822941ec920432a4$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($822941ec920432a4$var$replacementMap.size) throw new Error(`${(0, $53fwy.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $gbS7D.addInjectableToMap)($822941ec920432a4$var$replacementMap, inj));
    },
    clear () {
        $822941ec920432a4$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $53fwy.diRegistry).get(inj).global) (0, $gbS7D.addInjectableToMap)($822941ec920432a4$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $gbS7D.removeInjectableFromMap)($822941ec920432a4$var$replacementMap, inj));
    }
};
function $822941ec920432a4$export$b887ce09d70113f9(thunk, deps) {
    $822941ec920432a4$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($822941ec920432a4$export$a775919ebd7dd28a.clear);
        else $822941ec920432a4$export$a775919ebd7dd28a.clear();
    }
}

});
parcelRegister("53fwy", function(module, exports) {

$parcel$export(module.exports, "diRegistry", () => $3ad946528df32797$export$4203fb010fad9bf0);
$parcel$export(module.exports, "PACKAGE_NAME", () => $3ad946528df32797$export$b8b9d90f9e5bd72b);
const $3ad946528df32797$export$4203fb010fad9bf0 = new WeakMap();
const $3ad946528df32797$export$b8b9d90f9e5bd72b = 'react-magnetic-di';

});

parcelRegister("gbS7D", function(module, exports) {

$parcel$export(module.exports, "warnOnce", () => $bc97a7ed7f44645a$export$5b28268982f175ba);
$parcel$export(module.exports, "addInjectableToMap", () => $bc97a7ed7f44645a$export$7a7134bdd2f9ae2e);
$parcel$export(module.exports, "removeInjectableFromMap", () => $bc97a7ed7f44645a$export$8057a2244a849b7b);
$parcel$export(module.exports, "getDisplayName", () => $bc97a7ed7f44645a$export$be63e0664592e141);
$parcel$export(module.exports, "findInjectable", () => $bc97a7ed7f44645a$export$7c436e151c3ee289);

var $53fwy = parcelRequire("53fwy");

var $duJai = parcelRequire("duJai");
let $bc97a7ed7f44645a$var$hasWarned = false;
function $bc97a7ed7f44645a$export$5b28268982f175ba(message) {
    if (!$bc97a7ed7f44645a$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $bc97a7ed7f44645a$var$hasWarned = true;
    }
}
function $bc97a7ed7f44645a$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $53fwy.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $duJai.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $bc97a7ed7f44645a$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $53fwy.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $bc97a7ed7f44645a$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $bc97a7ed7f44645a$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $bc97a7ed7f44645a$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $duJai.stats).track(candidate);
    return candidate;
}

});
parcelRegister("duJai", function(module, exports) {

$parcel$export(module.exports, "stats", () => $9d311c8dcfd06b8d$export$7804429c45dff272);
const $9d311c8dcfd06b8d$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $9d311c8dcfd06b8d$export$7804429c45dff272 = {
    state: $9d311c8dcfd06b8d$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $9d311c8dcfd06b8d$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

});





parcelRegister("2YZCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fc557aa9084018$export$2e2bcd8739ae039);

var $jpY8v = parcelRequire("jpY8v");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $4R6GH = parcelRequire("4R6GH");

var $jyCEH = parcelRequire("jyCEH");

var $5pmnS = parcelRequire("5pmnS");
const $50fc557aa9084018$var$MAX_CONCURRENCY_FOR_THROTTLE = 5;
const $50fc557aa9084018$var$throttleInstance = (0, $jyCEH.default)($50fc557aa9084018$var$MAX_CONCURRENCY_FOR_THROTTLE);
if (typeof window !== 'undefined') window.addEventListener('beforeunload', $50fc557aa9084018$var$throttleInstance.flush);
// Each log call passes in a location - a path to the file with '.' separation. This utility will
// prepend 'jira.frontend.' to this location before it is sent.
// For example, 'jira.frontend.issue.state.reducers.entities.reducer'.
//
// Log messages and events must only contain privacy-safe information.
const $50fc557aa9084018$var$isProduction = ()=>true;
const $50fc557aa9084018$var$sendToServer = (body, endpoint)=>{
    const fetchOptions = {
        ...(0, $5HnTq.getDefaultOptions)(endpoint),
        method: 'POST',
        body: body
    };
    return (0, $4R6GH.fg)('background_priority_frontend_log_requests') ? (0, $5pmnS.polyfilledSchedulerPostTask)(()=>fetch(endpoint, fetchOptions), 'background') : fetch(endpoint, fetchOptions);
};
const $50fc557aa9084018$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%cJIRA %s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentWindow = window;
    if (!$50fc557aa9084018$var$isProduction() && currentWindow.Cypress) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!window.cypressSafeErrorsLog) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog = [];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $50fc557aa9084018$var$joinArrayFields = (error)=>Object.fromEntries(Object.entries(error).map(([key, value])=>{
        if (Array.isArray(value)) return [
            key,
            value.join(', ')
        ];
        return [
            key,
            value
        ];
    }));
const $50fc557aa9084018$var$transformError = (error)=>{
    const commonProperties = {
        message: error.message,
        stack: error.stack
    };
    // Not importing ValidationError and performing instanceof check because it's causing bundle size increase for skeletons.
    // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'. | TS2339 - Property 'errors' does not exist on type 'Error'.
    if (error.name === (0, $jJZqs.VALIDATION_ERROR_NAME) && error.errors && error.errors.map) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'.
        const { errors: errors, ...otherProperties } = error;
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        const invalidFields = errors.map((item)=>item.field).join(', ');
        // @ts-expect-error - TS2322 - Type '{ name: string; message: string; stack: string | undefined; invalidFields: any; }' is not assignable to type '{ [key: string]: string | number; }'.
        return {
            ...commonProperties,
            invalidFields: invalidFields,
            ...otherProperties
        };
    }
    const result = {
        ...commonProperties,
        ...error
    };
    return $50fc557aa9084018$var$joinArrayFields(result);
};
const $50fc557aa9084018$var$transformData = (location, message, event)=>{
    const { name: browserName, version: browserVersion } = (0, $jpY8v.getBrowser)();
    return {
        sentFrom: `jira.frontend.${location}`,
        message: String(message),
        event: event instanceof Error ? $50fc557aa9084018$var$transformError(event) : event,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        buildKey: window.BUILD_KEY,
        logTime: new Date().toISOString(),
        browserName: browserName,
        browserVersion: browserVersion
    };
};
const $50fc557aa9084018$var$sendData = (level, location, message, event = {})=>{
    const data = $50fc557aa9084018$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($50fc557aa9084018$var$isProduction()) return new Promise((resolve, reject)=>{
        $50fc557aa9084018$var$throttleInstance.add(()=>$50fc557aa9084018$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $50fc557aa9084018$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event
 *
 * @example Usage
 * safeInfoWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource INFO "my.location.string"
 */ const $50fc557aa9084018$var$safeInfoWithoutCustomerData = async (location, message, event)=>{
    await $50fc557aa9084018$var$sendData('info', location, message, event);
};
/** This function logs privacy safe warnings.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeWarnWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource WARN "my.location.string"
 */ const $50fc557aa9084018$var$safeWarnWithoutCustomerData = async (location, message, event)=>{
    await $50fc557aa9084018$var$sendData('warn', location, message, event);
};
/** This function logs privacy safe errors.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeErrorWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource ERROR "my.location.string"
 */ const $50fc557aa9084018$var$safeErrorWithoutCustomerData = async (location, message, event)=>{
    await $50fc557aa9084018$var$sendData('error', location, message, event);
};
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ const $50fc557aa9084018$var$unsafeErrorWithCustomerData = (location, message, event = {})=>{
    const data = $50fc557aa9084018$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = '/rest/internal/2/log/unsafe/frontend-exception';
    if ($50fc557aa9084018$var$isProduction()) return new Promise((resolve, reject)=>{
        $50fc557aa9084018$var$throttleInstance.add(()=>$50fc557aa9084018$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $50fc557aa9084018$var$sendToConsole(body, endpoint, 'error', message, typeof event, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50fc557aa9084018$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $50fc557aa9084018$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $50fc557aa9084018$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $50fc557aa9084018$var$safeErrorWithoutCustomerData,
    unsafeErrorWithCustomerData: $50fc557aa9084018$var$unsafeErrorWithCustomerData
};

});
parcelRegister("jpY8v", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $0f8ffafb41ad7521$export$89e15fc796a4a429);
$parcel$export(module.exports, "isIE11", () => $0f8ffafb41ad7521$export$f7bad96d83325a34);
$parcel$export(module.exports, "isEdge", () => $0f8ffafb41ad7521$export$cac3980734d91fbe);
$parcel$export(module.exports, "isChrome", () => $0f8ffafb41ad7521$export$6446a186d09e379e);
$parcel$export(module.exports, "isSafari", () => $0f8ffafb41ad7521$export$95df08bae54cb4df);
$parcel$export(module.exports, "isFirefox", () => $0f8ffafb41ad7521$export$b7d78993b74f766d);

var $4XKM3 = parcelRequire("4XKM3");
let $0f8ffafb41ad7521$var$parsedUA;
const $0f8ffafb41ad7521$var$parseUserAgent = ()=>{
    if ($0f8ffafb41ad7521$var$parsedUA === undefined) {
        const userAgent = typeof navigator !== 'undefined' && navigator.userAgent;
        $0f8ffafb41ad7521$var$parsedUA = userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser(userAgent) : null;
    }
    return $0f8ffafb41ad7521$var$parsedUA;
};
const $0f8ffafb41ad7521$var$getBrowserNameAndVersion = ()=>{
    const browser = $0f8ffafb41ad7521$var$parseUserAgent();
    if (browser) return browser.getBrowser();
    return {
        name: '',
        version: ''
    };
};
const $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion = (bowserVersion, minimumVersion)=>{
    const parts = bowserVersion.split('.');
    const part1 = parts[0];
    const part2 = parts[1];
    let version;
    if (part2) version = `${part1}.${part2}`;
    else version = part1;
    return Number(version) >= minimumVersion;
};
const $0f8ffafb41ad7521$export$89e15fc796a4a429 = ()=>$0f8ffafb41ad7521$var$getBrowserNameAndVersion();
const $0f8ffafb41ad7521$export$f7bad96d83325a34 = ()=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Internet Explorer' && version === '11.0';
};
const $0f8ffafb41ad7521$export$cac3980734d91fbe = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Microsoft Edge' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0f8ffafb41ad7521$export$6446a186d09e379e = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Chrome' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0f8ffafb41ad7521$export$95df08bae54cb4df = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Safari' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0f8ffafb41ad7521$export$b7d78993b74f766d = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Firefox' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};

});
parcelRegister("4XKM3", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("jJZqs", function(module, exports) {

$parcel$export(module.exports, "TYPE_ERROR_NAME", () => $9b8050d14ddb3fd0$export$764da004e4110fae);
$parcel$export(module.exports, "ABORT_ERROR_NAME", () => $9b8050d14ddb3fd0$export$41b7a909d5bcdc59);
$parcel$export(module.exports, "VALIDATION_ERROR_NAME", () => $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4);
$parcel$export(module.exports, "ValidationError", () => $9b8050d14ddb3fd0$export$2191b9da168c6cf0);
$parcel$export(module.exports, "isValidationError", () => $9b8050d14ddb3fd0$export$f715db496ec47204);
$parcel$export(module.exports, "default", () => $9b8050d14ddb3fd0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isFetchError", () => $9b8050d14ddb3fd0$export$96f7e6db4105d70c);
/* eslint-disable max-classes-per-file */ 
var $ht021 = parcelRequire("ht021");
const $9b8050d14ddb3fd0$export$764da004e4110fae = 'TypeError';
const $9b8050d14ddb3fd0$export$41b7a909d5bcdc59 = 'AbortError';
const $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4 = 'ValidationError';
const $9b8050d14ddb3fd0$export$83179404a61b001a = 'FetchError';
class $9b8050d14ddb3fd0$export$2191b9da168c6cf0 extends (0, $ht021.default) {
    constructor(message, errors = [], // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number'.
    statusCode, traceId, originalResponse){
        super(message, {
            cause: errors[0]
        });
        // Setting name to a hardcoded string so it doesn't get obfuscated. This is used for my poor man's instanceof
        // check in common/util/logging/log.js.
        this.name = $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4;
        this.errors = errors;
        this.statusCode = statusCode;
        this.skipSentry = true;
        this.traceId = traceId;
        this.originalResponse = originalResponse;
    }
}
const $9b8050d14ddb3fd0$export$f715db496ec47204 = (error)=>error.name === $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4;
class $9b8050d14ddb3fd0$export$2e2bcd8739ae039 extends (0, $ht021.default) {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = $9b8050d14ddb3fd0$export$83179404a61b001a;
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $9b8050d14ddb3fd0$export$96f7e6db4105d70c = (error)=>error instanceof $9b8050d14ddb3fd0$export$2e2bcd8739ae039 && error.name === $9b8050d14ddb3fd0$export$83179404a61b001a;

});
parcelRegister("ht021", function(module, exports) {

$parcel$export(module.exports, "default", () => $b155b7f0479fe122$export$2e2bcd8739ae039);
class $b155b7f0479fe122$export$2e2bcd8739ae039 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
    }
}

});


parcelRegister("5HnTq", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $d8e199c5de7ab402$export$430a3269e24b912e);
$parcel$export(module.exports, "defaultOptions", () => $d8e199c5de7ab402$export$ba43bf67f3d48107);

var $51xpa = parcelRequire("51xpa");
function $d8e199c5de7ab402$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $51xpa.applyObservabilityHeaders)(url, options) : options;
}
const $d8e199c5de7ab402$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});
parcelRegister("51xpa", function(module, exports) {

$parcel$export(module.exports, "makeObservabilityHeaders", () => $d3562d3cd66dff31$export$78a090c6aabf87d6);
$parcel$export(module.exports, "applyObservabilityHeaders", () => $d3562d3cd66dff31$export$f51f2ccd07af96d8);

var $aZsz6 = parcelRequire("aZsz6");

var $tcn7E = parcelRequire("tcn7E");


var $87OsA = parcelRequire("87OsA");

var $eKonk = parcelRequire("eKonk");
const $d3562d3cd66dff31$export$78a090c6aabf87d6 = (url)=>{
    const headers = {};
    const capability = (0, $87OsA.getCapability)();
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability);
    if (capabilityHeader) headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84] = capabilityHeader;
    const tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    if (tracingHeaders !== null) Object.assign(headers, tracingHeaders);
    if (Object.keys(headers).length === 0) return null;
    return {
        headers: headers
    };
};
const $d3562d3cd66dff31$export$f51f2ccd07af96d8 = (url, options)=>{
    const endpointUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!false && endpointUrl.hostname && endpointUrl.hostname !== window.location.hostname) return options;
    const extraHeaders = $d3562d3cd66dff31$export$78a090c6aabf87d6(url);
    if (extraHeaders === null) return options;
    return {
        ...options,
        headers: {
            ...options.headers,
            ...extraHeaders.headers
        }
    };
};

});
parcelRegister("aZsz6", function(module, exports) {
'use strict';

var $3XKGA = parcelRequire("3XKGA");

var $ipY9R = parcelRequire("ipY9R");
var $8005c250dc89d938$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $8005c250dc89d938$var$CRHTLF = /[\n\r\t]/g, $8005c250dc89d938$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $8005c250dc89d938$var$port = /:\d+$/, $8005c250dc89d938$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $8005c250dc89d938$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $8005c250dc89d938$var$trimLeft(str) {
    return (str ? str : '').toString().replace($8005c250dc89d938$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $8005c250dc89d938$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $8005c250dc89d938$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $8005c250dc89d938$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $8005c250dc89d938$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $8005c250dc89d938$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $8005c250dc89d938$var$Url(loc, {});
        for(key in $8005c250dc89d938$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $8005c250dc89d938$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $8005c250dc89d938$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $8005c250dc89d938$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $8005c250dc89d938$var$extractProtocol(address, location) {
    address = $8005c250dc89d938$var$trimLeft(address);
    address = address.replace($8005c250dc89d938$var$CRHTLF, '');
    location = location || {};
    var match = $8005c250dc89d938$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($8005c250dc89d938$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $8005c250dc89d938$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $8005c250dc89d938$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $8005c250dc89d938$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $8005c250dc89d938$var$Url(address, location, parser) {
    address = $8005c250dc89d938$var$trimLeft(address);
    address = address.replace($8005c250dc89d938$var$CRHTLF, '');
    if (!(this instanceof $8005c250dc89d938$var$Url)) return new $8005c250dc89d938$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $8005c250dc89d938$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $ipY9R.parse;
    location = $8005c250dc89d938$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $8005c250dc89d938$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $8005c250dc89d938$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$8005c250dc89d938$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $8005c250dc89d938$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $8005c250dc89d938$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$3XKGA(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $8005c250dc89d938$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $8005c250dc89d938$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $ipY9R.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$3XKGA(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($8005c250dc89d938$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $8005c250dc89d938$var$rules.length; i++){
        var ins = $8005c250dc89d938$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $8005c250dc89d938$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $8005c250dc89d938$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $ipY9R.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $8005c250dc89d938$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $8005c250dc89d938$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $8005c250dc89d938$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$8005c250dc89d938$var$Url.prototype = {
    set: $8005c250dc89d938$var$set,
    toString: $8005c250dc89d938$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$8005c250dc89d938$var$Url.extractProtocol = $8005c250dc89d938$var$extractProtocol;
$8005c250dc89d938$var$Url.location = $8005c250dc89d938$var$lolcation;
$8005c250dc89d938$var$Url.trimLeft = $8005c250dc89d938$var$trimLeft;
$8005c250dc89d938$var$Url.qs = $ipY9R;
module.exports = $8005c250dc89d938$var$Url;

});
parcelRegister("3XKGA", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("ipY9R", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $d68939f3762ba35d$export$fac44ee5b035f737, (v) => $d68939f3762ba35d$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $d68939f3762ba35d$export$98e6a39c04603d36, (v) => $d68939f3762ba35d$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $d68939f3762ba35d$export$fac44ee5b035f737;
var $d68939f3762ba35d$export$98e6a39c04603d36;
'use strict';
var $d68939f3762ba35d$var$has = Object.prototype.hasOwnProperty, $d68939f3762ba35d$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $d68939f3762ba35d$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $d68939f3762ba35d$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $d68939f3762ba35d$var$querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $d68939f3762ba35d$var$decode(part[1]), value = $d68939f3762ba35d$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $d68939f3762ba35d$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($d68939f3762ba35d$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $d68939f3762ba35d$var$undef || isNaN(value))) value = '';
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$d68939f3762ba35d$export$fac44ee5b035f737 = $d68939f3762ba35d$var$querystringify;
$d68939f3762ba35d$export$98e6a39c04603d36 = $d68939f3762ba35d$var$querystring;

});


const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("87OsA", function(module, exports) {

$parcel$export(module.exports, "setCapability", () => $ddf54a85e3ee1f25$export$60e3f676689faf78);
$parcel$export(module.exports, "getCapability", () => $ddf54a85e3ee1f25$export$38805c31c710553c);
let $ddf54a85e3ee1f25$var$activeCapability = null;
const $ddf54a85e3ee1f25$export$60e3f676689faf78 = (capability)=>{
    $ddf54a85e3ee1f25$var$activeCapability = capability;
};
const $ddf54a85e3ee1f25$export$38805c31c710553c = ()=>$ddf54a85e3ee1f25$var$activeCapability;

});

parcelRegister("eKonk", function(module, exports) {

$parcel$export(module.exports, "getEnhancedCapabilityHeader", () => $ea5a8371adb619de$export$8660821f7e55d98b);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $4R6GH = parcelRequire("4R6GH");
function $ea5a8371adb619de$export$8660821f7e55d98b(capability) {
    if (!(0, $4R6GH.fg)('jira_enhanced_capability_header') || capability == null) return capability;
    const defaultCapabilityHeader = `${capability}--other`;
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (!interactionId) return defaultCapabilityHeader;
    const currentInteractionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
    if (currentInteractionType === 'page_load') return `${capability}--page-load`;
    else if (currentInteractionType === 'transition') return `${capability}--transition`;
    return defaultCapabilityHeader;
}

});
parcelRegister("1u4q7", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", () => $7e359588695aef0a$export$3109542b68df9ba1);
$parcel$export(module.exports, "default", () => $7e359588695aef0a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $7e359588695aef0a$export$37bca3107733ac1e);

var $5uXOq = parcelRequire("5uXOq");
const $7e359588695aef0a$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$7e359588695aef0a$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($7e359588695aef0a$export$3109542b68df9ba1);
const $7e359588695aef0a$export$37bca3107733ac1e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;
const $7e359588695aef0a$export$9f6000531b78127e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;

});

parcelRegister("bFU4G", function(module, exports) {

$parcel$export(module.exports, "postInteractionLog", () => $b98c15df5ed39925$export$d8f52e8f804021e8);
$parcel$export(module.exports, "getActiveInteraction", () => $b98c15df5ed39925$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $b98c15df5ed39925$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addMetadata", () => $b98c15df5ed39925$export$12f2b6cb85d59904);
$parcel$export(module.exports, "addCustomData", () => $b98c15df5ed39925$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $b98c15df5ed39925$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $b98c15df5ed39925$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $b98c15df5ed39925$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $b98c15df5ed39925$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "extractModuleName", () => $b98c15df5ed39925$export$f5a8f10de74904da);
$parcel$export(module.exports, "addHold", () => $b98c15df5ed39925$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $b98c15df5ed39925$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $b98c15df5ed39925$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $b98c15df5ed39925$export$2df109852219d16e);
$parcel$export(module.exports, "ModuleLoadingProfiler", () => $b98c15df5ed39925$export$9591b52b33ccc510);
$parcel$export(module.exports, "addError", () => $b98c15df5ed39925$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $b98c15df5ed39925$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $b98c15df5ed39925$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $b98c15df5ed39925$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $b98c15df5ed39925$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $b98c15df5ed39925$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $b98c15df5ed39925$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $b98c15df5ed39925$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $b98c15df5ed39925$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $b98c15df5ed39925$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $b98c15df5ed39925$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $b98c15df5ed39925$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdexToAll", () => $b98c15df5ed39925$export$ad216cc25852d44b);
$parcel$export(module.exports, "addApdex", () => $b98c15df5ed39925$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $b98c15df5ed39925$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $b98c15df5ed39925$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $b98c15df5ed39925$export$d0365e48b58231c3);
$parcel$export(module.exports, "addRedirect", () => $b98c15df5ed39925$export$bbf14d79614d9818);
$parcel$export(module.exports, "interactionSpans", () => $b98c15df5ed39925$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $b98c15df5ed39925$export$5342dcad19138a1c);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $f38ba = parcelRequire("f38ba");

var $tcn7E = parcelRequire("tcn7E");

var $gSA3s = parcelRequire("gSA3s");

var $1u4q7 = parcelRequire("1u4q7");

var $a0hd6 = parcelRequire("a0hd6");

var $45w2S = parcelRequire("45w2S");

var $bJCAw = parcelRequire("bJCAw");
const $b98c15df5ed39925$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $b98c15df5ed39925$export$d8f52e8f804021e8 = new (0, $bJCAw.default)();
const $b98c15df5ed39925$var$interactionQueue = [];
const $b98c15df5ed39925$var$segmentCache = new Map();
const $b98c15df5ed39925$var$CLEANUP_TIMEOUT = 60000;
const $b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
const $b98c15df5ed39925$var$segmentObservers = [];
function $b98c15df5ed39925$export$2b3954d2e8509985() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $45w2S.interactions).get(interactionId.current);
}
function $b98c15df5ed39925$var$isPerformanceTracingEnabled() {
    return (0, $fe1wc.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $b98c15df5ed39925$var$performanceEventObserver;
const $b98c15df5ed39925$export$17afbba0f16b4b19 = ()=>{
    $b98c15df5ed39925$var$performanceEventObserver = $b98c15df5ed39925$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $b98c15df5ed39925$export$e6be05b411ce21a6(entry);
    });
    return $b98c15df5ed39925$var$performanceEventObserver;
};
const $b98c15df5ed39925$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $b98c15df5ed39925$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $b98c15df5ed39925$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $b98c15df5ed39925$var$addSegmentObserver(observer) {
    $b98c15df5ed39925$var$segmentObservers.push(observer);
    for (const segmentInfo of $b98c15df5ed39925$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $b98c15df5ed39925$var$removeSegmentObserver(observer) {
    const index = $b98c15df5ed39925$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $b98c15df5ed39925$var$segmentObservers.splice(index, 1);
}
function $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId) {
    (0, $45w2S.interactions).delete(interactionId);
}
function $b98c15df5ed39925$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $b98c15df5ed39925$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $b98c15df5ed39925$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $b98c15df5ed39925$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $b98c15df5ed39925$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b98c15df5ed39925$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b98c15df5ed39925$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $b98c15df5ed39925$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $b98c15df5ed39925$export$9e04fe1a58571ec(moduleId, timestamp) {
    $b98c15df5ed39925$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $b98c15df5ed39925$export$6f228d1fdc911d7(identifier, start, end) {
    $b98c15df5ed39925$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $b98c15df5ed39925$var$moduleLoadingRequests = {};
function $b98c15df5ed39925$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $b98c15df5ed39925$var$labelStackToString(labelStack), name, startTime);
}
function $b98c15df5ed39925$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $b98c15df5ed39925$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    const id = (0, $7Jxgt.v4)();
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
            ...holdActive,
            start: start
        });
        if (!experimental) interaction.holdActive.set(id, {
            ...holdActive,
            start: start
        });
        $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
        return ()=>{
            const end = performance.now();
            if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $b98c15df5ed39925$var$removeHoldCriterion(id);
            const currentInteraction = (0, $45w2S.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return ()=>{};
}
function $b98c15df5ed39925$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
    }
    return ()=>{};
}
function $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $45w2S.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $b98c15df5ed39925$var$removeHoldCriterion(id);
        }
    }
}
function $b98c15df5ed39925$export$2df109852219d16e(interactionId) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $b98c15df5ed39925$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $b98c15df5ed39925$export$9e04fe1a58571ec($b98c15df5ed39925$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
            $b98c15df5ed39925$export$6f228d1fdc911d7($b98c15df5ed39925$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $1u4q7.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b98c15df5ed39925$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $1u4q7.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b98c15df5ed39925$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $b98c15df5ed39925$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $b98c15df5ed39925$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $45w2S.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
function $b98c15df5ed39925$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $b98c15df5ed39925$var$pushToQueue(id, data) {
    $b98c15df5ed39925$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $b98c15df5ed39925$var$handleInteraction = $b98c15df5ed39925$var$pushToQueue;
function $b98c15df5ed39925$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $b98c15df5ed39925$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $gSA3s.currentFeatureFlagsAccessed));
    (0, $tcn7E.clearActiveTrace)();
    $b98c15df5ed39925$var$callCleanUpCallbacks(data);
    if ((0, $fe1wc.getConfig)()?.vc?.stopVCAtInteractionFinish) data.vc = (0, $a0hd6.getVCObserver)().getVCRawData();
    if (!(0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) $b98c15df5ed39925$export$cd7f480d6b8286c3(id);
    $b98c15df5ed39925$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $b98c15df5ed39925$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $b98c15df5ed39925$var$handleInteraction(id, data);
    if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $b98c15df5ed39925$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $b98c15df5ed39925$export$9e614a29a1ac213e(sinkFn) {
    if ($b98c15df5ed39925$var$handleInteraction === $b98c15df5ed39925$var$pushToQueue) {
        $b98c15df5ed39925$var$handleInteraction = sinkFn;
        $b98c15df5ed39925$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $b98c15df5ed39925$var$interactionQueue.length = 0;
    }
}
function $b98c15df5ed39925$export$8a1ba7bef607358a(sinkFn) {
    $b98c15df5ed39925$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $b98c15df5ed39925$var$activeSubmitted = false;
function $b98c15df5ed39925$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const postInteraction = async ()=>{
            if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $f38ba.getExperimentalVCMetrics)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $b98c15df5ed39925$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
            $b98c15df5ed39925$var$activeSubmitted = false;
        };
        if (noMoreActiveHolds) {
            if (!$b98c15df5ed39925$var$activeSubmitted) {
                $b98c15df5ed39925$var$finishInteraction(interactionId, interaction, endTime);
                $b98c15df5ed39925$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $b98c15df5ed39925$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $b98c15df5ed39925$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        $b98c15df5ed39925$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $b98c15df5ed39925$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        $b98c15df5ed39925$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $b98c15df5ed39925$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $45w2S.interactions).forEach((interaction, interactionId)=>{
        const noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $b98c15df5ed39925$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $f38ba.onExperimentalInteractionComplete)(interactionId, interaction);
            $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $b98c15df5ed39925$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $45w2S.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $b98c15df5ed39925$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    if ((0, $fe1wc.getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.reset();
    let previousTime = startTime;
    let timeoutTime = $b98c15df5ed39925$var$CLEANUP_TIMEOUT;
    const timerID = setTimeout(()=>{
        $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
    }, $b98c15df5ed39925$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $5gx4p.default)((0, $fe1wc.getCapabilityRate)('feature_flag_access'));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $b98c15df5ed39925$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $b98c15df5ed39925$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $gSA3s.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $gSA3s.currentFeatureFlagsAccessed).clear();
    (0, $45w2S.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $b98c15df5ed39925$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $b98c15df5ed39925$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    const awaitBM3TTIList = (0, $fe1wc.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $b98c15df5ed39925$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') {
        (0, $a0hd6.getVCObserver)().start({
            startTime: startTime,
            experienceKey: ufoName
        });
        $b98c15df5ed39925$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $f38ba.experimentalVC).start({
            startTime: startTime
        });
    }
}
function $b98c15df5ed39925$export$4a759336b50e86e3(event) {
    const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $b98c15df5ed39925$export$ad216cc25852d44b(apdex) {
    (0, $45w2S.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $b98c15df5ed39925$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $b98c15df5ed39925$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $b98c15df5ed39925$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $b98c15df5ed39925$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($b98c15df5ed39925$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $b98c15df5ed39925$export$1c43f9ac826b6462(labelStack) {
    const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
    const existingSegment = $b98c15df5ed39925$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $b98c15df5ed39925$var$segmentCache.set(key, segmentInfo);
        $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $b98c15df5ed39925$export$d0365e48b58231c3(labelStack) {
    const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $b98c15df5ed39925$var$segmentCache.get(key);
    if (segmentInfo) {
        $b98c15df5ed39925$var$segmentCache.delete(JSON.stringify(labelStack));
        $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $b98c15df5ed39925$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $45w2S.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($b98c15df5ed39925$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const $b98c15df5ed39925$export$6ce04c7ca6810a7e = [];
const $b98c15df5ed39925$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $b98c15df5ed39925$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $b98c15df5ed39925$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $b98c15df5ed39925$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("7Jxgt", function(module, exports) {

var $2sHuS = parcelRequire("2sHuS");

var $bXrHm = parcelRequire("bXrHm");
var $5a168a0a2f115164$var$uuid = $bXrHm;
$5a168a0a2f115164$var$uuid.v1 = $2sHuS;
$5a168a0a2f115164$var$uuid.v4 = $bXrHm;
module.exports = $5a168a0a2f115164$var$uuid;

});
parcelRegister("2sHuS", function(module, exports) {

var $jfTQu = parcelRequire("jfTQu");

var $35e9R = parcelRequire("35e9R");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $1cafefead11b6998$var$_nodeId;
var $1cafefead11b6998$var$_clockseq;
// Previous uuid creation time
var $1cafefead11b6998$var$_lastMSecs = 0;
var $1cafefead11b6998$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $1cafefead11b6998$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $1cafefead11b6998$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $1cafefead11b6998$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $jfTQu();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $1cafefead11b6998$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $1cafefead11b6998$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $1cafefead11b6998$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $1cafefead11b6998$var$_lastMSecs + (nsecs - $1cafefead11b6998$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $1cafefead11b6998$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $1cafefead11b6998$var$_lastMSecs = msecs;
    $1cafefead11b6998$var$_lastNSecs = nsecs;
    $1cafefead11b6998$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $35e9R(b);
}
module.exports = $1cafefead11b6998$var$v1;

});
parcelRegister("jfTQu", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $e04abcd4da220d70$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($e04abcd4da220d70$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $e04abcd4da220d70$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $e04abcd4da220d70$var$getRandomValues($e04abcd4da220d70$var$rnds8);
        return $e04abcd4da220d70$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $e04abcd4da220d70$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $e04abcd4da220d70$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $e04abcd4da220d70$var$rnds;
    };
}

});

parcelRegister("35e9R", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $23ecd232e3053ef4$var$byteToHex = [];
for(var $23ecd232e3053ef4$var$i = 0; $23ecd232e3053ef4$var$i < 256; ++$23ecd232e3053ef4$var$i)$23ecd232e3053ef4$var$byteToHex[$23ecd232e3053ef4$var$i] = ($23ecd232e3053ef4$var$i + 0x100).toString(16).substr(1);
function $23ecd232e3053ef4$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $23ecd232e3053ef4$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $23ecd232e3053ef4$var$bytesToUuid;

});


parcelRegister("bXrHm", function(module, exports) {

var $jfTQu = parcelRequire("jfTQu");

var $35e9R = parcelRequire("35e9R");
function $8b4ab0b910e6c2c2$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $jfTQu)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $35e9R(rnds);
}
module.exports = $8b4ab0b910e6c2c2$var$v4;

});


parcelRegister("5gx4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f3dab3adc4e602$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $50f3dab3adc4e602$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $50f3dab3adc4e602$export$2e2bcd8739ae039 = $50f3dab3adc4e602$var$coinflip;

});

parcelRegister("fe1wc", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", () => $884a08804b0d324c$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $884a08804b0d324c$export$44487a86467333c3);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $884a08804b0d324c$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $884a08804b0d324c$export$70184d6e2c753893);
$parcel$export(module.exports, "getInteractionRate", () => $884a08804b0d324c$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $884a08804b0d324c$export$563f73272328c0d);
$parcel$export(module.exports, "getPostInteractionRate", () => $884a08804b0d324c$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $884a08804b0d324c$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getTypingPerformanceTracingMethod", () => $884a08804b0d324c$export$7e32aae12bf9b50f);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $884a08804b0d324c$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $884a08804b0d324c$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $884a08804b0d324c$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $884a08804b0d324c$export$d6dc9444bd15f70f);

var $VSDnB = parcelRequire("VSDnB");
let $884a08804b0d324c$var$config;
const $884a08804b0d324c$var$DEFAULT_TTVC_REVISION = 'fy25.02';
function $884a08804b0d324c$export$10d6139a8fb42158(newConfig) {
    if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
        // Handle edge cases with `enabledVCRevisions`
        const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
        if (typeof enabledVCRevisions?.byExperience === 'object') $884a08804b0d324c$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    // enforce axiom about `enabledVCRevisions.all` config
                    all: Array.from(new Set([
                        $884a08804b0d324c$var$DEFAULT_TTVC_REVISION,
                        ...enabledVCRevisions?.all,
                        ...Object.values(enabledVCRevisions?.byExperience).flat()
                    ])),
                    byExperience: {
                        ...enabledVCRevisions?.byExperience
                    }
                }
            }
        };
        else $884a08804b0d324c$var$config = newConfig;
    } else $884a08804b0d324c$var$config = newConfig;
}
function $884a08804b0d324c$export$44487a86467333c3() {
    return $884a08804b0d324c$var$config;
}
const $884a08804b0d324c$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $884a08804b0d324c$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$884a08804b0d324c$var$config) return [];
        if ($884a08804b0d324c$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $884a08804b0d324c$var$config.vc ?? {};
            if ($884a08804b0d324c$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey]) && (0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) return enabledVCRevisions.byExperience?.[experienceKey];
            if ($884a08804b0d324c$var$isValidConfigArray(enabledVCRevisions?.all)) return enabledVCRevisions.all;
            return [
                $884a08804b0d324c$var$DEFAULT_TTVC_REVISION
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $884a08804b0d324c$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $884a08804b0d324c$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $884a08804b0d324c$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $884a08804b0d324c$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $884a08804b0d324c$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $884a08804b0d324c$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $884a08804b0d324c$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $884a08804b0d324c$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $884a08804b0d324c$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { postInteractionLog: postInteractionLog } = $884a08804b0d324c$var$config;
        if (!postInteractionLog?.enabled) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $884a08804b0d324c$export$29b9ffb14861a1d(capability) {
    try {
        if (!$884a08804b0d324c$var$config) return 0;
        const { capability: capabilityRate } = $884a08804b0d324c$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
const $884a08804b0d324c$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $884a08804b0d324c$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$884a08804b0d324c$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $884a08804b0d324c$var$config;
        if (typingMethod != null && $884a08804b0d324c$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $884a08804b0d324c$export$2d311b3fd18dcab1() {
    try {
        if (!$884a08804b0d324c$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $884a08804b0d324c$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $884a08804b0d324c$export$e2ea675800536898() {
    try {
        if (!$884a08804b0d324c$var$config) return false;
        const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $884a08804b0d324c$var$config;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $884a08804b0d324c$export$525ba53ca98e9db() {
    try {
        if (!$884a08804b0d324c$var$config) return false;
        const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $884a08804b0d324c$var$config;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $884a08804b0d324c$export$4f4649ef27b6f5d6() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $884a08804b0d324c$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$3c170167645a0eff() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $884a08804b0d324c$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $884a08804b0d324c$export$d6dc9444bd15f70f() {
    try {
        if (!$884a08804b0d324c$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $884a08804b0d324c$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});
parcelRegister("VSDnB", function(module, exports) {

$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $162b6b7cff61a519$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $162b6b7cff61a519$export$b40ec24ac8275656);

var $gNWRx = parcelRequire("gNWRx");
function $162b6b7cff61a519$export$ba05d765b8392e5e(flagResolver) {
    (0, $gNWRx.setBooleanResolver)(flagResolver);
}
function $162b6b7cff61a519$export$470e5c2be1411c89(name) {
    return (0, $gNWRx.resolveBooleanFlag)(name);
}
function $162b6b7cff61a519$export$b40ec24ac8275656(name) {
    return (0, $gNWRx.resolveBooleanFlag)(name);
}

});
parcelRegister("gNWRx", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $deb4360f78d10c50$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $deb4360f78d10c50$export$6333b6aff9fc6275);

var $iEN9D = parcelRequire("iEN9D");

var $8z44t = parcelRequire("8z44t");

var $6cAn5 = parcelRequire("6cAn5");
const $deb4360f78d10c50$var$pkgName = '@atlaskit/platform-feature-flags';
const $deb4360f78d10c50$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $deb4360f78d10c50$var$hasProcessEnv = typeof $6cAn5 !== 'undefined' && typeof $6cAn5.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $deb4360f78d10c50$var$ENV_ENABLE_PLATFORM_FF = $deb4360f78d10c50$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $deb4360f78d10c50$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $deb4360f78d10c50$var$hasProcessEnv ? false : false;
const $deb4360f78d10c50$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $deb4360f78d10c50$var$ENV_ENABLE_PLATFORM_FF || $deb4360f78d10c50$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $deb4360f78d10c50$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $deb4360f78d10c50$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98] = $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98] || $deb4360f78d10c50$var$DEFAULT_PFF_GLOBAL;
function $deb4360f78d10c50$export$f2b591175b3e424c(resolver) {
    $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $deb4360f78d10c50$export$6333b6aff9fc6275(flagKey) {
    if ($deb4360f78d10c50$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8z44t.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $deb4360f78d10c50$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $iEN9D.default).checkGate(flagKey);
        const result = $deb4360f78d10c50$var$globalVar[$deb4360f78d10c50$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("8z44t", function(module, exports) {

$parcel$export(module.exports, "debug", () => $74a930288ce2e8c4$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $74a930288ce2e8c4$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $74a930288ce2e8c4$var$DEBUG_MODE = !$74a930288ce2e8c4$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $74a930288ce2e8c4$export$1c9f709888824e05 = (...args)=>{
    if (!$74a930288ce2e8c4$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});




parcelRegister("f38ba", function(module, exports) {

$parcel$export(module.exports, "sinkExperimentalHandler", () => $ae10169b4d4f0485$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $ae10169b4d4f0485$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $ae10169b4d4f0485$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $ae10169b4d4f0485$export$d17d2b5c5e8d732e);

var $37gc9 = parcelRequire("37gc9");

var $h2sI1 = parcelRequire("h2sI1");
const $ae10169b4d4f0485$var$interactionBuffer = [];
let $ae10169b4d4f0485$var$bufferInteractionData = (interactionId, data)=>{
    $ae10169b4d4f0485$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $ae10169b4d4f0485$var$clearInteractionBuffer() {
    $ae10169b4d4f0485$var$interactionBuffer.length = 0;
}
function $ae10169b4d4f0485$var$appendInteractionData(interactionId, data) {
    $ae10169b4d4f0485$var$bufferInteractionData(interactionId, data);
}
function $ae10169b4d4f0485$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $ae10169b4d4f0485$var$interactionBuffer)handler(interactionId, data);
    $ae10169b4d4f0485$var$clearInteractionBuffer();
    $ae10169b4d4f0485$var$bufferInteractionData = handler;
}
function $ae10169b4d4f0485$export$7aa99c40634ac65f(sinkFn) {
    $ae10169b4d4f0485$export$c8a9e17ae62a073d(sinkFn);
}
function $ae10169b4d4f0485$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $ae10169b4d4f0485$var$appendInteractionData(interactionId, data);
        $ae10169b4d4f0485$var$clearInteractionBuffer();
    }
}
class $ae10169b4d4f0485$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $h2sI1.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $ae10169b4d4f0485$export$81b28dca2587ec47 = new $ae10169b4d4f0485$export$f9a59f57e0282541();
async function $ae10169b4d4f0485$export$d17d2b5c5e8d732e(interaction) {
    if ($ae10169b4d4f0485$export$81b28dca2587ec47.vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await $ae10169b4d4f0485$export$81b28dca2587ec47.vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(interaction.start, interaction.end);
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}

});
parcelRegister("37gc9", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $9d4714fe1b0ac403$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $9d4714fe1b0ac403$export$768b2008623433e1);

var $cBeZP = parcelRequire("cBeZP");
const $9d4714fe1b0ac403$var$timings = [];
let $9d4714fe1b0ac403$var$wasHiddenFlag;
let $9d4714fe1b0ac403$var$setupFlag = false;
function $9d4714fe1b0ac403$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $9d4714fe1b0ac403$var$SIZE = 50;
let $9d4714fe1b0ac403$var$insertIndex = 0;
function $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, time) {
    $9d4714fe1b0ac403$var$timings[$9d4714fe1b0ac403$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $9d4714fe1b0ac403$var$insertIndex = ($9d4714fe1b0ac403$var$insertIndex + 1) % $9d4714fe1b0ac403$var$SIZE;
    $9d4714fe1b0ac403$var$wasHiddenFlag = isPageHiddenFlag;
}
function $9d4714fe1b0ac403$var$handleChange() {
    const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
        $9d4714fe1b0ac403$var$wasHiddenFlag = true;
    } else {
        if ($9d4714fe1b0ac403$var$wasHiddenFlag) $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag);
        $9d4714fe1b0ac403$var$wasHiddenFlag = false;
    }
}
function $9d4714fe1b0ac403$var$setup() {
    (0, $cBeZP.bind)(window, {
        type: 'pageshow',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
    (0, $cBeZP.bind)(window, {
        type: 'pagehide',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
    (0, $cBeZP.bind)(document, {
        type: 'visibilitychange',
        listener: $9d4714fe1b0ac403$var$handleChange
    });
}
function $9d4714fe1b0ac403$export$554cefe0f0373da4() {
    if (!$9d4714fe1b0ac403$var$setupFlag) {
        const isPageHiddenFlag = $9d4714fe1b0ac403$var$isPageHidden();
        $9d4714fe1b0ac403$var$pushHidden(isPageHiddenFlag, 0);
        $9d4714fe1b0ac403$var$setup();
        $9d4714fe1b0ac403$var$setupFlag = true;
    }
}
function $9d4714fe1b0ac403$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($9d4714fe1b0ac403$var$timings.length === 0) return 'visible';
    const currentSize = $9d4714fe1b0ac403$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $9d4714fe1b0ac403$var$insertIndex;
    let endIdx = $9d4714fe1b0ac403$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($9d4714fe1b0ac403$var$insertIndex + i) % currentSize;
        if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($9d4714fe1b0ac403$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($9d4714fe1b0ac403$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});
parcelRegister("cBeZP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $ievrd = parcelRequire("ievrd");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $ievrd.bind;
    }
});

var $kKhts = parcelRequire("kKhts");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $kKhts.bindAll;
    }
});

});
parcelRegister("ievrd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $d461ebbb57f062f1$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $d461ebbb57f062f1$var$bind;

});

parcelRegister("kKhts", function(module, exports) {
"use strict";
var $f1a5a88c1c09cc51$var$__assign = module.exports && module.exports.__assign || function() {
    $f1a5a88c1c09cc51$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1a5a88c1c09cc51$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $ievrd = parcelRequire("ievrd");
function $f1a5a88c1c09cc51$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f1a5a88c1c09cc51$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f1a5a88c1c09cc51$var$__assign($f1a5a88c1c09cc51$var$__assign({}, original), {
        options: $f1a5a88c1c09cc51$var$__assign($f1a5a88c1c09cc51$var$__assign({}, $f1a5a88c1c09cc51$var$toOptions(sharedOptions)), $f1a5a88c1c09cc51$var$toOptions(original.options))
    });
    return binding;
}
function $f1a5a88c1c09cc51$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f1a5a88c1c09cc51$var$getBinding(original, sharedOptions);
        return (0, $ievrd.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $f1a5a88c1c09cc51$var$bindAll;

});



parcelRegister("h2sI1", function(module, exports) {

$parcel$export(module.exports, "VCObserver", () => $8281afea1c2bf80e$export$1f70d263701b1d01);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $bFU4G = parcelRequire("bFU4G");

var $aceO8 = parcelRequire("aceO8");

var $5lAmc = parcelRequire("5lAmc");

var $epQcA = parcelRequire("epQcA");

var $6Subd = parcelRequire("6Subd");

var $eZGsd = parcelRequire("eZGsd");

var $joHOM = parcelRequire("joHOM");
const $8281afea1c2bf80e$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $8281afea1c2bf80e$var$UNUSED_SECTOR = 0;
function $8281afea1c2bf80e$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $8281afea1c2bf80e$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.multiHeatmap = null;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                multiHeatmap: this.multiHeatmap,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios, multiHeatmap: multiHeatmap } = rawData;
            const isTTVCv1Disabled = (0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience') ? !(0, $fe1wc.isVCRevisionEnabled)('fy25.01', experienceKey) : !(0, $fe1wc.isVCRevisionEnabled)('fy25.01');
            // NOTE: as part of platform_ufo_add_vc_abort_reason_by_revisions feature,
            // we want to report abort by scroll events the same way as other abort reasons
            // i.e. not have the concept of `abortReason.blocking` anymore
            if (abortReasonInfo !== null && (0, $VSDnB.fg)('platform_ufo_add_vc_abort_reason_by_revisions')) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReason.reason,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp,
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason
                });
                return vcAbortedResultWithRevisions;
            } else if (abortReasonInfo !== null && abortReason.blocking) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReasonInfo,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp
                };
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport
            });
            try {
                if (!this.isPostInteraction) $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    if (isTTVCv1Disabled) {
                        const duration = vcNext.VC[key];
                        if (duration !== null && duration !== undefined) {
                            performance.measure(`VC${key}`, {
                                start: start,
                                duration: duration
                            });
                            performance.measure(`VC_Next${key}`, {
                                start: start,
                                duration: duration
                            });
                        }
                    } else {
                        const ttvcV1duration = VC[key];
                        if (ttvcV1duration !== null && ttvcV1duration !== undefined) performance.measure(`VC${key}`, {
                            start: start,
                            duration: ttvcV1duration
                        });
                        const ttvcV2duration = vcNext.VC[key];
                        if (ttvcV2duration !== null && ttvcV2duration !== undefined) performance.measure(`VC_Next${key}`, {
                            start: start,
                            duration: ttvcV2duration
                        });
                    }
                });
            } catch (e) {
            /* empty */ }
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $8281afea1c2bf80e$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
            } catch (e) {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $5lAmc.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                multiHeatmap: multiHeatmap,
                ssr: ssr,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience') ? (0, $fe1wc.isVCRevisionEnabled)('fy25.03', experienceKey) : (0, $fe1wc.isVCRevisionEnabled)('fy25.03');
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            this.measureStart();
            this.legacyHandleUpdate(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue);
            let isTTVCv3Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.03');
            if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
                const interaction = (0, $bFU4G.getActiveInteraction)();
                isTTVCv3Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.03', interaction?.ufoName);
            }
            if (isTTVCv3Disabled) this.onViewportChangeDetected({
                timestamp: rawTime,
                intersectionRect: intersectionRect,
                targetName: targetName,
                element: element,
                type: type,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
            this.measureStop();
        };
        this.legacyHandleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                let isTTVCv1Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01');
                if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
                    const interaction = (0, $bFU4G.getActiveInteraction)();
                    isTTVCv1Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                }
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.onViewportChangeDetected = ({ element: element, type: type, ignoreReason: ignoreReason, timestamp: timestamp, targetName: targetName, intersectionRect: intersectionRect, attributeName: attributeName, oldValue: oldValue, newValue: newValue })=>{
            if (this.multiHeatmap === null) return;
            // @todo add abort reason handling
            const time = Math.round(timestamp - this.startTime);
            const revisions = (0, $joHOM.getRevisions)();
            const revisionsClassification = revisions.map((revision)=>{
                return revision.classifier.classifyUpdate({
                    element: element,
                    type: type,
                    ignoreReason: ignoreReason
                });
            }, []);
            this.multiHeatmap.handleUpdate({
                time: time,
                targetName: targetName,
                intersectionRect: intersectionRect,
                type: type,
                element: element,
                classification: revisionsClassification,
                onError: (error)=>{
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, error.time, error.error);
                },
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $aceO8.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) {
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                    if (time) this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                delete window?.__SSR_ABORT_LISTENERS__;
            }
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $eZGsd.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $6Subd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $joHOM.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $8281afea1c2bf80e$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport }) {
        const lastUpdate = {};
        let totalPainted = 0;
        if (ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssr]) componentsLog[ssr] = [];
            componentsLog[ssr].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $8281afea1c2bf80e$var$UNUSED_SECTOR && ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? ssr : entry);
                totalPainted += rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $8281afea1c2bf80e$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $6Subd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $joHOM.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($8281afea1c2bf80e$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $epQcA.getViewportWidth)();
        this.viewport.h = (0, $epQcA.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (Array.isArray(this.unbind)) {
            this.unbind.forEach((fn)=>fn());
            this.unbind = [];
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("aceO8", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", () => $05d54f94441303a8$export$9010aa71841a6887);

var $cBeZP = parcelRequire("cBeZP");

var $Pu2vb = parcelRequire("Pu2vb");

var $epQcA = parcelRequire("epQcA");
function $05d54f94441303a8$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $Pu2vb.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $Pu2vb.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $cBeZP.bind)(window, {
        type: (0, $Pu2vb.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $epQcA.getViewportWidth)() !== initialViewPort.w || (0, $epQcA.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $Pu2vb.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("Pu2vb", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", () => $b4a560c0776083f4$export$199edc0307b5587f);
const $b4a560c0776083f4$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("epQcA", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", () => $20743fc2a72ae229$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $20743fc2a72ae229$export$4f01c15d21ef9cc6);
function $20743fc2a72ae229$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $20743fc2a72ae229$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("5lAmc", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", () => $01e36a1b8e73b8a5$export$5c86a34c9becd6d0);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $37gc9 = parcelRequire("37gc9");

var $joHOM = parcelRequire("joHOM");
const $01e36a1b8e73b8a5$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $01e36a1b8e73b8a5$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $01e36a1b8e73b8a5$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $01e36a1b8e73b8a5$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $01e36a1b8e73b8a5$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $01e36a1b8e73b8a5$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, multiHeatmap: multiHeatmap, ssr: ssr, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey }) {
    const isTTVCv3Enabled = (0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience') ? (0, $fe1wc.isVCRevisionEnabled)('fy25.03', experienceKey) : (0, $fe1wc.isVCRevisionEnabled)('fy25.03');
    // As part of `platform_ufo_vc_enable_revisions_by_experience`, we are looking to turn off the `multiHeatmap` branch of code
    // for calculating TTVC, and instead rely on existing values already available, e.g. `calculatedVC` and `calculatedVCNext`
    if (!isTTVCv3Enabled && !(0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
        if (!multiHeatmap) return null;
        return {
            [`${fullPrefix}vc:rev`]: multiHeatmap?.getPayloadShapedData({
                VCParts: $01e36a1b8e73b8a5$var$VCParts.map((v)=>parseInt(v)),
                VCCalculationMethods: (0, $joHOM.getRevisions)().map(({ classifier: classifier })=>classifier.VCCalculationMethod),
                filterComponentsLog: (0, $joHOM.getRevisions)().map(({ classifier: classifier })=>classifier.filterComponentsLog),
                isEventAborted: isEventAborted,
                interactionStart: interaction.start,
                ttai: interaction.end,
                ssr: ssr,
                clean: isVCClean
            })
        };
    }
    const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
        const availableVCRevisionPayloads = [];
        if ((0, $fe1wc.isVCRevisionEnabled)('fy25.01', experienceKey)) availableVCRevisionPayloads.push({
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $01e36a1b8e73b8a5$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        });
        if ((0, $fe1wc.isVCRevisionEnabled)('fy25.02', experienceKey)) availableVCRevisionPayloads.push({
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $01e36a1b8e73b8a5$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        });
        return {
            [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
        };
    } else {
        // Create the V2 revision object which is always needed
        const ttvcV2Revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $01e36a1b8e73b8a5$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        const isTTVCv1Disabled = !(0, $fe1wc.isVCRevisionEnabled)('fy25.01');
        if (isTTVCv1Disabled) return {
            [`${fullPrefix}vc:rev`]: [
                ttvcV2Revision
            ]
        };
        // Only create ttvcV1Revision when we're actually going to use it
        const ttvcV1Revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $01e36a1b8e73b8a5$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        return {
            [`${fullPrefix}vc:rev`]: [
                ttvcV1Revision,
                ttvcV2Revision
            ]
        };
    }
}

});
parcelRegister("joHOM", function(module, exports) {

$parcel$export(module.exports, "getRevisions", () => $661e71f007ef70c7$export$3a6bcaa2795a58f8);

var $fe1wc = parcelRequire("fe1wc");

var $fxqmJ = parcelRequire("fxqmJ");

var $2YVdr = parcelRequire("2YVdr");
function $661e71f007ef70c7$export$3a6bcaa2795a58f8() {
    if (!(0, $fe1wc.isVCRevisionEnabled)('fy25.01')) return [
        {
            name: 'fy25.02',
            classifier: (0, $2YVdr.revFY25_02Classifier)
        }
    ];
    return [
        {
            name: 'fy25.01',
            classifier: (0, $fxqmJ.revFY25_01Classifier)
        },
        {
            name: 'fy25.02',
            classifier: (0, $2YVdr.revFY25_02Classifier)
        }
    ];
}

});
parcelRegister("fxqmJ", function(module, exports) {

$parcel$export(module.exports, "FY25_01Classifier", () => $f82147c2ef7ad89b$export$1287fed0f253eee5);
$parcel$export(module.exports, "revFY25_01Classifier", () => $f82147c2ef7ad89b$export$d822caadc9ee5453);

var $jPXob = parcelRequire("jPXob");
const $f82147c2ef7ad89b$var$legacyIgnoreReasons = [
    'image',
    'ssr-hydration'
];
class $f82147c2ef7ad89b$export$1287fed0f253eee5 extends (0, $jPXob.ViewportUpdateClassifier) {
    VCCalculationMethod({ VCParts: VCParts, entries: entries, totalPainted: totalPainted, componentsLog: componentsLog }) {
        const VC = {};
        const VCBox = {};
        entries.reduce((acc = 0, v)=>{
            let VCRatio = v[1] / totalPainted + acc;
            const time = v[0];
            // @todo apply fix to include small changes into accumulator
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            VCParts.forEach((value)=>{
                if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
                    VC[value] = time;
                    VCBox[value] = new Set();
                    componentsLog[time]?.forEach((v)=>VCBox[value]?.add(v.targetName));
                }
            });
            return VCRatio;
        }, 0);
        return {
            VC: VC,
            VCBox: VCBox
        };
    }
    constructor(){
        super(), this.revision = 'fy25.01', this.types = [
            'html',
            'text'
        ], this.filters = [
            {
                name: 'default-ignore-reasons',
                filter: ({ type: type, ignoreReason: ignoreReason })=>{
                    return !ignoreReason || !$f82147c2ef7ad89b$var$legacyIgnoreReasons.includes(ignoreReason);
                }
            }
        ];
        this.mergeConfig();
    }
}
const $f82147c2ef7ad89b$export$d822caadc9ee5453 = new $f82147c2ef7ad89b$export$1287fed0f253eee5();

});
parcelRegister("jPXob", function(module, exports) {

$parcel$export(module.exports, "ViewportUpdateClassifier", () => $503d28df6b954812$export$66a5f74f04eab7df);
class $503d28df6b954812$export$66a5f74f04eab7df {
    VCCalculationMethod(_) {
        return {
            VC: {},
            VCBox: {}
        };
    }
    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
    filterComponentsLog({ componentsLog: componentsLog }) {
        return componentsLog;
    }
    mergeConfig() {
        this.__combinedTypes = [
            ...this.types,
            ...this?.__combinedTypes || []
        ];
        const previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter((filter)=>!this.removedFilters.includes(filter.name));
        this.__combinedFilters = [
            ...this.filters,
            ...previousFilters
        ];
    }
    classifyUpdate({ element: element, type: type, tags: tags, ignoreReason: ignoreReason }) {
        if (!this.__combinedTypes.includes(type)) return false;
        return this.__combinedFilters.every(({ filter: filter, name: name })=>{
            return filter({
                type: type,
                tags: tags,
                ignoreReason: ignoreReason
            });
        });
    }
    constructor(){
        this.types = [];
        this.filters = [];
        this.removedFilters = [];
        this.__combinedTypes = [];
        this.__combinedFilters = [];
    }
}

});


parcelRegister("2YVdr", function(module, exports) {

$parcel$export(module.exports, "revFY25_02Classifier", () => $de8b48bc6201ce8c$export$624b2c3760a5ab41);

var $fxqmJ = parcelRequire("fxqmJ");
class $de8b48bc6201ce8c$export$d8e8ccb82df07b7c extends (0, $fxqmJ.FY25_01Classifier) {
    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
    filterComponentsLog({ componentsLog: componentsLog, ttai: ttai }) {
        const _componentsLog = {};
        Object.entries(componentsLog).forEach(([_timestamp, value])=>{
            const timestamp = Number(_timestamp);
            if (Math.ceil(ttai) >= timestamp) _componentsLog[timestamp] = value;
        });
        return _componentsLog;
    }
    constructor(){
        super(), this.revision = 'fy25.02', this.types = [
            'attr'
        ], this.filters = [
            {
                name: 'not-visible',
                filter: ({ type: type, ignoreReason: ignoreReason })=>{
                    return !ignoreReason?.includes('not-visible') && ignoreReason !== 'non-visual-style';
                }
            }
        ], this.removedFilters = [];
        this.mergeConfig();
    }
}
const $de8b48bc6201ce8c$export$624b2c3760a5ab41 = new $de8b48bc6201ce8c$export$d8e8ccb82df07b7c();

});



parcelRegister("6Subd", function(module, exports) {

$parcel$export(module.exports, "MultiRevisionHeatmap", () => $e691834d2c757960$export$40923620784ea2c1);

var $37gc9 = parcelRequire("37gc9");
const $e691834d2c757960$var$UNUSED_SECTOR = 0;
class $e691834d2c757960$export$40923620784ea2c1 {
    constructor({ viewport: viewport, revisions: revisions, arraySize: arraySize, devToolsEnabled: devToolsEnabled }){
        this.arraySize = {
            w: 200,
            h: 200
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize.w);
            const t = Math.floor(top / h * this.arraySize.h);
            const r = Math.ceil((left + width) / w * this.arraySize.w);
            const b = Math.ceil((top + height) / h * this.arraySize.h);
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize.w, r),
                b: Math.min(this.arraySize.h, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize.w * this.arraySize.h);
        };
        this.viewport = viewport;
        this.revisions = revisions;
        if (arraySize) this.arraySize = arraySize;
        this.heatmaps = new Array(revisions.length);
        this.componentsLogs = new Array(revisions.length);
        this.vcRatios = new Array(revisions.length);
        this.devToolsEnabled = devToolsEnabled || false;
        revisions.forEach(({}, i)=>{
            this.heatmaps[i] = this.getCleanHeatmap();
            this.componentsLogs[i] = {};
            this.vcRatios[i] = {};
        });
    }
    handleUpdate({ time: time, type: type, classification: classification, intersectionRect: intersectionRect, element: element, targetName: targetName, ignoreReason: ignoreReason, onError: onError, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
        const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
        const result = this.applyChangesToHeatMap(mappedValues, time, classification);
        if (result !== true) onError(result);
        const componentRatio = this.getElementRatio(mappedValues);
        this.revisions.forEach((_, i)=>{
            if (classification[i]) this.vcRatios[i][targetName] = componentRatio;
            if (!this.componentsLogs[i][time]) this.componentsLogs[i][time] = [];
            this.componentsLogs[i][time].push({
                __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                intersectionRect: intersectionRect,
                targetName: targetName,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
    }
    getData() {
        return {
            heatmaps: this.heatmaps
        };
    }
    getPayloadShapedData(args) {
        const pageVisibilityUpToTTAI = (0, $37gc9.getPageVisibilityState)(args.interactionStart, args.ttai);
        const result = this.processData(args);
        const payload = this.revisions.map((rev, i)=>{
            const vcDetails = {};
            args.VCParts.forEach((VCPart)=>{
                vcDetails[VCPart] = {
                    t: result[i].VC[VCPart] || 0,
                    e: Array.from(result[i].VCBox[VCPart] || [])
                };
            });
            return {
                revision: rev.name,
                clean: args.clean,
                'metric:vc90': args.clean && !args.isEventAborted && pageVisibilityUpToTTAI === 'visible' ? vcDetails?.['90']?.t : null,
                vcDetails: vcDetails
            };
        });
        return payload;
    }
    processData({ VCParts: VCParts, VCCalculationMethods: VCCalculationMethods, filterComponentsLog: filterComponentsLog, ttai: ttai, ssr: ssr = $e691834d2c757960$var$UNUSED_SECTOR }) {
        return this.heatmaps.map((heatmap, i)=>{
            const lastUpdate = {};
            let totalPainted = 0;
            let componentsLog = this.componentsLogs[i];
            if (ssr !== $e691834d2c757960$var$UNUSED_SECTOR) {
                const element = {
                    __debug__element: new WeakRef(window.document?.body),
                    intersectionRect: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        x: 0,
                        y: 0,
                        width: this.viewport.w,
                        height: this.viewport.h,
                        toJSON () {
                            return {};
                        }
                    },
                    targetName: 'SSR'
                };
                if (!componentsLog[ssr]) componentsLog[ssr] = [];
                componentsLog[ssr].push(element);
            }
            for(let i = 0; i < heatmap.length; i++){
                const rounded = Math.floor(heatmap[i] === $e691834d2c757960$var$UNUSED_SECTOR && ssr !== $e691834d2c757960$var$UNUSED_SECTOR ? ssr : heatmap[i]);
                totalPainted += rounded !== $e691834d2c757960$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $e691834d2c757960$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            }
            const entries = Object.entries(lastUpdate).map((a)=>[
                    parseInt(a[0], 10),
                    a[1]
                ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
            // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
            componentsLog = filterComponentsLog[i]({
                componentsLog: componentsLog,
                ttai: ttai
            });
            const { VC: VC, VCBox: VCBox } = VCCalculationMethods[i]({
                VCParts: VCParts,
                componentsLog: componentsLog,
                entries: entries,
                totalPainted: totalPainted
            });
            const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
                const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
                const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                const logEntry = componentsLog[timestamp]?.map((v)=>v.targetName);
                acc.abs.push([
                    timestamp,
                    currentlyPainted
                ]);
                acc.rel.push({
                    time: timestamp,
                    vc: currentlyPaintedRatio,
                    elements: logEntry
                });
                return acc;
            }, {
                abs: [],
                rel: []
            });
            return {
                VC: VC,
                VCBox: VCBox,
                VCEntries: VCEntries,
                totalPainted: totalPainted
            };
        });
    }
    applyChangesToHeatMap(a, time, classification) {
        const { l: l, t: t, r: r, b: b } = a;
        const size = classification.length;
        for(let row = t; row < b; row++){
            if (this.heatmaps[0][row] === undefined) try {
                return {
                    error: `index - ${row}`,
                    time: time
                };
            } catch (e) {
                return {
                    error: 'row error',
                    time: time
                };
            }
            else {
                for(let heatmapIndex = 0; heatmapIndex < size; heatmapIndex++)if (classification[heatmapIndex]) this.heatmaps[heatmapIndex].fill(time, this.getIndex(l, row), this.getIndex(r, row));
            }
        }
        return true;
    }
    getIndex(x, y) {
        return x + this.arraySize.w * y;
    }
    getCleanHeatmap() {
        return new Int32Array(this.arraySize.w * this.arraySize.h);
    }
    static makeVCReturnObj(VCParts) {
        const vc = {};
        VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
}

});

parcelRegister("eZGsd", function(module, exports) {

$parcel$export(module.exports, "Observers", () => $aa3fefb78ef7f562$export$b65d046240060e78);

var $1HYUt = parcelRequire("1HYUt");

var $eliYW = parcelRequire("eliYW");

var $flJpT = parcelRequire("flJpT");
const $aa3fefb78ef7f562$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $aa3fefb78ef7f562$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $aa3fefb78ef7f562$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $aa3fefb78ef7f562$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $flJpT.SSRPlaceholderHandlers)();
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $aa3fefb78ef7f562$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $aa3fefb78ef7f562$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $aa3fefb78ef7f562$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $aa3fefb78ef7f562$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $aa3fefb78ef7f562$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $aa3fefb78ef7f562$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $1HYUt.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $eliYW.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $1HYUt.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$aa3fefb78ef7f562$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("1HYUt", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $dac8a3c213f349f7$export$f61fbc3b9c4a9019);

var $lr1Nm = parcelRequire("lr1Nm");
function $dac8a3c213f349f7$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $lr1Nm.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("lr1Nm", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $71e1e5daed4f23b4$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $71e1e5daed4f23b4$export$7028e9efe569888c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $71e1e5daed4f23b4$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $71e1e5daed4f23b4$export$7028e9efe569888c = {
    [$71e1e5daed4f23b4$export$7674290405cc25b0]: true
};
function $71e1e5daed4f23b4$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...$71e1e5daed4f23b4$export$7028e9efe569888c,
        children: children
    });
}

});
parcelRegister("2OMIu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iIkmJ"));

});
parcelRegister("iIkmJ", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d9fc223fda04f9ed$export$ffb0004e005737fa, (v) => $d9fc223fda04f9ed$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d9fc223fda04f9ed$export$34b9dba7ce09269b, (v) => $d9fc223fda04f9ed$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d9fc223fda04f9ed$export$25062201e9e25d76, (v) => $d9fc223fda04f9ed$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9fc223fda04f9ed$export$ffb0004e005737fa;
var $d9fc223fda04f9ed$export$34b9dba7ce09269b;
var $d9fc223fda04f9ed$export$25062201e9e25d76;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
var $d9fc223fda04f9ed$var$k = Symbol.for("react.element"), $d9fc223fda04f9ed$var$l = Symbol.for("react.fragment"), $d9fc223fda04f9ed$var$m = Object.prototype.hasOwnProperty, $d9fc223fda04f9ed$var$n = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9fc223fda04f9ed$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d9fc223fda04f9ed$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d9fc223fda04f9ed$var$m.call(a, b) && !$d9fc223fda04f9ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d9fc223fda04f9ed$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d9fc223fda04f9ed$var$n.current
    };
}
$d9fc223fda04f9ed$export$ffb0004e005737fa = $d9fc223fda04f9ed$var$l;
$d9fc223fda04f9ed$export$34b9dba7ce09269b = $d9fc223fda04f9ed$var$q;
$d9fc223fda04f9ed$export$25062201e9e25d76 = $d9fc223fda04f9ed$var$q;

});




parcelRegister("eliYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c623265a80191b$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $95c623265a80191b$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $95c623265a80191b$export$2e2bcd8739ae039 = $95c623265a80191b$var$isNonVisualStyleMutation;

});

parcelRegister("flJpT", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $8867921f8b6036b7$export$c0102f1a1198d10f);
const $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT = 10;
class $8867921f8b6036b7$export$c0102f1a1198d10f {
    constructor(){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = target.dataset.ssrPlaceholder || '';
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = target.getBoundingClientRect();
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = target.dataset.ssrPlaceholderReplace || '';
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = target.getBoundingClientRect();
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        if (window.document) try {
            const existingElements = document.querySelectorAll('[data-ssr-placeholder]');
            existingElements.forEach((el)=>{
                if (el instanceof HTMLElement && el?.dataset?.ssrPlaceholder) {
                    let width = -1;
                    let height = -1;
                    let x = -1;
                    let y = -1;
                    const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    this.intersectionObserver?.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    isPlaceholder(element) {
        return Boolean(element.dataset.ssrPlaceholder);
    }
    isPlaceholderReplacement(element) {
        return Boolean(element.dataset.ssrPlaceholderReplace);
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = el.dataset.ssrPlaceholder || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = el.dataset.ssrPlaceholderReplace || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    hasSameSizePosition(rect, boundingClientRect) {
        return rect && Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD || false;
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});




parcelRegister("a0hd6", function(module, exports) {

$parcel$export(module.exports, "VCObserverWrapper", () => $fa52152d064ec067$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "getVCObserver", () => $fa52152d064ec067$export$b3bc47985717b49e);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $i0vFa = parcelRequire("i0vFa");

var $h2sI1 = parcelRequire("h2sI1");

var $cmAu5 = parcelRequire("cmAu5");

var $6cAn5 = parcelRequire("6cAn5");
class $fa52152d064ec067$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
            this.oldVCObserver = null;
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.03')) this.newVCObserver = new (0, $cmAu5.default)({
                selectorConfig: opts.selectorConfig
            });
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.01') || (0, $fe1wc.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $h2sI1.VCObserver)(opts);
        } else {
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.03')) this.newVCObserver = new (0, $cmAu5.default)({
                selectorConfig: opts.selectorConfig
            });
            this.oldVCObserver = new (0, $h2sI1.VCObserver)(opts);
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $fe1wc.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
                startTime: startTime
            });
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.03', experienceKey)) this.newVCObserver?.start({
                startTime: startTime
            });
        } else {
            this.oldVCObserver?.start({
                startTime: startTime
            });
            this.newVCObserver?.start({
                startTime: startTime
            });
        }
    }
    stop(experienceKey) {
        if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $fe1wc.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
            if ((0, $fe1wc.isVCRevisionEnabled)('fy25.03', experienceKey)) this.newVCObserver?.stop();
        } else {
            this.oldVCObserver?.stop();
            this.newVCObserver?.stop();
        }
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        if ((0, $VSDnB.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
            const { experienceKey: experienceKey } = param;
            const v1v2Result = (0, $fe1wc.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $fe1wc.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
            const v3Result = (0, $fe1wc.isVCRevisionEnabled)('fy25.03', experienceKey) ? await this.newVCObserver?.getVCResult({
                start: param.start,
                stop: param.stop
            }) : [];
            if (!v3Result) return v1v2Result ?? {};
            return {
                ...v1v2Result,
                'ufo:vc:rev': [
                    ...v1v2Result?.['ufo:vc:rev'] ?? [],
                    ...v3Result ?? []
                ]
            };
        } else {
            const oldResult = await this.oldVCObserver?.getVCResult(param);
            const newResult = await this.newVCObserver?.getVCResult({
                start: param.start,
                stop: param.stop
            });
            if (oldResult && !newResult) return oldResult;
            return {
                ...oldResult ?? {},
                'ufo:vc:rev': [
                    ...oldResult?.['ufo:vc:rev'] ?? [],
                    ...newResult ?? []
                ]
            };
        }
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
}
// Some products set this variable to indicate it is running in SSR
let $fa52152d064ec067$var$isServer = Boolean(globalThis?.false);
// Other products set this other variable to indicate it is running in SSR
let $fa52152d064ec067$var$isReactSSR = typeof $6cAn5 !== 'undefined' && Boolean($6cAn5?.env?.REACT_SSR || false);
function $fa52152d064ec067$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($fa52152d064ec067$var$isReactSSR || $fa52152d064ec067$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $fa52152d064ec067$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$fa52152d064ec067$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $i0vFa.VCObserverNOOP)() : new $fa52152d064ec067$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}

});
parcelRegister("i0vFa", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", () => $b94cebb0b45b066d$export$24d07287b49da906);
class $b94cebb0b45b066d$export$24d07287b49da906 {
    start(startArg) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(param) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(element) {}
    setReactRootRenderStart(startTime) {}
    setReactRootRenderStop(stopTime) {}
}

});

parcelRegister("cmAu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a174c05d81ba02$export$2e2bcd8739ae039);

var $7JcwI = parcelRequire("7JcwI");

var $ijRKb = parcelRequire("ijRKb");

var $9XWZI = parcelRequire("9XWZI");

var $1OMZa = parcelRequire("1OMZa");

var $ePAog = parcelRequire("ePAog");
const $56a174c05d81ba02$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $56a174c05d81ba02$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = new (0, $7JcwI.default)();
        this.selectorConfig = config.selectorConfig ?? $56a174c05d81ba02$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $1OMZa.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                this.entriesTimeline.push({
                    time: time,
                    type: type,
                    data: {
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData?.attributeName
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $ePAog.default)({
            onEvent: ({ time: time, type: type })=>{
                this.entriesTimeline.push({
                    time: time,
                    type: 'window:event',
                    data: {
                        eventType: type
                    }
                });
            }
        });
    }
    start({ startTime: startTime }) {
        this.viewportObserver?.start();
        this.windowEventObserver?.start();
        this.entriesTimeline.clear();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
    }
    async getVCResult(param) {
        const { start: start, stop: stop } = param;
        const results = [];
        const calculator_fy25_03 = new (0, $9XWZI.default)();
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop
        });
        if (fy25_03) results.push(fy25_03);
        return results;
    }
    getElementName(element) {
        return (0, $ijRKb.default)(this.selectorConfig, element);
    }
}

});
parcelRegister("7JcwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $eddbcb024948b44d$export$2e2bcd8739ae039);
class $eddbcb024948b44d$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("ijRKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41a358eae106edf$export$2e2bcd8739ae039);
const $c41a358eae106edf$var$nameCache = new WeakMap();
function $c41a358eae106edf$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $c41a358eae106edf$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $c41a358eae106edf$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $c41a358eae106edf$var$nameCache.set(element, name);
    return name;
}
var $c41a358eae106edf$export$2e2bcd8739ae039 = $c41a358eae106edf$var$getElementName;

});

parcelRegister("9XWZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fcf1b81943b604c$export$2e2bcd8739ae039);

var $Z0DvF = parcelRequire("Z0DvF");

var $aXT4C = parcelRequire("aXT4C");
const $7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $7fcf1b81943b604c$var$REVISION_NO = 'fy25.03';
const $7fcf1b81943b604c$var$CONSIDERED_ENTRY_TYPE = [
    'mutation:child-element',
    'mutation:element',
    'mutation:attribute',
    'layout-shift',
    'window:event'
];
const $7fcf1b81943b604c$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'draggable'
];
class $7fcf1b81943b604c$export$2e2bcd8739ae039 extends (0, $Z0DvF.default) {
    constructor(){
        super($7fcf1b81943b604c$var$REVISION_NO);
    }
    isEntryIncluded(entry) {
        if (!$7fcf1b81943b604c$var$CONSIDERED_ENTRY_TYPE.includes(entry.type)) return false;
        if (entry.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || $7fcf1b81943b604c$export$98812f4e79596e2b.includes(attributeName)) return false;
            return true;
        }
        if ((0, $aXT4C.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    isVCClean(filteredEntries) {
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.type === 'window:event') {
                const data = entry.data;
                if ($7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
            }
            return false;
        });
        return !hasAbortEvent;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.type === 'window:event') {
                const data = entry.data;
                if ($7fcf1b81943b604c$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("Z0DvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $de18581208359322$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $8c8Ex = parcelRequire("8c8Ex");

var $6RK1A = parcelRequire("6RK1A");

var $dF9Lu = parcelRequire("dF9Lu");
class $de18581208359322$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry);
        });
        if ((0, $VSDnB.fg)('platform_ufo_add_vc_abort_reason_by_revisions')) {
            const { isVCClean: isVCClean, dirtyReason: dirtyReason } = this.getVCCleanStatus(filteredEntries);
            if (!isVCClean) return {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false,
                abortReason: dirtyReason
            };
        } else {
            const isVCClean = this.isVCClean(filteredEntries);
            if (!isVCClean) return {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false
            };
        }
        const vcDetails = await (0, $8c8Ex.default)({
            viewport: {
                width: (0, $dF9Lu.default)(),
                height: (0, $6RK1A.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: filteredEntries,
            percentiles: [
                25,
                50,
                75,
                80,
                85,
                90,
                95,
                98,
                99
            ]
        });
        return {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined
        };
    }
}

});
parcelRegister("8c8Ex", function(module, exports) {

$parcel$export(module.exports, "default", () => $17901c826f2eaa4d$export$2e2bcd8739ae039);

var $2Fqls = parcelRequire("2Fqls");

var $7YUd0 = parcelRequire("7YUd0");

var $aBSWp = parcelRequire("aBSWp");
async function $17901c826f2eaa4d$var$calculateTTVCPercentiles(arg) {
    const algo = 'canvas_heatmap';
    if (algo === 'canvas_heatmap') {
        const vcDetails = await (0, $2Fqls.default)(arg);
        return vcDetails;
    }
    if (algo === 'rect_sweeping') {
        const vcDetails = await (0, $aBSWp.default)(arg);
        return vcDetails;
    }
    if (algo === 'old_heatmap') {
        const vcDetails = await (0, $7YUd0.default)(arg);
        return vcDetails;
    }
    throw new Error('unexpected Error algo not chosen correctly');
}
var $17901c826f2eaa4d$export$2e2bcd8739ae039 = $17901c826f2eaa4d$var$calculateTTVCPercentiles;

});
parcelRegister("2Fqls", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadfe5c88ea5db2d$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $a6vME = parcelRequire("a6vME");
async function $aadfe5c88ea5db2d$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $a6vME.ViewportCanvas)(viewport, (0, $VSDnB.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $aadfe5c88ea5db2d$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
var $aadfe5c88ea5db2d$export$2e2bcd8739ae039 = $aadfe5c88ea5db2d$var$calculateTTVCPercentiles;
function $aadfe5c88ea5db2d$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}

});
parcelRegister("a6vME", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", () => $0e1e69660e38aacc$export$3e59ac9de7402fb1);

var $VSDnB = parcelRequire("VSDnB");

var $ctFNJ = parcelRequire("ctFNJ");
class $0e1e69660e38aacc$export$3e59ac9de7402fb1 {
    /**
	 * Creates a new ViewportCanvas instance.
	 * @param viewport - The dimensions of the viewport
	 * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
	 * @throws {Error} If canvas context cannot be obtained
	 */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        if ((0, $VSDnB.fg)('platform_ufo_use_offscreen_canvas')) this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
	 * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
	 * or if the feature flag is disabled
	 */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined' && (0, $VSDnB.fg)('platform_ufo_use_offscreen_canvas')) return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $0e1e69660e38aacc$export$54591583ed0b20ce(rgbColor);
    }
    /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $0e1e69660e38aacc$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $0e1e69660e38aacc$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $0e1e69660e38aacc$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $0e1e69660e38aacc$export$fafc9be44839f9c8(imageData, scaleFactor, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $ctFNJ.default)();
    }
    return arr;
}

});
parcelRegister("ctFNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7427e932608e9a3e$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $7427e932608e9a3e$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $7427e932608e9a3e$export$2e2bcd8739ae039 = $7427e932608e9a3e$var$taskYield;

});



parcelRegister("7YUd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1907482eac6f531$export$2e2bcd8739ae039);

var $aXT4C = parcelRequire("aXT4C");

var $ctFNJ = parcelRequire("ctFNJ");
const $d1907482eac6f531$var$MAX_HEATMAP_SIZE = 1000;
function $d1907482eac6f531$var$createEmptyHeatmapEntry() {
    return {
        head: null,
        previousEntries: []
    };
}
function $d1907482eac6f531$var$createEmptyMap(heatmapWidth, heatmapHeight) {
    return Array.from({
        length: heatmapHeight
    }).map(()=>Array.from({
            length: heatmapWidth
        }).map($d1907482eac6f531$var$createEmptyHeatmapEntry));
}
function $d1907482eac6f531$var$isRectInside(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}
class $d1907482eac6f531$var$Heatmap {
    constructor({ viewport: viewport, heatmapSize: heatmapSize }){
        // TODO timeOrigin? do we need? for SSR??
        this.viewport = viewport;
        const safeSize = Math.min(heatmapSize, $d1907482eac6f531$var$MAX_HEATMAP_SIZE);
        if (viewport.width === 0 || viewport.height === 0) {
            this.width = safeSize;
            this.height = safeSize;
            this.scaleX = 1;
            this.scaleY = 1;
            this.heatmapAreaSize = 0;
            this.map = $d1907482eac6f531$var$createEmptyMap(safeSize, safeSize);
            return;
        }
        const aspectRatio = viewport.width / viewport.height;
        if (aspectRatio > 1) {
            // Landscape orientation
            this.width = safeSize;
            this.height = Math.round(safeSize / aspectRatio);
        } else {
            // Portrait orientation
            this.width = safeSize;
            this.height = Math.round(safeSize * aspectRatio);
        }
        this.scaleX = this.width / viewport.width;
        this.scaleY = this.height / viewport.height;
        this.heatmapAreaSize = this.width * this.height;
        this.map = $d1907482eac6f531$var$createEmptyMap(this.width, this.height);
    }
    getHeatmap() {
        return this.map;
    }
    getCell(row, col) {
        return this.map[row]?.[col];
    }
    /**
	 * Map Dom Rect to Heatmap Rect, rounded up to occupy full cell.
	 * @param rect DOM Rect
	 * @returns
	 */ mapDOMRectToHeatmap(rect) {
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        return {
            left: Math.floor(scaledX),
            right: Math.ceil(scaledX + scaledWidth),
            top: Math.floor(scaledY),
            bottom: Math.ceil(scaledY + scaledHeight)
        };
    }
    /**
	 * Calculate the ratio of a HeatmapRect compared to the full heatmap
	 *
	 * This function determines what fraction of the heatmap is covered by the given heatmap rectangle.
	 *
	 * @param rect
	 */ getRatio(rect) {
        if (this.viewport.width === 0 || this.viewport.height === 0) return 0;
        const { right: right, left: left, bottom: bottom, top: top } = rect;
        const rectWidth = right - left;
        const rectHeight = bottom - top;
        const rectArea = rectWidth * rectHeight;
        const ratio = rectArea / this.heatmapAreaSize;
        if (ratio > 1) return 1;
        return ratio;
    }
    async applyEntriesToHeatmap(entries) {
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const { time: time, type: type, data: data } = entry;
            if ((0, $aXT4C.default)(data)) {
                const rect = this.mapDOMRectToHeatmap(data.rect);
                const ratio = this.getRatio(rect);
                const heatmapEntryData = {
                    time: time,
                    elementName: data.elementName,
                    ratio: ratio ?? null,
                    rect: rect,
                    source: type
                };
                const roundedTop = Math.floor(rect.top);
                const roundedBottom = Math.min(rect.bottom, this.height);
                const roundedLeft = Math.floor(rect.left);
                const roundedRight = Math.min(rect.right, this.width);
                for(let row = roundedTop; row < roundedBottom; row++)for(let col = roundedLeft; col < roundedRight; col++){
                    const cell = this.getCell(row, col);
                    if (!cell) continue;
                    const previousEntry = cell.head;
                    // When elements are added at the same time
                    // we try to keep the inner element changes as the head
                    if (previousEntry?.time === entry.time && $d1907482eac6f531$var$isRectInside(previousEntry.rect, heatmapEntryData.rect)) {
                        cell.previousEntries.push({
                            ...heatmapEntryData,
                            source: 'mutation:parent-mounted'
                        });
                        continue;
                    }
                    cell.head = {
                        ...heatmapEntryData,
                        source: heatmapEntryData.source || null
                    };
                    if (previousEntry !== null) cell.previousEntries.push(previousEntry);
                }
            }
            // Every 100 events processed
            // we give the browser the power
            // to process any other high priority task
            if (i % 100 === 0) await (0, $ctFNJ.default)();
        }
    }
    async getVCPercentMetrics(vcPercentCheckpoint, startTime) {
        const sortedCheckpoints = [
            ...vcPercentCheckpoint
        ].sort((a, b)=>a - b);
        const flattenHeatmap = this.map.flat();
        const totalCells = flattenHeatmap.length;
        const timestampMap = new Map();
        for(let i = 0; i < flattenHeatmap.length; i++){
            const cell = flattenHeatmap[i];
            const cellHead = cell.head;
            const timestamp = Math.trunc(cellHead?.time ?? 0);
            const elementName = cellHead?.elementName;
            const curr = timestampMap.get(timestamp) ?? {
                cellCount: 0,
                domElements: new Set()
            };
            curr.cellCount += 1;
            if (elementName) curr.domElements.add(elementName);
            timestampMap.set(timestamp, curr);
            // Every 10000 heatmap entries processed
            // we give the browser the power
            // to process any other high priority task
            if (i > 10000 && i % 10000 === 0) await (0, $ctFNJ.default)();
        }
        const sortedTimings = [
            ...timestampMap.keys()
        ].sort((a, b)=>a - b);
        let totalCellPainted = 0;
        const result = {};
        let domElementsBuffer = new Set();
        for(let i = 0; i < sortedTimings.length; i++){
            const timestamp = sortedTimings[i];
            const timestampInfo = timestampMap.get(timestamp);
            if (!timestampInfo) throw new Error('unexpected timestampInfo not found');
            const { cellCount: cellCount, domElements: domElements } = timestampInfo;
            totalCellPainted += cellCount;
            const currVCRatio = totalCellPainted / totalCells;
            const currVCPercent = Math.round(currVCRatio * 100);
            domElements.forEach((domElement)=>{
                domElementsBuffer.add(domElement);
            });
            let matchesAnyCheckpoints = false;
            while(sortedCheckpoints.length > 0 && currVCPercent >= sortedCheckpoints[0]){
                const checkpoint = sortedCheckpoints.shift();
                const domElements = [
                    ...domElementsBuffer
                ];
                if (!checkpoint) break;
                matchesAnyCheckpoints = true;
                result[checkpoint.toString()] = {
                    t: Math.round(timestamp - startTime),
                    e: domElements
                };
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (i % 500 === 0) await (0, $ctFNJ.default)();
        }
        return result;
    }
}
async function $d1907482eac6f531$var$calculateTTVCPercentiles({ orderedEntries: orderedEntries, viewport: viewport, percentiles: percentiles, startTime: startTime }) {
    const heatmap = new $d1907482eac6f531$var$Heatmap({
        viewport: viewport,
        heatmapSize: 200
    });
    await heatmap.applyEntriesToHeatmap(orderedEntries);
    const vcDetails = await heatmap.getVCPercentMetrics(percentiles, startTime);
    return vcDetails;
}
var $d1907482eac6f531$export$2e2bcd8739ae039 = $d1907482eac6f531$var$calculateTTVCPercentiles;

});
parcelRegister("aXT4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3a0b9cd58731c0$export$2e2bcd8739ae039);
function $1a3a0b9cd58731c0$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $1a3a0b9cd58731c0$export$2e2bcd8739ae039 = $1a3a0b9cd58731c0$var$isViewportEntryData;

});


parcelRegister("aBSWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f28caeda438a786$export$2e2bcd8739ae039);

var $aXT4C = parcelRequire("aXT4C");

var $ctFNJ = parcelRequire("ctFNJ");

var $4SPdL = parcelRequire("4SPdL");
async function $4f28caeda438a786$var$calculateTTVCPercentiles({ orderedEntries: orderedEntries, viewport: viewport, percentiles: percentiles, startTime: startTime }) {
    const sortedPercentiles = [
        ...percentiles
    ].sort((a, b)=>a - b);
    const viewportArea = viewport.width * viewport.height;
    const checkpoints = {};
    let activeRects = orderedEntries.filter((e)=>(0, $aXT4C.default)(e.data)).map((e)=>e.data.rect);
    const removeActiveRect = (rectToRemove)=>{
        const index = activeRects.indexOf(rectToRemove);
        // Check if the element exists in the array
        if (index !== -1) // Remove the element at the found index
        activeRects.splice(index, 1);
    };
    let domElementsBuffer = new Set();
    for(let i = 0; i < orderedEntries.length; i++){
        const iEntry = orderedEntries[i];
        const iEntryData = iEntry.data;
        if (!(0, $aXT4C.default)(iEntryData)) continue;
        const { rect: rect, elementName: elementName } = iEntryData;
        domElementsBuffer.add(elementName);
        removeActiveRect(rect);
        const exclusionArea = (0, $4SPdL.default)(activeRects);
        const currentArea = viewportArea - exclusionArea;
        const currVCPercent = Math.round(currentArea / viewportArea * 100);
        let matchesAnyCheckpoints = false;
        while(sortedPercentiles.length > 0 && currVCPercent >= sortedPercentiles[0]){
            const checkpoint = sortedPercentiles.shift();
            const domElements = [
                ...domElementsBuffer
            ];
            if (!checkpoint) break;
            matchesAnyCheckpoints = true;
            checkpoints[checkpoint.toString()] = {
                t: Math.round(iEntry.time - startTime),
                e: domElements
            };
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (i % 500 === 0) await (0, $ctFNJ.default)();
    }
    return checkpoints;
}
var $4f28caeda438a786$export$2e2bcd8739ae039 = $4f28caeda438a786$var$calculateTTVCPercentiles;

});
parcelRegister("4SPdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $35172c167051c304$export$2e2bcd8739ae039);
/**
 * Calculate the union areas of all rectangles using Sweep Line Algorithm
 *
 * Reference:
 * 	https://en.wikipedia.org/wiki/Sweep_line_algorithm
 *  https://www.hackerearth.com/practice/math/geometry/line-sweep-technique/tutorial/#:~:text=A%20sweep%20line%20is%20an,order%20to%20discretize%20the%20sweep.
 *
 * @param rectangles
 * @returns
 */ function $35172c167051c304$var$calculateUnionArea(rectangles) {
    // Step 1: Create sweep line events
    const events = $35172c167051c304$var$createSweepLineEvents(rectangles);
    // Step 2: Process events to calculate total area
    const activeIntervals = new Map();
    let totalArea = 0;
    let previousX = 0;
    for (const event of events){
        // Calculate height at current x-position
        const currentHeight = $35172c167051c304$var$calculateActiveHeight(activeIntervals);
        // Add area since last x-position
        totalArea += currentHeight * (event.x - previousX);
        // Update x-position
        previousX = event.x;
        // Update active intervals
        $35172c167051c304$var$updateActiveIntervals(activeIntervals, event);
    }
    return totalArea;
}
var $35172c167051c304$export$2e2bcd8739ae039 = $35172c167051c304$var$calculateUnionArea;
function $35172c167051c304$var$createSweepLineEvents(rectangles) {
    const events = [];
    for (const rect of rectangles){
        // Create start and end events for each rectangle
        events.push({
            x: rect.left,
            type: 'start',
            top: rect.top,
            bottom: rect.bottom
        });
        events.push({
            x: rect.right,
            type: 'end',
            top: rect.top,
            bottom: rect.bottom
        });
    }
    // Sort events by x-coordinate (and type as tiebreaker)
    return events.sort((a, b)=>a.x === b.x ? a.type === 'end' ? 1 : -1 : a.x - b.x);
}
function $35172c167051c304$var$calculateActiveHeight(intervals) {
    if (intervals.size === 0) return 0;
    // Get all unique y-coordinates
    const coordinates = [];
    for (const [key] of intervals){
        const [start, end] = key.split(',').map(Number);
        coordinates.push(start, end);
    }
    // Sort coordinates
    const sortedCoords = [
        ...new Set(coordinates)
    ].sort((a, b)=>a - b);
    let totalHeight = 0;
    // Check each segment between consecutive coordinates
    for(let i = 0; i < sortedCoords.length; i++){
        const y1 = sortedCoords[i];
        const y2 = sortedCoords[i + 1];
        // Check if this segment is covered by any active interval
        let covered = false;
        for (const [key, count] of intervals){
            if (count <= 0) continue;
            const [start, end] = key.split(',').map(Number);
            if (start <= y1 && end >= y2) {
                covered = true;
                break;
            }
        }
        if (covered) totalHeight += y2 - y1;
    }
    return totalHeight;
}
function $35172c167051c304$var$updateActiveIntervals(intervals, event) {
    const key = `${event.top},${event.bottom}`;
    if (event.type === 'start') intervals.set(key, (intervals.get(key) || 0) + 1);
    else {
        const count = intervals.get(key) || 0;
        if (count > 1) intervals.set(key, count - 1);
        else intervals.delete(key);
    }
}

});



parcelRegister("6RK1A", function(module, exports) {

$parcel$export(module.exports, "default", () => $6076bc8255230f24$export$2e2bcd8739ae039);
function $6076bc8255230f24$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $6076bc8255230f24$export$2e2bcd8739ae039 = $6076bc8255230f24$var$getViewportHeight;

});

parcelRegister("dF9Lu", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f98cb8540d04a5$export$2e2bcd8739ae039);
function $50f98cb8540d04a5$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $50f98cb8540d04a5$export$2e2bcd8739ae039 = $50f98cb8540d04a5$var$getViewportWidth;

});



parcelRegister("1OMZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $924a5faf49f93f96$export$2e2bcd8739ae039);

var $1HYUt = parcelRequire("1HYUt");

var $eliYW = parcelRequire("eliYW");

var $aS5cI = parcelRequire("aS5cI");

var $4b2DW = parcelRequire("4b2DW");

var $aq5g1 = parcelRequire("aq5g1");
function $924a5faf49f93f96$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $924a5faf49f93f96$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $924a5faf49f93f96$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
const $924a5faf49f93f96$var$createElementMutationsWatcher = (removedNodeRects)=>({ rect: rect })=>{
        const wasDeleted = removedNodeRects.some((nr)=>$924a5faf49f93f96$var$sameRectDimensions(nr, rect));
        if (wasDeleted) return 'mutation:element-replacement';
        return 'mutation:element';
    };
class $924a5faf49f93f96$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = $924a5faf49f93f96$var$isElementVisible(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = ({ addedNodes: addedNodes, removedNodes: removedNodes })=>{
            const removedNodeRects = removedNodes.map((n)=>this.mapVisibleNodeRects.get(n));
            addedNodes.forEach((addedNode)=>{
                const sameDeletedNode = removedNodes.find((n)=>n.isEqualNode(addedNode));
                if (sameDeletedNode) {
                    this.intersectionObserver?.watchAndTag(addedNode, 'mutation:remount');
                    return;
                }
                if ((0, $1HYUt.isContainedWithinMediaWrapper)(addedNode)) {
                    this.intersectionObserver?.watchAndTag(addedNode, 'mutation:media');
                    return;
                }
                this.intersectionObserver?.watchAndTag(addedNode, $924a5faf49f93f96$var$createElementMutationsWatcher(removedNodeRects));
            });
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $1HYUt.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName
                    }
                };
                if ((0, $eliYW.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && $924a5faf49f93f96$var$sameRectSize(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) this.onChange({
                    time: time,
                    elementRef: new WeakRef(target),
                    visible: true,
                    rect: changedRect.rect,
                    previousRect: changedRect.previousRect,
                    type: 'layout-shift'
                });
            }
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $aS5cI.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $4b2DW.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $aq5g1.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore-error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
    }
}

});
parcelRegister("aS5cI", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", () => $aed46d2ac193da35$export$c3799d33e0ae80a5);
function $aed46d2ac193da35$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $aed46d2ac193da35$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$aed46d2ac193da35$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("4b2DW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b967497fd95af45c$export$2e2bcd8739ae039);
function $b967497fd95af45c$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const addedNodes = [];
        const removedNodes = [];
        const targets = [];
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if (mut.type === 'attributes') {
                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown'
                });
                continue;
            } else if (mut.type === 'childList') {
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) addedNodes.push(node);
                });
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) removedNodes.push(node);
                });
            }
            targets.push(mut.target);
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $b967497fd95af45c$export$2e2bcd8739ae039 = $b967497fd95af45c$var$createMutationObserver;

});

parcelRegister("aq5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f4470e0f19f214$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $a0f4470e0f19f214$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $a0f4470e0f19f214$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $a0f4470e0f19f214$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $a0f4470e0f19f214$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $a0f4470e0f19f214$export$2e2bcd8739ae039 = $a0f4470e0f19f214$var$createPerformanceObserver;

});


parcelRegister("ePAog", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e5589b99c2bea9$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");
class $91e5589b99c2bea9$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $cBeZP.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("45w2S", function(module, exports) {

$parcel$export(module.exports, "interactions", () => $689164667c3e99b9$export$cc97b17ef9aeb088);
const $689164667c3e99b9$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("bJCAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ef004db30d88d6$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $fe1wc = parcelRequire("fe1wc");

var $a0hd6 = parcelRequire("a0hd6");

var $h2sI1 = parcelRequire("h2sI1");
const $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $34ef004db30d88d6$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        if ((0, $VSDnB.fg)('platform_ufo_vc_align_revisions_on_watchdog_event')) this.vcObserver = new (0, $a0hd6.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
        else if (this.vcObserver === null) this.vcObserver = new (0, $h2sI1.VCObserver)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
	 * Reset state of the log
	 */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
	 * Check if there is data in the log
	 */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
	 * Send the log if there is data
	 */ async sendPostInteractionLog() {
        if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
            return;
        }
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            ...this.vcObserverSSRConfig,
            experienceKey: this.lastInteractionFinish.ufoName
        });
        if ((0, $fe1wc.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
            postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
        });
        this.reset();
    }
    /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = (0, $fe1wc.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    constructor(){
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = ()=>{};
    }
}

});





parcelRegister("jyCEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c5e2e6b0d512a0$export$2e2bcd8739ae039);
const $c1c5e2e6b0d512a0$var$throttleLogs = (limit)=>{
    const queue = [];
    let activeCount = 0;
    const next = ()=>{
        if (queue.length > 0 && activeCount < limit) {
            const fn = queue.shift();
            if (fn) {
                activeCount++;
                fn().finally(()=>{
                    activeCount--;
                    next();
                });
            }
        }
    };
    const add = (fn)=>{
        queue.push(fn);
        next();
    };
    const flush = async ()=>{
        const promises = [];
        while(queue.length > 0){
            const fn = queue.shift();
            if (fn) promises.push(fn());
        }
        await Promise.all(promises);
    };
    return {
        add: add,
        flush: flush
    };
};
var $c1c5e2e6b0d512a0$export$2e2bcd8739ae039 = $c1c5e2e6b0d512a0$var$throttleLogs;

});

parcelRegister("5pmnS", function(module, exports) {

$parcel$export(module.exports, "polyfilledSchedulerPostTask", () => $fd29493838695eb1$export$76fe6fc7f54a2fa6);
const $fd29493838695eb1$export$76fe6fc7f54a2fa6 = (callback, priority)=>{
    if ('scheduler' in globalThis) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const retVal = globalThis.scheduler.postTask(callback, {
            priority: priority
        });
        return retVal;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(callback());
        });
    });
};

});




parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("ajjqZ", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $383b599fde987e1e$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $383b599fde987e1e$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $383b599fde987e1e$export$e1336d32be02faf4);
$parcel$export(module.exports, "earlyFetch", () => $383b599fde987e1e$export$5b55058781674413);

var $tcn7E = parcelRequire("tcn7E");

var $l83Uu = parcelRequire("l83Uu");

var $eKonk = parcelRequire("eKonk");

var $eCZ6m = parcelRequire("eCZ6m");
const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
    const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
    if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
    return result;
};
const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
};
const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $l83Uu.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $eCZ6m.getAggEndpoint)(compiledQuery.params);
    const body = (0, $eCZ6m.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability ?? null);
    $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $l83Uu.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("l83Uu", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $ef655a7b07a35675$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ef655a7b07a35675$export$e88cb5bfb57ce9c4);

var $dO0aE = parcelRequire("dO0aE");
const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);

});
parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});


parcelRegister("eCZ6m", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $3d812b79ec4c2140$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $3d812b79ec4c2140$export$55bce18df99af758);

var $6cAn5 = parcelRequire("6cAn5");
const $3d812b79ec4c2140$var$branchSlug = typeof $6cAn5 !== 'undefined' && $6cAn5.env ? undefined : undefined;
const $3d812b79ec4c2140$var$aggPathname = `/gateway/api/graphql${$3d812b79ec4c2140$var$branchSlug ? `/${$3d812b79ec4c2140$var$branchSlug}/graphql` : ''}`;
const $3d812b79ec4c2140$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $3d812b79ec4c2140$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $3d812b79ec4c2140$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});


parcelRegister("2kcwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace457987dc8eaf8$export$2e2bcd8739ae039);
/* eslint-disable prefer-object-spread */ 
var $tcn7E = parcelRequire("tcn7E");


var $eKonk = parcelRequire("eKonk");
const $ace457987dc8eaf8$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
// @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type.
const $ace457987dc8eaf8$var$addObservabilityHeaders = (options)=>Object.assign({}, options, {
        headers: Object.assign({}, options.headers, {
            [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$ef94a84e2990361c)),
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(options.url)
        })
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ace457987dc8eaf8$export$2e2bcd8739ae039 = (url, options = {})=>{
    const mergedOptions = Object.assign({}, $ace457987dc8eaf8$var$defaultOptions, options);
    const requestOptions = $ace457987dc8eaf8$var$addObservabilityHeaders(mergedOptions);
    return fetch(url, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        throw new Error(`Fetch call failed with status code: ${response.status}`);
    });
};

});

parcelRegister("i5Y40", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce77446897a6ae9$export$2e2bcd8739ae039);

var $3X3hu = parcelRequire("3X3hu");
/**
 * Scrapes the JSON payload from the initial page response within as HTML comment by bifrost template.
 *
 * @param queryId - The query ID to scrape the JSON payload for. Only supports 'earlyFetchMainIssueAggQuery' or 'earlyFetchIssueViewInteractiveQuery'.
 * The values are accessible via IssueViewFetchOperations.EARLY_FETCH_GIRA or IssueViewFetchOperations.EARLY_FETCH_AGG.
 * @returns Promise of JSON payload scraped from HTML comment.
 */ const $9ce77446897a6ae9$var$scrapeJsonFromInitialPageResponse = (queryId)=>{
    if (!queryId) return Promise.reject();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const checkForEl = ()=>document.getElementById(`shifted-${queryId}`);
    const DIDNT_ARRIVE = new Error(`element with ID "shifted-${queryId}" did not arrive`);
    return new Promise((resolve, reject)=>{
        const tryResolve = (el)=>{
            try {
                let payloadEl = el?.previousSibling;
                // account for server sending whitespace before the comment
                if (payloadEl && payloadEl.nodeType === Node.TEXT_NODE) payloadEl = payloadEl.previousSibling;
                // payload should be sent in a comment node
                if (!payloadEl || payloadEl.nodeType !== Node.COMMENT_NODE) throw new Error(`shifted ${queryId}: expected comment node before shifted element`);
                // the comment node should have non-empty text content
                if (!payloadEl.textContent) throw new Error(`shifted ${queryId}: expected comment node to have text content`);
                // parse the content as json, expect an object in response
                // JIV-19357: Unescape angle brackets that was escaped from SSR to avoid HTML comment breakages.
                let result;
                try {
                    result = JSON.parse((0, $3X3hu.default)(payloadEl.textContent));
                } catch (e) {
                    throw new Error(`shifted ${queryId}: expected comment node to have text parsable to JSON`);
                }
                // bail if the server didn't send an object as JSON
                // add null check since apparently 'null' is JSON parsable and typeof null is object
                if (typeof result !== 'object' || result === null) throw new Error(`shifted ${queryId}: expected JSON payload to be a non-null object`);
                // bail if the server reported any problems
                if (result.ssrError) throw new Error(result.ssrError);
                // bail JSON payload does not have data
                if (!result.data) throw new Error(`shifted ${queryId}: expected JSON payload to have data`);
                resolve(result);
            } catch (e) {
                reject(e);
            }
        };
        // check for the element immediately.
        {
            const el = checkForEl();
            if (el) {
                tryResolve(el);
                return;
            }
        }
        // if the document is ready, the element either exists or didn't arrive.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.readyState === 'interactive' || document.readyState === 'complete') {
            reject(DIDNT_ARRIVE);
            return;
        }
        // wait for the element to arrive.
        const onNewElements = (_, observer)=>{
            // I could be "optimal" by iterating through the elements indicated in the mutation record array...
            // ...but it's probably just faster to ask the DOM whether the element exists by ID now.
            const el = checkForEl();
            if (el) {
                observer.disconnect();
                tryResolve(el);
            }
        };
        // use a mutation observer until the document is ready.
        // only observe direct children of the document body.
        const observer = new MutationObserver(onNewElements);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        observer.observe(document.body, {
            attributes: false,
            childList: true,
            subtree: false
        });
        // only keep trying until DOM ready, then give up.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('DOMContentLoaded', ()=>{
            setTimeout(()=>{
                observer.disconnect();
                const el = checkForEl();
                el ? tryResolve(el) : reject(DIDNT_ARRIVE);
            }, 0);
        }, {
            once: true
        });
    });
};
var $9ce77446897a6ae9$export$2e2bcd8739ae039 = $9ce77446897a6ae9$var$scrapeJsonFromInitialPageResponse;

});
parcelRegister("3X3hu", function(module, exports) {

$parcel$export(module.exports, "default", () => $92309e5605938745$export$2e2bcd8739ae039);
// JIV-19357: For the current use case, we just want to escape angle brackets to avoid HTML comment breakages.
// This should match the inverse of jira/src/entry-fs/utils/early-graphql-fetch-utils/escape-html.tsx
const $92309e5605938745$var$REGEX_HTML_UNESCAPE = /&lt;|&gt;/g;
const $92309e5605938745$var$UNESCAPE_HTML_MAP = {
    '&lt;': '<',
    '&gt;': '>'
};
const $92309e5605938745$var$unescapeHTML = (str)=>str.replace($92309e5605938745$var$REGEX_HTML_UNESCAPE, (token)=>$92309e5605938745$var$UNESCAPE_HTML_MAP[token]);
var $92309e5605938745$export$2e2bcd8739ae039 = $92309e5605938745$var$unescapeHTML;

});



parcelRegister("fV0e4", function(module, exports) {

$parcel$export(module.exports, "fetchIssueGiraData", () => $ef94d0e2f71471e7$export$4da9918e444ba421);
$parcel$export(module.exports, "getGiraDataFromInitialPageResponse", () => $ef94d0e2f71471e7$export$790cf3715a0b5247);

var $fqpdr = parcelRequire("fqpdr");

var $eDXka = parcelRequire("eDXka");

var $2kcwv = parcelRequire("2kcwv");

var $i5Y40 = parcelRequire("i5Y40");
const $ef94d0e2f71471e7$export$4da9918e444ba421 = (baseUrl, issueKey, projectKey)=>(0, $2kcwv.default)((0, $fqpdr.getGiraUrl)(baseUrl, (0, $eDXka.IssueViewFetchOperations).EARLY_FETCH_GIRA), (0, $fqpdr.getGiraRequestOptions)(issueKey, projectKey));
const $ef94d0e2f71471e7$export$790cf3715a0b5247 = ()=>(0, $i5Y40.default)((0, $eDXka.IssueViewFetchOperations).EARLY_FETCH_GIRA);

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};

});

parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});
parcelRegister("e5wyW", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $12199147dc0ae1fa$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});


parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});



parcelRegister("bYZwm", function(module, exports) {

$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $aca3971e7356c899$export$58a9221a6c5306db);

var $fqpdr = parcelRequire("fqpdr");

var $c6dax = parcelRequire("c6dax");

var $eDXka = parcelRequire("eDXka");

var $2kcwv = parcelRequire("2kcwv");
const $aca3971e7356c899$export$58a9221a6c5306db = (issueKey)=>(0, $2kcwv.default)((0, $fqpdr.getGiraUrl)('', (0, $eDXka.IssueViewFetchOperations).EARLY_FETCH_NON_CRITICAL_GIRA), (0, $c6dax.getNonCriticalGiraQueryRequestOptions)(issueKey));

});
parcelRegister("c6dax", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $b74efd74d6a135cc$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $b74efd74d6a135cc$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $b74efd74d6a135cc$export$555194bfc9159fa3);

var $jzVvW = parcelRequire("jzVvW");
const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $jzVvW.getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
            query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("jzVvW", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $8b485783ca3ced28$export$edefef8c65e08bd2);
const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;

});





parcelRequire("8HVLq");


//# sourceMappingURL=issue-app-early-entry.634beb09.js.map
